var site = site || {};

site.addToCart = function(args) {
  var skuBaseId;
  if (args.skuData && args.skuData.SKU_BASE_ID) {
    skuBaseId = args.skuData.SKU_BASE_ID;
  } else if (args.skuBaseId) {
    skuBaseId = args.skuBaseId;
  } else {
    return null;
  }

  var quantity;
  if (args.quantity) {
    quantity = args.quantity;
  } else {
    quantity = 1;
  }

 // Support Replenishment
  var replAmount;
  if (args.replAmount && args.replAmount != 0 || args.REPLENISHMENT_FREQ) {
    replAmount = args.replAmount;
    args.action       = 'add';
    args.itemType     = 'replenishment';
    args.add_to_cart  = 1;
  } else {
    replAmount = 0;
  }

  var catBaseId = '';
  if (args.skuData && args.skuData.PARENT_CAT_ID) {
    var matchResult = args.skuData.PARENT_CAT_ID.match("[0-9]+");
    if (matchResult) {
      cat_base_id = matchResult[0];
    }
  }

  args.skus = args.skus || [skuBaseId];
  args.itemType = args.itemType || 'cart';
  args.INCREMENT = 1;
  args.CAT_BASE_ID = args.CAT_BASE_ID || catBaseId;
  args.QTY = args.QTY || quantity;
  args.REPLENISHMENT_FREQ = args.REPLENISHMENT_FREQ || replAmount;

  generic.checkout.cart.updateCart({
    params: args,
    onSuccess: function(r) {
      var resultObj = r.getCartResults();
      var msgs = r.getMessages();
      if (msgs){
          $(msgs).each(function(){
            if($(this)[0].key === 'offer_criteria_not_met' && $(this)[0].tags[2] === 'one_time_purchase'){
                generic.overlay.launch({
                    content: $(this)[0].text,
                    includeBackground: true,
                    cssClass: "add_cart_response",
                    cssStyle: {
                        width: '400px',
                        height:'auto',
                        padding: '25px'
                    }
                });
                $('.cart-confirm').addClass("one_time_hide");
            }
         });
      } else if ($(".cart-confirm").hasClass("one_time_hide"))
        {
            $('.cart-confirm').removeClass("one_time_hide");
        }
      // // Report product view based on either loctmpl attribute (if it exists) or last QV location.
      // // Call with URL_CLICK 0 to unset location override. We only neeed it for for add to cart.
      // // This seems kind of horrible to me.
      // if ( typeof Analytics =='object' ){
      //     var locType = $(thisButton).attr("loctmpl");
      //     var params = {};
      //     if (locType) {
      //         location_params = locType.split(",");
      //         params['TYPE_LOCATION'] = location_params[0];
      //         params['PRODUCT_KEY'] = location_params[1];
      //         params['URL_CLICK'] = 0;
      //         Analytics.reportProductView(params);
      //     }
      // }
      $(document).trigger("addToCart.success", [resultObj]);
    },
    onFailure: function(ss) {
      var errorObjectsArray = ss.getMessages();
        $(document).trigger("addToCart.failure", [errorObjectsArray]);
        // // Escape any html in the alert box.
        prodAddedMsg = $('<div/>').html(errorObjectsArray[0].text).text();
        // TODO replace alert message with something nicer
        //alert(prodAddedMsg);
        generic.overlay.launch({
            content: errorObjectsArray[0].text,
            includeBackground: true,
            cssClass: "add_cart_response",
            cssStyle: {
               width: '300px',
               height:'auto',
               padding:'25px'
            }
        });
        var resultObj = ss.getCartResults();
        $(document).trigger("addToCart.success", [resultObj]);
      }
  });
};


site.productData = {
  isActive: function(skuData) {
    return skuData.INVENTORY_STATUS && skuData.INVENTORY_STATUS == 1;
  },
  isTempOutOfStock: function(skuData) {
    return skuData.INVENTORY_STATUS && skuData.INVENTORY_STATUS == 2;
  },
  isComingSoon: function(skuData) {
    return skuData.INVENTORY_STATUS && skuData.INVENTORY_STATUS == 3;
  },
  isInactive: function(skuData) {
    return skuData.INVENTORY_STATUS && skuData.INVENTORY_STATUS == 5;
  },
  isSoldOut: function(skuData) {
    return skuData.INVENTORY_STATUS && skuData.INVENTORY_STATUS == 7;
  },
  isShoppable: function(skuData) {
    return site.productData.isActive(skuData) ||  site.productData.isTempOutOfStock(skuData);
  }
};

site.addToFavorites = function(args) {

  var params = {
    "_SUBMIT": "alter_collection",
    "action": "add"
  };

  var skuBaseId;
  if (args.skuData && args.skuData.SKU_BASE_ID) {
    skuBaseId = args.skuData.SKU_BASE_ID;
  } else if (args.skuBaseId) {
    skuBaseId = args.skuBaseId;
  } else {
    return null;
  }
  params.SKU_BASE_ID = skuBaseId;

  var catBaseId = '';
  if (args.skuData && args.skuData.PARENT_CAT_ID) {
    var matchResult = args.skuData.PARENT_CAT_ID.match("[0-9]+");
    if (matchResult) {
      params.CAT_BASE_ID = matchResult[0];
    }
  }

  if ($.cookie('csrftoken')) {
    params._TOKEN = $.cookie('csrftoken');
  }

  var id = generic.jsonrpc.fetch({
    method : 'rpc.form',
    params: [params],
    onSuccess:function(jsonRpcResponse) {
      var d = jsonRpcResponse.getData();
      var r = d.ac_results[0].result;

      if (r.KEY == 'SKU_ALREADY_IN_COLLECTION.ADD_SKU.COLLECTION.SAVE') {
        $(document).trigger("addToWishlist.exists", [r]);
      } else if (r.SUCCESS == 1 || r.KEY == 'SUCCESS.ADD_SKU.COLLECTION.SAVE') {
        var cr = jsonRpcResponse.getCartResults();
        $(document).trigger("addToWishlist.success", [cr]);
      }
    },
    onFailure: function(jsonRpcResponse) {
      console.log("add to favorites failure");
      console.log(jsonRpcResponse.getError());
    }
  });
};

/*
 * DEPRECATED - Use createAddButton instead
 */
site.addButton = function(args) {
  var p = args.productData;
  var $addButton = $(".js-add-to-cart[data-product-id=" + p.PRODUCT_ID + "]");
  var $notifyMe = $('.js-notify-me[data-product-id=' + p.PRODUCT_ID + ']');

  $addButton.bind("click", function(clickEvt) {
    var skuBaseId = $(this).attr("data-sku-base-id");
    var quantity = $(this).attr("data-qty");
    site.addToCart({skuBaseId: skuBaseId, quantity : quantity}  );
  });
  var selectSku = function(skuBaseId) {
    $addButton.attr("data-sku-base-id", skuBaseId);
    $notifyMe.attr('data-sku-base-id', skuBaseId);
    updateInvStatus();
  }
  var updateInvStatus = function() {
    var currentSkuId = "SKU" + $addButton.attr("data-sku-base-id");
    var skuDataL2 = $(document).data(currentSkuId);
    if (skuDataL2 && !skuDataL2.isShoppable) {
      $addButton.hide();
    } else {
      $addButton.show();
    }
  }

  selectSku(p.skus[0]["SKU_BASE_ID"]);

  $(document).on('sku:select', function(e, skuData) {
    if (skuData.PRODUCT_ID == p.PRODUCT_ID) {
      selectSku(skuData.SKU_BASE_ID);
    }
  });
  $(document).bind('inventory_status_stored', function(e, skuData) {
    updateInvStatus();
  });
  var selectQuantity = function(quantity) {
    $addButton.attr("data-qty", quantity);
  }
  $(document).bind('qty:select', function(e, quantity) {
    selectQuantity(quantity);
  });
  var selectReplAmount = function(replAmount) {
    $addButton.attr("data-replenishment", replAmount);
  }
  $(document).bind('repl:select', function(e, replAmount) {
    selectReplAmount(replAmount);
  });
};

site.addFavoritesButton = function($favButton) {
  var that = {};
  that.$favButton = $favButton;

  $favButton.bind("click", function(clickEvt) {
    clickEvt.preventDefault();
    var skuBaseId = $(this).attr("data-sku-base-id");
    site.addToFavorites({skuBaseId: skuBaseId});
  });
  var selectSku = function(skuBaseId) {
    $favButton.attr("data-sku-base-id", skuBaseId);
  };
  $favButton.bind('sku:select', function(e, skuData) {
    selectSku(skuData.SKU_BASE_ID);
    e.stopPropagation();
  });
};

site.qtySelectMenu = function($selectNode) {
  var that = {
    $selectNode: $selectNode
  };
  that.$selectNode.on("change", function(event) {
    var productId = that.$selectNode.attr("data-product-id");
    var quantity = that.$selectNode.val();
    site.qtySelect(productId, quantity);
  });
  return that;
};

//
// site.sizeSelectMenu = function($selectNode) {
//   var that = {
//     $selectNode: $selectNode,
//   };
//   that.$selectNode.on("change", function(event) {
//     var selectedSku = $that.selectNode.find('option:selected').attr('data-sku-base-id');
//       var skuData = _.find(that.productData.skus, function(sku){ return sku.SKU_BASE_ID== selectedSku; });
//       site.skuSelect(skuData);
//     });
//     var productId = that.$selectNode.attr("data-product-id");
//     var quantity = that.$selectNode.val();
//     site.qtySelect(productId, quantity);
//   });
//   return that;
// };


site.createAddButton = function($addButton) {
  var that = {};
  that.$addButton = $addButton;
  that.productId = that.$addButton.attr("data-product-id");
  that.replAmount = that.$addButton.attr("data-replenishment");
  that.$quantity = $('.js-quantity').filter("[data-product-id=" + that.productId +  "]");
  that.$notifyMe = $('.js-notify-me').filter('[data-product-id=' + that.productId + ']');
  that.$basicReorder = $('.js-basic-reorder').filter('[data-product-id=' + that.productId + ']');
  that.$soldOutStatus = $('.js-inv-status-list').filter('[data-product-id=' + that.productId + ']');
  that.$replContainer = $('.product-replenishment-select');
  //For new MPP template
  if($('.extended-mpp').length > 0) {
    that.$quantity = $('.js-quantity', that.$addButton.parents("li")).filter("[data-product-id=" + that.productId +  "]");
  }

  // click handler
  that.$addButton.on('click', function(e) {
    e.preventDefault();
    var skuBaseId = $(this).attr("data-sku-base-id");
    if (!skuBaseId || skuBaseId.length<1) return null;
    var args = {skuBaseId: skuBaseId};
    // quantity
    var quantity = $(this).attr("data-qty");
    if (!!quantity) {
      args.quantity = quantity;
    }
    // replenishment
    var replAmount = parseInt($(this).attr("data-replenishment"));
    if (!!replAmount) {
      args.replAmount = replAmount;
    }

    site.addToCart(args);
  });

  // SKU change handler
  var selectSku = function(skuBaseId) {
    that.$addButton.attr("data-sku-base-id", skuBaseId);
    that.$notifyMe.attr('data-sku-base-id', skuBaseId);
    // fix for IE 9 issue with statement above
    if ($('body').hasClass('ie-9')) {
      $('.product-full__add-button').attr('data-sku-base-id', skuBaseId);
    }
    that.updateInvStatus();
  };

  that.$addButton.on('sku:select', function(e, skuData) {
    if (skuData.PRODUCT_ID == that.productId) {
      selectSku(skuData.SKU_BASE_ID);
      that.updateInvStatus();
    }
    e.stopPropagation();
  });

  // Inventory Status change handler
  that.updateInvStatus = function() {
    var currentSkuId = "SKU" + that.$addButton.attr("data-sku-base-id");
    var skuDataL2 = $(document).data(currentSkuId);
    var isRefillable = false;

    // Helper function to search through page_data for product and sku data based on a single sku
    var _searchCatalog = function(searchSku) {
      var catalog = {};
      var products = [];
      var filteredSku = false;

      for (var key in page_data) {
        if (!page_data.hasOwnProperty(key)) {
          continue;
        }

        catalog = page_data[key] || {};
        products = catalog.hasOwnProperty('products') ? catalog.products : [];

        for (var i = 0, j = products.length; i < j; i++) {
          filteredSku = false;

          if (!!products[i].skus) {
            filteredSku = _.find(products[i].skus, function(s) {
              return s.SKU_ID == searchSku;
            });
          }

          if (!!filteredSku) {
            return {
              product : products[i],
              sku     : filteredSku
            };
          }
        }
      }

      return {
        product : {},
        sku     : {}
      };
    };

    // Only on SPP pages check refillable status
    if ($(document.body).hasClass('page-product') && typeof page_data !== 'undefined') {
      var data = _searchCatalog(currentSkuId);
      isRefillable = data.sku.REFILLABLE || false;
    }

    if (skuDataL2 && !skuDataL2.isShoppable) {
      that.$addButton.hide();
      that.$quantity.hide();
      that.$notifyMe.hide();
      that.$basicReorder.hide();
      if(skuDataL2.isPreOrder && skuDataL2.INVENTORY_STATUS == 2){
        that.$addButton.show();
        that.$quantity.show();
      }
      // Enable notify me button, if sku is soldout and basic re-order
      if (skuDataL2.INVENTORY_STATUS === 7 && skuDataL2.LIFE_OF_PRODUCT === 2) {
        that.$notifyMe.show();
        that.$basicReorder.show();
      }
    } else {
      that.$addButton.show();
      that.$quantity.show();
      that.$notifyMe.hide();
      that.$basicReorder.hide();
    }

    // show select if sku if it is refillable
    if( !_.isUndefined(skuDataL2) ){
      if (isRefillable && that.$replContainer.length > 0) {
        that.$replContainer.show();
      } else {
        that.$replContainer.hide();
      }
    }else{
      console.log('no sku data');
    }

    // Hide ReplContainer & InventoryContainer if sku is soldout and basic re-order
    if (!_.isUndefined(skuDataL2)) {
      if (skuDataL2.INVENTORY_STATUS === 7 && skuDataL2.LIFE_OF_PRODUCT === 2 && that.$notifyMe.length > 0) {
        that.$replContainer.hide();
        that.$soldOutStatus.hide();
      } else {
        that.$soldOutStatus.show();
      }
    }
    //Show Estimated delivery date in SPP
    if (skuDataL2 && site.EDD && site.EDD.showEstimatedDeliveryDate) {
      site.EDD.showEstimatedDeliveryDate({
        isShoppable: skuDataL2.isShoppable && !(skuDataL2.INVENTORY_STATUS && skuDataL2.INVENTORY_STATUS == 2)
      });
    }
    if (skuDataL2 && site.EDD && site.EDD.whenWillMyOrderArrive) {
      site.EDD.whenWillMyOrderArrive({
        isShoppable: skuDataL2.isShoppable && !(skuDataL2.INVENTORY_STATUS && skuDataL2.INVENTORY_STATUS == 2)
      });
    }
  };

  that.$addButton.on('inventory_status_stored', function(e, skuData) {
    that.updateInvStatus();
    e.stopPropagation();
  });

  // Quantity change handler
  var selectQuantity = function(quantity) {
    that.$addButton.attr("data-qty", quantity);
  };
  that.$addButton.on('qty:select', function(e, quantity) {
    selectQuantity(quantity);
    e.stopPropagation();

  });

  // replenishment change handler
  var selectReplAmount = function(replAmount) {
    that.$addButton.attr("data-replenishment", replAmount);
  };
  that.$addButton.on('repl:select', function(e, replAmount) {
    selectReplAmount(replAmount);
    e.stopPropagation();
   });

  return that;
};

// Replenishment
site.replSelect = function(prodId, replAmount) {
  var prodSlctr = "[data-product-id='" + prodId + "']";
  $(prodSlctr).trigger('repl:select', replAmount);
};

site.skuSelect = function(skuData) {
  if (!skuData) return;
  var prodId = skuData.PRODUCT_ID;
  var prodSlctr = "[data-product-id='" + prodId + "']";
  $(prodSlctr).trigger('sku:select', skuData);
};

site.qtySelect = function(prodId, qty) {
  var prodSlctr = "[data-product-id='" + prodId + "']";
  $(prodSlctr).trigger('qty:select', qty);
};


(function($) {
  Drupal.behaviors.ELB_addToCartButton = {
    attach: function(context, settings) {
      $('.js-add-to-cart').each( function() {
        var btn = site.createAddButton($(this));
      });
    }
  };
  Drupal.behaviors.ELB_addToFavorites = {
    attach: function(context, settings) {
      $('.js-add-to-favorites-btn').each( function() {
		    site.addFavoritesButton($(this));
      });
    }
  };
})(jQuery);

var site = site || {};
site.panels = site.panels || {};

(function($) {
  Drupal.behaviors.ELB_addToEngraving = {
    attach: function(context, settings) {
      site.addEngravingButton(context);
      site.deleteEngravingButton(context);
    }
  };
})(jQuery);

site.deleteEngravingButton = function(context) {
  $('.js-delete-to-engraving', context).once('delete-engraving').on('click', function(e) {
    e.preventDefault();
    var form = $(this).parents('form.viewcart-engraving__engraving--form');
    // retrieve form data
    var params = form.engravingJSON();
    //error messages
    var error_node = form.find('ul.error_messages');
    $(this).closest('.js-engraving-view').children('.js-engraving-loading').removeClass('hidden');
    generic.jsonrpc.fetch({
      method : 'form.rpc',
      params: [params],
      onBoth: function(r) {
        var resultObj = r.getCartResults();
        var messages = r.getMessages();
        //Filter messages to remove SUCCESS messages
        if (messages) {
          messages = $.grep(messages, function(e) {
            return $.inArray('SUCCESS', e.tags) === -1 && $.inArray('alter_monogram', e.tags) > 0;
          });
        }
        //Filter messages to remove SUCCESS messages
        //If we have error messages aftr stripping SUCCESS tags then show them otherwise we're successful
        if (messages && messages.length) {
          generic.showErrors(messages, error_node, form);
        } else {
          var resultData = r.getData();
          site.panels.reloadPanels({noAnchor: true, noAnchorAndMsg: true});
          generic.overlay.hide();
        }
      }
    });
  });
};

site.addEngravingButton = function(context) {
  site.engraveButtons();
  var $addToEngraving = $('.js-add-to-engraving', context);
  var selectSku = function(skuBaseId) {
    $addToEngraving.attr("data-sku-base-id", skuBaseId);
    $addToEngraving.addClass('hidden');
  };
  $addToEngraving.on('sku:select', function(e, skuData) {
    if (skuData.ENGRAVABLE) {
      selectSku(skuData.SKU_BASE_ID);
      $addToEngraving.removeClass('hidden');
      e.stopPropagation();
    } else {
      selectSku(skuData.SKU_BASE_ID);
      e.stopPropagation();
    }
  });
};

site.engraveButtons = function(context){
  var $addToEngraving = $('.js-add-to-engraving', context);
  $addToEngraving.once('add-to-engraving').on('click', function(e) {
    e.preventDefault();
    var $ele = $(this);
    var $body = $('body', context);
    var dataSkubaseId = $ele.attr('data-sku-base-id');
    var dataCartId = $ele.attr('data-cart-id');
    var queryCardId = dataCartId ? '&CART_ID='+dataCartId : '';
    site.isAerin = $body.hasClass('brand-aerin');
    var aerinQuery = (site.isAerin || $ele.closest('.monogram-product').length > 0) ? '&is_aerin=1' : '';
    var query = '?SKU_BASE_ID=' + dataSkubaseId + queryCardId + aerinQuery;
    var engravingType = $ele.attr('data-engraving-type');
    var engravingFont = 'popup'+$ele.attr('data-monogram-font');
    var engravingClass = (parseInt(engravingType) === 1) ? ' brand-aerin ' : ' ';
    $ele.closest('.js-engraving-view').children('.js-engraving-loading').removeClass('hidden');
    generic.template.get({
      path:'/templates/engraving-qvform.tmpl'+query,
      forceReload: true,
      callback: function(html) {
        generic.overlay.launch({
          content: html,
          cssClass: 'engraving-preview-popup js-engraving-preview-popup'+engravingClass+engravingFont,
          cssStyle: {
            width: '725px',
            height: '518px'
          },
          center: true,
          lockPosition: false,
          includeBackground: true,
          backgroundNodeClickHide: true,
          onComplete : function() {
            site.engravingInit();
            //Retain values of font in overlay
            var $engravingChoices = $('.js-font-choice-button', context);
            var $engravingFrChoice = $('.js-fr-font', context);
            var $engravingFr = $('.js-engraving-fr', context);

            if (site.isAerin) {
              $('a.change-font').removeClass('engrave-style-chosen');
              $('.monogram-choice-lower').eq(0).trigger('click');
            }
            if ($body.is('#viewcart')) {
              var engravingFontChoice = $('.js-font-choice-button'),
                engravingPreviewPopup = $('.engraving-preview-popup'),
                selectButtonClass = engravingPreviewPopup.attr("class").split(" ").pop();
              engravingFontChoice.find("." +selectButtonClass).trigger("click");
              $('.engraving-message').focus();
            } else {//Other than viewcart page
              if (site.isAerin) {
                $('.engraving-message').addClass('engrave-choice-roman');
              } else {
                $('.engraving-message').addClass('engrave-choice-optima');
              }
            }
            if ($engravingFr.length > 0 && !site.isAerin) {
              $engravingChoices.find('.engraving').addClass('hidden');
              if ($engravingFrChoice.length > 1) {
                $engravingFrChoice.removeClass('hidden');
              }
              $engravingFrChoice.eq(0).trigger('click');
            }
          }
        });
      },
      object: []
    });
  });

  // When engraving popup form is closed, then hide the loading gif
  $('#viewcart').on('click', '.js-engraving-preview-popup #cboxClose', function(e){
    $('.js-engraving-loading').addClass('hidden');
  });
}

site.engravingInit = function() {
  var engravingformWrap = $('.js-edit-form'),
    engravedPreview = $('.js-form-preview'),
    engravingPreviewButton = $('.js-engraving-preview-button'),
    engravingBackButton = $('.js-back-preview'),
    engravinfFormContainer = $('form.js-engraving-form'),
    engravingAddtoBag = $('.js-engraving-save');

  // Android Input box fix
  var isAndroid = /android/i.test(navigator.userAgent.toLowerCase());
  if (isAndroid) {
    engravinfFormContainer.addClass('small-container');
  }
  engravingPreviewButton.bind('click', function(e){
    e.preventDefault();
    var form = $(this).closest('form.js-engraving-form');
    /* retrieve form data*/
    var params = form.engravingJSON();
    /*error messages*/
    var error_node = form.find('ul.error_messages');
    if (form.find(".engraving-message").val().length === 0) {
      generic.jsonrpc.fetch({
        method : 'form.rpc',
        params: [params],
        onBoth: function(r) {
          var resultObj = r.getCartResults();
          var messages = r.getMessages();
          /*Filter messages to remove SUCCESS messages*/
          if (messages) {
            messages = $.grep(messages, function(e) {
              return ($.inArray('SUCCESS', e.tags) === -1 && $.inArray('alter_monogram', e.tags) > 0);
            });
          }
          /*Filter messages to remove SUCCESS messages*/
          /*If we have error messages aftr stripping SUCCESS tags then show them otherwise we're successful*/
          if (messages && messages.length) {
              generic.showErrors(messages, error_node, form);
          }
          /*If we have error messages aftr stripping SUCCESS tags then show them otherwise we're successful*/
        }
      });
    } else {
      engravingPreviewButton.hide();
      engravingformWrap.hide();
      engravedPreview.addClass('active');
      engravingAddtoBag.show().css('display','block');
    }
  });
  //Show Engraved Form and hide Preview
  engravingBackButton.bind('click', function(e){
    e.preventDefault();
    engravedPreview.removeClass('active');
    engravingAddtoBag.hide();
    engravingformWrap.show();
    engravingPreviewButton.show();
  });
  //Bind keyup, keydown paste and autocomplete for input text fields
 $('.js-engraving-form input.engraving-message').on('input focus', function(e) {
    var $msgTextNode = $(this);
    var msgTextValue = $msgTextNode.val();
    //Update the preview copy
    var theId = $msgTextNode.attr('id').replace('txt-','preview-');
    //Update Char count
    var currentLength = msgTextValue.length;
    var maxLength = $msgTextNode.attr('maxlength') || 10;
    //Check and force the length of the field whilst typing
    if (currentLength > maxLength) {
      $msgTextNode.val(msgTextValue.substr(0, maxLength));
      return false;
    }
    //Now update the counter
    var $messageLenNode = $msgTextNode.closest('.js-engraving-form-line').find(".chars-left");
    if ($messageLenNode.length > 0) {
      $messageLenNode.html(currentLength + ' / ' + maxLength);
    }
    site.handleOverlayButton($msgTextNode, msgTextValue, theId);
  });

  //Multiple Choice Font Switching but allow different forms different selected
  $('.js-engraving-form a.change-font').click(function(e) {
    e.preventDefault();
    $this = $(this);
    var getClassName = $this.searchClassValue('engrave-choice-');
    var $engravingForm = $this.closest('form.js-engraving-form');
    var engravingMsg = $engravingForm.find('.engraving-message');
    var engravingMsgValue = engravingMsg.val();
    //If we have copy set the font style
    $engravingForm.find('input.engraving-message').each(function() {
      $(this).removeClassPrefix('engrave-choice-').addClass(getClassName);
    });
    $engravingForm.find('.new-canvas input').removeClassPrefix('engrave-choice-').addClass(getClassName);
    $engravingForm.find('.new-canvas .preview-copy').removeClassPrefix('engrave-choice-').addClass(getClassName);
    //Now set button selected styles
    $('a.change-font').removeClass('engrave-style-chosen');
    $this.addClass('engrave-style-chosen');
    //Now set the form value for the font
    var value = $this.searchClassValue('value-').replace('value-','');
    $engravingForm.find('input[name="MONOGRAM_FONT"]').val(value);

    site.handleOverlayButton($this, engravingMsgValue);
  });

  //Add to Cart
  $('.js-engraving-form a.engraving-save').click(function(e) {
    e.preventDefault();
    var form = $(this).closest('form.js-engraving-form');
    // retrieve form data
    var params = form.engravingJSON();
    //error messages
    var error_node = form.find('ul.error_messages');
    generic.jsonrpc.fetch({
      method : 'form.rpc',
      params: [params],
      onBoth: function(r) {
        var resultGetData = r.getData();
        if (resultGetData !== null && typeof resultGetData.ac_results !== 'undefined' && resultGetData.ac_results[0].result.CARTITEM !== null) {
          // Pass the engraving collection info to last added item object
          // So that, this info will be pulled by cart bag overlay
          resultGetData.ac_results[0].result.CARTITEM['coll_info'] = resultGetData.coll_info;
          var currentItem = r.getCartResults().getItem();
          var result;
          resultGetData.trans_data.order.items.map(function(a) {
            if (a.COLLECTION_ID == currentItem.COLLECTION_ID) {
              result = a;
            }
          });
          if (result.formattedAppliedPrice != null && resultGetData.ac_results[0].result.CARTITEM !== null) {
            resultGetData.ac_results[0].result.CARTITEM.formattedAppliedPrice = result.formattedAppliedPrice;
          }
        }
        var resultObj = r.getCartResults();
        var messages = r.getMessages();
        //Filter messages to remove SUCCESS messages
        if (messages) {
          messages = $.grep(messages, function(e) {
            return ($.inArray('SUCCESS',e.tags) === -1 && $.inArray('alter_monogram',e.tags) > 0);
          });
        }
        //Filter messages to remove SUCCESS messages
        //If we have error messages aftr stripping SUCCESS tags then show them otherwise we're successful
        if (messages && messages.length) {
            generic.showErrors(messages, error_node, form);
          $(document).trigger('engraving.error', [resultObj]);
        } else {
          var resultData = r.getData();
          $(document).trigger("addToCart.success", [resultObj]);
          generic.overlay.hide();
          if ($("#viewcart").length > 0 || $('#index-checkout').length > 0 || $('#index').length > 0) {
            site.panels.reloadPanels({
              noAnchor: true,
              noAnchorAndMsg: true,
            });
          }
        }
        //If we have error messages aftr stripping SUCCESS tags then show them otherwise we're successful
      }
    });
  });

  $.fn.engravingJSON  = function() {
    var form = this;
    var formSerial = form.serializeArray();
    // transform string into array of form elements
    var paramStr = '',
    params = {};
    // iterate through collection to transform form name/value into key/value properties of a literal object string.
    $.each(formSerial, function(i) {
      var key = this.name, value = this.value;
      if (params[key]) { //If the key exists
        if (!$.isArray(params[key])) { //and its not current already an array
          params[key] = new Array(params[key], value); //Then create a new array with Stirng as key 0 and this value as key 1
        } else {
          params[key].push(value); //Otherwise if its already an array lets add the new value to the array say 3rd or 4th input
        }
      } else {
        params[key] = value; //Otherwise its a simply string store
      }
    });
    //Join MONOGRAM_TEXT array if we have multiple lines
    if ($.isArray(params['MONOGRAM_TEXT'])) {
      params['MONOGRAM_TEXT'] = params['MONOGRAM_TEXT'].filter(function(val) { return val.trim() ? val : false; }).join('[BR]');
    }
    $.each(params, function(key, value){
      paramStr += '"'+ key + '":"' + value + '",';
    });
    // parse the string and create the literal object
    return eval("(" + "{"+paramStr.substring(0,(paramStr.length-1))+"}" + ")");
  };

  $.fn.searchClassValue = function(prefix) {
    var theClass = $(this).attr('class').match(new RegExp(prefix+"[0-9a-zA-Z_]+(s+)?", "g"));
    if ($.isArray(theClass)) {
      return theClass[0];
    }
    return false;
  };

  $.fn.removeClassPrefix = function(prefix) {
    this.each(function(i, el) {
      var classes = el.className.split(" ").filter(function(c) {
        return c.lastIndexOf(prefix, 0) !== 0;
      });
      el.className = $.trim(classes.join(" "));
    });
    return this;
  };
}

site.handleOverlayButton = function(currentObj, msgTextValue, theId) {
  $this = currentObj;
  var $engravingForm = $this.closest('form.js-engraving-form'),
    engravingMsg = $engravingForm.find('.engraving-message'),
    engravingStyleChosen = $engravingForm.find('a.engrave-style-chosen'),
    engravingMsgValue = engravingMsg.val();

  var transformedEngravingCopy = msgTextValue;
    /*Transform monogram copy case*/
  if (/[A-Z]/.test(transformedEngravingCopy) === true) {
    /*Monogram copy has uppercase char*/
    var copyArr = msgTextValue.split('');
    transformedEngravingCopy = copyArr.map(function(currentValue, index, arr) {
    return (index === 1 ) ?
      '<span class="preview-copy-capitalise">' + currentValue + '</span>' : currentValue;
    });
  }
  var $newCanvasNode = $this.closest('form.js-engraving-form').find('.new-canvas');
  $newCanvasNode.find('#'+theId).val(msgTextValue);
  var previewCopy = $newCanvasNode.find('.preview-copy');
  previewCopy.html(transformedEngravingCopy);
  
  if (engravingStyleChosen.hasClass('js-monogram-choice-lower')) {
    $engravingForm.find('.engrave-placement .preview-copy-capitalise').removeClass('preview-copy-capitalise');
    engravingMsg.val(engravingMsgValue.toLowerCase());
  } else if (engravingStyleChosen.hasClass('js-monogram-choice-upper')) {
    var engravingCopy = engravingMsgValue,
    copyArr = engravingMsgValue.split('');
    engravingCopy = copyArr.map(function(currentchar, index, arr) {
      return (index === 1 ) ?
        '<span class="preview-copy-capitalise">' + currentchar + '</span>' : currentchar;
    });
    var $engravePlacement = $engravingForm.find('.new-canvas');
    $engravePlacement.find('.preview-copy').html(engravingCopy);
    if (copyArr.length > 0) {
      if (copyArr[0] !== undefined && copyArr[1] !== undefined && copyArr[2] === undefined) {
        engravingMsg.val(copyArr[0].toLowerCase() + copyArr[1].toUpperCase());
      } else if (copyArr[0] !== undefined && copyArr[1] !== undefined && copyArr[2] !== undefined) {
        engravingMsg.val(copyArr[0].toLowerCase() + copyArr[1].toUpperCase() + copyArr[2].toLowerCase());
      }
    }
  }
  var $newCanvasNode = $this.closest('form.js-engraving-form').find('.new-canvas');
  var placementNode = $newCanvasNode.find('.engrave-placement');
  var canvasNode = $newCanvasNode.find('span.canvas-orig');
  canvasNode.removeClass('large-font');
  if (placementNode.width() < canvasNode.width()) {
    canvasNode.addClass('large-font');
  }
}

$.fn.engravingJSON  = function() {
  var form = this;
    var formSerial = form.serializeArray();
    // transform string into array of form elements
    var paramStr = '',
    params = {};
    // iterate through collection to transform form name/value into key/value properties of a literal object string.
    $.each(formSerial, function(i) {
      var key = this.name, value = this.value;
      if (params[key]) { //If the key exists
        if (!$.isArray(params[key])) { //and its not current already an array
          params[key] = new Array(params[key], value); //Then create a new array with Stirng as key 0 and this value as key 1
        } else {
          params[key].push(value); //Otherwise if its already an array lets add the new value to the array say 3rd or 4th input
        }
      } else {
        params[key] = value; //Otherwise its a simply string store
      }
    });
    //Join MONOGRAM_TEXT array if we have multiple lines
    if ($.isArray(params['MONOGRAM_TEXT'])) {
      params['MONOGRAM_TEXT'] = params['MONOGRAM_TEXT'].filter(function(val) { return val.trim() ? val : false; }).join('[BR]');
    }
    $.each(params, function(key, value){
      paramStr += '"'+ key + '":"' + value + '",';
    });
    // parse the string and create the literal object
    return eval("(" + "{"+paramStr.substring(0,(paramStr.length-1))+"}" + ")");
};

site.addToEngraving = function(args) {
  var params = {
    "_SUBMIT": "alter_collection",
    "action": "add"
  };
  if ($.cookie('csrftoken')) {
    params._TOKEN = $.cookie('csrftoken');
  }
  var skuBaseId;
  if (args.skuData && args.skuData.SKU_BASE_ID) {
    skuBaseId = args.skuData.SKU_BASE_ID;
  } else if (args.skuBaseId) {
    skuBaseId = args.skuBaseId;
  } else {
    return null;
  }
  params.SKU_BASE_ID = skuBaseId;

  var catBaseId = '';
  if (args.skuData && args.skuData.PARENT_CAT_ID) {
    var matchResult = args.skuData.PARENT_CAT_ID.match("[0-9]+");
    if (matchResult) {
      params.CAT_BASE_ID = matchResult[0];
    }
  }

  var id = generic.jsonrpc.fetch({
    method : 'rpc.form',
    params: [params],
    onSuccess:function(jsonRpcResponse) {
      var d = jsonRpcResponse.getData();
      var r = d.ac_results[0].result;

      if (r.KEY == 'SKU_ALREADY_IN_COLLECTION.ADD_SKU.COLLECTION.SAVE') {
        $(document).trigger("addToWishlist.exists", [r]);
      } else if (r.SUCCESS == 1 || r.KEY == 'SUCCESS.ADD_SKU.COLLECTION.SAVE') {
        var cr = jsonRpcResponse.getCartResults();
        $(document).trigger("addToWishlist.success", [cr]);
      }
    },
    onFailure: function(jsonRpcResponse) {
      console.log("add to favorites failure");
      console.log(jsonRpcResponse.getError());
    }
  });
};

var site = site || {};
site.shadeFilter = {};

site.shadeFilter.init = function() {
  new site.CustomSelects();
};

site.shadeFilter.filter = function() {
  var $swatches = $('.js-swatch', '.js-shade-picker');
  var $shadeFilter = $('.js-custom-select');
  var intensity = '';
  var miscFlag = '';
  var colorFamily = '';
  var $swatchesFiltered = $();
  var $selectedFilter = $();
  $shadeFilter.change(function() {
    $selectedFilter = $(this).find(':selected');
    if ($selectedFilter.data('allItems')) {
      $swatches.parent().show();
      $swatches.first().click();
    } else if ($selectedFilter.data('intensityItem')) {
      intensity = $selectedFilter.attr('data-intensity');
      $swatches.parent().hide();
      $swatchesFiltered = $swatches.filter('[data-intensity="' + intensity + '"]');
      $swatchesFiltered.parent().show();
      $swatchesFiltered.first().click();
    } else if ($selectedFilter.data('miscFlagItem')) {
      miscFlag = $selectedFilter.attr('data-misc-flag');
      $swatches.parent().hide();
      $swatchesFiltered = $swatches.filter('[data-misc-flag="' + miscFlag + '"]');
      $swatchesFiltered.parent().show();
      $swatchesFiltered.first().click();
    } else if ($selectedFilter.data('colorFamily')) {
      colorFamily = $selectedFilter.data('colorFamily');
      $swatches.parent().hide();
      $swatchesFiltered = $swatches.filter('[data-color-family="' + colorFamily + '"]');
      $swatchesFiltered.parent().show();
      $swatchesFiltered.first().click();
    }
  });
};

site.shadeFilter.loadProductFilterData = function(productData) {
  var p = productData;
  var $prodContainer = $(".js-pr-product[data-product-id='" + p.PRODUCT_ID + "']");
  var showShadeFlag = $prodContainer.data('showShadeFilter') ? true : false;
  if ($prodContainer.length === 0) {
    return p;
  }
  p['enable_mobile_shade_filter'] = showShadeFlag;
  if (showShadeFlag) {
    var skus = p.skus;
    var filteredIntensity = [];
    var filteredMiscFlags = [];
    var filteredColorFamily = [];
    var miscFlag = 0;
    var hexCount = 0;
    var shadeHex = '';
    $(skus).each(function(index, sku) {
    //intensity
      if (!_.isNull(sku['INTENSITY']) && !_.isUndefined(sku['INTENSITY'])) {
        filteredIntensity.push(sku['INTENSITY']);
      }

      //color family
      if (!_.isNull(sku['ATTRIBUTE_COLOR_FAMILY']) && !_.isUndefined(sku['ATTRIBUTE_COLOR_FAMILY'])) {
        filteredColorFamily.push(sku['ATTRIBUTE_COLOR_FAMILY']);
      }

      //misc flags
      if (!_.isNull(sku['MISC_FLAG']) && !_.isUndefined(sku['MISC_FLAG'])) {
        filteredMiscFlags.push(sku['MISC_FLAG']);
        miscFlag = sku['MISC_FLAG'];
        switch (miscFlag) {
          case 1:
            sku['misc_flag_sku_1'] = true;
            break;
          case 2:
            sku['misc_flag_sku_2'] = true;
            break;
          case 3:
            sku['misc_flag_sku_3'] = true;
            break;
          case 5:
          case 94:
            sku['misc_flag_sku_4'] = true;
            break;
          case 15:
            sku['misc_flag_sku_5'] = true;
            break;
          case 126:
            sku['misc_flag_sku_13'] = true;
            break;
        }
      }
      //hex
      shadeHex = sku.HEX_VALUE_STRING;
      // explode
      shadeHex = shadeHex.split(',');
      if (shadeHex.length === 1) {
        sku['SWATCH_TYPE'] = 'single';
      } else if (shadeHex.length === 2) {
        sku['SWATCH_TYPE'] = 'duo';
      } else if (shadeHex.length === 3) {
        sku['SWATCH_TYPE'] = 'trio';
      } else if (shadeHex.length === 5) {
        sku['SWATCH_TYPE'] = 'quint';
      }
      for (var i = 0; i < shadeHex.length; i++) {
        hexCount = i + 1;
        sku['HEX_VALUE_' + hexCount] = shadeHex[i];
      }
    }); // skus
    // intensity
    if (skus.length > 1) {
      filteredIntensity = _.uniq(filteredIntensity);
      if (filteredIntensity.length > 1) {
        p['filtered-intensity'] = filteredIntensity;
        p['filtered_intensity_filter'] = true;
      }

      filteredColorFamily = _.uniq(filteredColorFamily);
      if (filteredColorFamily.length > 1) {
        p['color-family'] = filteredColorFamily;
        p['color-family-show'] = true;
        p['filtered_intensity_filter'] = true;
      }

      filteredMiscFlags = _.uniq(filteredMiscFlags);
      if (filteredMiscFlags.length > 1) {
        $.each(filteredMiscFlags, function(i, v) {
          switch (v) {
            case 1:
              p['misc_flag_filter_1'] = 1;
              break;
            case 2:
              p['misc_flag_filter_2'] = 2;
              break;
            case 3:
              p['misc_flag_filter_3'] = 3;
              break;
            case 5:
              p['misc_flag_filter_4'] = 5;
              break;
            case 94:
              p['misc_flag_filter_4'] = 94;
              break;
            case 15:
              p['misc_flag_filter_5'] = 15;
              break;
            case 30:
              p['misc_flag_filter_6'] = 30;
              break;
            case 17:
              p['misc_flag_filter_7'] = 17;
              break;
            case 116:
              p['misc_flag_filter_8'] = 116;
              break;
            case 121:
              p['misc_flag_filter_9'] = 121;
              break;
            case 122:
              p['misc_flag_filter_10'] = 122;
              break;
            case 124:
              p['misc_flag_filter_11'] = 124;
              break;
            case 125:
              p['misc_flag_filter_12'] = 125;
              break;
            case 126:
              p['misc_flag_filter_13'] = 126;
              break;
            case 128:
              p['misc_flag_filter_14'] = 128;
              break;
          }
        });
        p['filtered_intensity_filter'] = true;
      }
    }
  }
  return p;
};

site.CustomSelects = function() {
  this.init();
};

site.CustomSelects.prototype = {
  selectClass: 'js-custom-select',
  optionClass: 'custom-select-option',
  $selects: $(),

  buildSelects: function() {
    var self = this;
    var customDivMock = '<div data-custom-select-index="" class="custom-select-clone js-custom-select-clone"><div class="custom-select-current select-markdown"><div class="filtered-swatch"></div><div class="selectBox-label"></div><span class="selectBox-arrow"></span></div> <div class="custom-select-options hidden"></div></div>';
    var $customDiv = $();
    var $selectedOption = $();
    var $customOptionsParent = $();
    var customOptionMock = '<li data-custom-option-value="" class="' + self.optionClass + '"></li>';
    var $customOption = $();
    var $customSelected = $();
    var $customSelectOptionsMock = $('<ul class="custom-select-box"></ul>');
    var $customSelectOptions = $();
    var swatchClass = '';
    self.$selects.each(function(i, el) {
      $(el).addClass('custom-select-index' + i);
      $customDiv = $(customDivMock).clone(true);
      $customDiv.attr('data-custom-select-index', i);
      $selectedOption = $(el).find(':selected');
      $customSelected = $customDiv.find('.custom-select-current .selectBox-label');
      $customOptionsParent = $customDiv.find('.custom-select-options');
      $customSelected.html($selectedOption.text());
      $customSelectOptions = $customSelectOptionsMock.clone(true);
      $(el).find('option').each(function(i, op) {
        $customOption = $(customOptionMock).clone(true);
        $customOption.attr('data-custom-option-value', i);
        if ($(op).is(':selected')) {
          $customOption.addClass('active');
        }
        $customOption.html(this.text);
        if ($(op).data('prependCssContainer')) {
          swatchClass = $(op).data('prependCssContainer');
          swatchClass = 'filter-' + swatchClass.toLowerCase().replace(/ /g, '_');
          swatchClass = swatchClass.toLowerCase();
          $customOption.prepend('<div class="filtered-swatch ' + swatchClass + '"></div>');
        }
        $customSelectOptions.append($customOption);
      });
      $customOptionsParent.append($customSelectOptions);
      $(el).addClass('hidden');
      $customDiv.insertAfter($(el));
      $(el).bind('change', function() {
        self.refreshSelect($(this));
      });
    });
  },
  refreshSelect: function($el) {
    var self = this;
    var $customDiv = $el.next('.js-custom-select-clone');
    var $selectedOption = $el.find(':selected');
    var $customSelected = $customDiv.find('.custom-select-current');
    var $customSelectLabel = $customSelected.find('.selectBox-label');
    var $filteredSwatch = $('.' + self.optionClass + '.active').find('.filtered-swatch').clone(true);
    var $swatchFilterMock = $('<div class="filtered-swatch"></div>');
    $customSelectLabel.html($selectedOption.text());
    $customSelected.find('.filtered-swatch').remove();
    // if the user selects All shades it has no swatchFilter, its needed to keep the select align
    $filteredSwatch.length ? $customSelected.prepend($filteredSwatch[0]) : $customSelected.prepend($swatchFilterMock[0]);
    $customDiv.find('.custom-select-options').toggleClass('hidden');
    $customSelected.toggleClass('clicked');
  },
  addEvents: function() {
    var self = this;
    var $currentSelect = $();
    var selectIndex = 0;
    var optionIndex = 0;
    $('.' + self.optionClass).on('click', function() {
      $('.' + self.optionClass).removeClass('active');
      $(this).addClass('active');
      selectIndex = $(this).closest('.js-custom-select-clone').attr('data-custom-select-index');
      $currentSelect = $('.custom-select-index' + selectIndex);
      optionIndex = $(this).attr('data-custom-option-value');
      $currentSelect[0].selectedIndex = parseInt(optionIndex);
      $currentSelect.find('option').removeClass('is_active');
      $currentSelect.find('option').eq(optionIndex).addClass('is_active');
      $currentSelect.trigger('change');
    });
    $('.custom-select-current').bind('click', function() {
      self.toggleSelect($(this));
    }).bind('clickoutside', function() {
      if ($(this).hasClass('clicked')) {
        self.toggleSelect($(this));
      }
    });
  },
  toggleSelect: function($el) {
    var self = this;
    var $currentOptions = $el.next('.custom-select-options');
    $el.toggleClass('clicked');
    self.positionSelectOptions($el, $currentOptions);
    $currentOptions.toggleClass('hidden');
  },
  positionSelectOptions: function($selectedOption, $options) {
    var scrollTop = $(window).scrollTop(),
        elementOffset = $selectedOption.offset().top,
        topSpace = elementOffset - scrollTop;
    var space = screen.height - (topSpace + $selectedOption.outerHeight(true));
    var $clonedOptions = $options.clone(true);
    // we need to display the cloned options outside the viewport, so we can get the
    // elements dinamic height
    $clonedOptions.removeClass('hidden').css({'top': '-9999px', 'display': 'block'});
    $options.parent().append($clonedOptions);
    var optionsHeight = $clonedOptions.find('.custom-select-box').outerHeight(true) + $selectedOption.outerHeight(false) - 1;
    // we remove the clone after getting it's height
    $clonedOptions.remove();
    $options.find('.custom-select-box').removeClass('custom-select-top');
    $selectedOption.removeClass('custom-select-top');
    $options.css('top', '0');
    if (parseInt(space) < parseInt(optionsHeight)) {
      $options.css({'top': '-' + optionsHeight + 'px'});
      $selectedOption.addClass('custom-select-top');
      $options.find('.custom-select-box').addClass('custom-select-top');
    }
  },
  init: function() {
    var self = this;
    self.$selects = $('.' + self.selectClass);
    if (self.$selects.length) {
      $.when(self.buildSelects()).then(self.addEvents());
    }
  },
};

/*
 * jQuery outside events - v1.1 - 3/16/2010
 * http://benalman.com/projects/jquery-outside-events-plugin/
 * 
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */
(function($,c,b){$.map("click dblclick mousemove mousedown mouseup mouseover mouseout change select submit keydown keypress keyup".split(" "),function(d){a(d)});a("focusin","focus"+b);a("focusout","blur"+b);$.addOutsideEvent=a;function a(g,e){e=e||g+b;var d=$(),h=g+"."+e+"-special-event";$.event.special[e]={setup:function(){d=d.add(this);if(d.length===1){$(c).bind(h,f)}},teardown:function(){d=d.not(this);if(d.length===0){$(c).unbind(h)}},add:function(i){var j=i.handler;i.handler=function(l,k){l.target=k;j.apply(this,arguments)}}};function f(i){$(d).each(function(){var j=$(this);if(this!==i.target&&!j.has(i.target).length){j.triggerHandler(e,[i.target])}})}}})(jQuery,document,"outside");

/**
 * Copyright (c) 2007-2013 Ariel Flesler - aflesler<a>gmail<d>com | http://flesler.blogspot.com
 * Licensed under MIT
 * @author Ariel Flesler
 * @version 1.3.1
 */
;(function($){var h=location.href.replace(/#.*/,'');var i=$.localScroll=function(a){$('body').localScroll(a)};i.defaults={duration:1000,axis:'y',event:'click',stop:true,target:window};i.hash=function(a){if(location.hash){a=$.extend({},i.defaults,a);a.hash=false;if(a.reset){var d=a.duration;delete a.duration;$(a.target).scrollTo(0,a);a.duration=d}scroll(0,location,a)}};$.fn.localScroll=function(b){b=$.extend({},i.defaults,b);return b.lazy?this.bind(b.event,function(e){var a=$([e.target,e.target.parentNode]).filter(filter)[0];if(a)scroll(e,a,b)}):this.find('a,area').filter(filter).bind(b.event,function(e){scroll(e,this,b)}).end().end();function filter(){return!!this.href&&!!this.hash&&this.href.replace(this.hash,'')==h&&(!b.filter||$(this).is(b.filter))}};function scroll(e,a,b){var c=a.hash.slice(1),elem=document.getElementById(c)||document.getElementsByName(c)[0];if(!elem)return;if(e)e.preventDefault();var d=$(b.target);if(b.lock&&d.is(':animated')||b.onBefore&&b.onBefore(e,elem,d)===false)return;if(b.stop)d._scrollable().stop(true);if(b.hash){var f=b.offset;f=f&&f.top||f||0;var g=elem.id==c?'id':'name',$a=$('<a> </a>').attr(g,c).css({position:'absolute',top:$(window).scrollTop()+f,left:$(window).scrollLeft()});elem[g]='';$('body').prepend($a);location=a.hash;$a.remove();elem[g]=c}d.scrollTo(elem,b).trigger('notify.serialScroll',[elem])}})(jQuery);
/**
 * Copyright (c) 2007-2013 Ariel Flesler - aflesler<a>gmail<d>com | http://flesler.blogspot.com
 * Licensed under MIT
 * @author Ariel Flesler
 * @version 1.4.7
 */
(function(d){function h(b){return"object"==typeof b?b:{top:b,left:b}}var n=d.scrollTo=function(b,c,a){return d(window).scrollTo(b,c,a)};n.defaults={axis:"xy",duration:1.3<=parseFloat(d.fn.jquery)?0:1,limit:!0};n.window=function(b){return d(window)._scrollable()};d.fn._scrollable=function(){return this.map(function(){if(this.nodeName&&-1==d.inArray(this.nodeName.toLowerCase(),["iframe","#document","html","body"]))return this;var b=(this.contentWindow||this).document||this.ownerDocument||this;return/webkit/i.test(navigator.userAgent)|| "BackCompat"==b.compatMode?b.body:b.documentElement})};d.fn.scrollTo=function(b,c,a){"object"==typeof c&&(a=c,c=0);"function"==typeof a&&(a={onAfter:a});"max"==b&&(b=9E9);a=d.extend({},n.defaults,a);c=c||a.duration;a.queue=a.queue&&1<a.axis.length;a.queue&&(c/=2);a.offset=h(a.offset);a.over=h(a.over);return this._scrollable().each(function(){function q(b){k.animate(e,c,a.easing,b&&function(){b.call(this,g,a)})}if(null!=b){var l=this,k=d(l),g=b,p,e={},s=k.is("html,body");switch(typeof g){case "number":case "string":if(/^([+-]=?)?\d+(\.\d+)?(px|%)?$/.test(g)){g= h(g);break}g=d(g,this);if(!g.length)return;case "object":if(g.is||g.style)p=(g=d(g)).offset()}d.each(a.axis.split(""),function(b,d){var c="x"==d?"Left":"Top",m=c.toLowerCase(),f="scroll"+c,h=l[f],r=n.max(l,d);p?(e[f]=p[m]+(s?0:h-k.offset()[m]),a.margin&&(e[f]-=parseInt(g.css("margin"+c))||0,e[f]-=parseInt(g.css("border"+c+"Width"))||0),e[f]+=a.offset[m]||0,a.over[m]&&(e[f]+=g["x"==d?"width":"height"]()*a.over[m])):(c=g[m],e[f]=c.slice&&"%"==c.slice(-1)?parseFloat(c)/100*r:c);a.limit&&/^\d+$/.test(e[f])&& (e[f]=0>=e[f]?0:Math.min(e[f],r));!b&&a.queue&&(h!=e[f]&&q(a.onAfterFirst),delete e[f])});q(a.onAfter)}}).end()};n.max=function(b,c){var a="x"==c?"Width":"Height",h="scroll"+a;if(!d(b).is("html,body"))return b[h]-d(b)[a.toLowerCase()]();var a="client"+a,l=b.ownerDocument.documentElement,k=b.ownerDocument.body;return Math.max(l[h],k[h])-Math.min(l[a],k[a])}})(jQuery);

/*
 * jQuery selectBox - A cosmetic, styleable replacement for SELECT elements
 *
 * Licensed under the MIT license: http://opensource.org/licenses/MIT
 *
 * v1.2.0
 *
 * https://github.com/marcj/jquery-selectBox
 */
;(function ($) {

    /**
     * SelectBox class.
     *
     * @param {HTMLElement|jQuery} select If it's a jQuery object, we use the first element.
     * @param {Object}             options
     * @constructor
     */
    var SelectBox = this.SelectBox = function (select, options) {
        if (select instanceof jQuery) {
            if (select.length > 0) {
                select = select[0];
            } else {
                return;
            }
        }

        this.typeTimer     = null;
        this.typeSearch    = '';
        this.isMac         = navigator.platform.match(/mac/i);
        options            = 'object' === typeof options ? options :  {};
        this.selectElement = select;

        // Disable for iOS devices (their native controls are more suitable for a touch device)
        if (!options.mobile && navigator.userAgent.match(/iPhone|Android|IEMobile|BlackBerry/i)) {
            return false;
        }

        // Element must be a select control
        if ('select' !== select.tagName.toLowerCase()) {
            return false;
        }

        this.init(options);
    };

    /**
     * @type {String}
     */
    SelectBox.prototype.version = '1.2.0';

    /**
     * @param {Object} options
     *
     * @returns {Boolean}
     */
    SelectBox.prototype.init = function (options) {
        var select = $(this.selectElement);
        if (select.data('selectBox-control')) {
            return false;
        }

        var control    = $('<a class="selectBox" />')
            , inline   = select.attr('multiple') || parseInt(select.attr('size')) > 1
            , settings = options || {}
            , tabIndex = parseInt(select.prop('tabindex')) || 0
            , self     = this;

        control
            // .width(select.outerWidth())
            .addClass(select.attr('class'))
            .attr('title', select.attr('title') || '')
            .attr('tabindex', tabIndex)
            .css('display', 'inline-block')
            .bind('focus.selectBox', function () {
                if (this !== document.activeElement && document.body !== document.activeElement) {
                    $(document.activeElement).blur();
                }
                if (control.hasClass('selectBox-active')) {
                    return;
                }
                control.addClass('selectBox-active');
                select.trigger('focus');
            })
            .bind('blur.selectBox', function () {
                if (!control.hasClass('selectBox-active')) {
                    return;
                }
                control.removeClass('selectBox-active');
                select.trigger('blur');
            });

        if (!$(window).data('selectBox-bindings')) {
            $(window)
                .data('selectBox-bindings', true)
                .bind('scroll.selectBox', (settings.hideOnWindowScroll) ? this.hideMenus : $.noop)
                .bind('resize.selectBox', this.hideMenus);
        }

        if (select.attr('disabled')) {
            control.addClass('selectBox-disabled');
        }

        // Focus on control when label is clicked
        select.bind('click.selectBox', function (event) {
            control.focus();
            event.preventDefault();
        });

        // Generate control
        if (inline) {
            // Inline controls
            options = this.getOptions('inline');

            control
                .append(options)
                .data('selectBox-options', options).addClass('selectBox-inline selectBox-menuShowing')
                .bind('keydown.selectBox', function (event) {
                    self.handleKeyDown(event);
                })
                .bind('keypress.selectBox',function (event) {
                    self.handleKeyPress(event);
                })
                .bind('mousedown.selectBox',function (event) {
                    if (1 !== event.which) {
                        return;
                    }
                    if ($(event.target).is('A.selectBox-inline')) {
                        event.preventDefault();
                    }
                    if (!control.hasClass('selectBox-focus')) {
                        control.focus();
                    }
                })
                .insertAfter(select);

            // Auto-height based on size attribute
            if (!select[0].style.height) {
                var size = select.attr('size') ? parseInt(select.attr('size')) : 5;
                // Draw a dummy control off-screen, measure, and remove it
                var tmp = control
                    .clone()
                    .removeAttr('id')
                    .css({
                        position: 'absolute',
                        top: '-9999em'
                    })
                    .show()
                    .appendTo('body');
                tmp.find('.selectBox-options').html('<li><a>\u00A0</a></li>');
                var optionHeight = parseInt(tmp.find('.selectBox-options A:first').html('&nbsp;').outerHeight());
                tmp.remove();
                control.height(optionHeight * size);
            }
            this.disableSelection(control);
        } else {
            // Dropdown controls
            var label = $('<span class="selectBox-label" />'),
                arrow = $('<span class="selectBox-arrow" />');

            // Update label
            label.attr('class', this.getLabelClass()).text(this.getLabelText());
            options = this.getOptions('dropdown');
            options.appendTo('BODY');

            control
                .data('selectBox-options', options)
                .addClass('selectBox-dropdown')
                .append(label)
                .append(arrow)
                .bind('mousedown.selectBox', function (event) {
                    if (1 === event.which) {
                        if (control.hasClass('selectBox-menuShowing')) {
                            self.hideMenus();
                        } else {
                            event.stopPropagation();
                            // Webkit fix to prevent premature selection of options
                            options
                                .data('selectBox-down-at-x', event.screenX)
                                .data('selectBox-down-at-y', event.screenY);
                            self.showMenu();
                        }
                    }
                })
                .bind('keydown.selectBox', function (event) {
                    self.handleKeyDown(event);
                })
                .bind('keypress.selectBox', function (event) {
                    self.handleKeyPress(event);
                })
                .bind('open.selectBox',function (event, triggerData) {
                    if (triggerData && triggerData._selectBox === true) {
                        return;
                    }
                    self.showMenu();
                })
                .bind('close.selectBox', function (event, triggerData) {
                    if (triggerData && triggerData._selectBox === true) {
                        return;
                    }
                    self.hideMenus();
                })
                .insertAfter(select);

            // Set label width
            // var labelWidth =
            //         control.width()
            //       - arrow.outerWidth()
            //       - (parseInt(label.css('paddingLeft')) || 0)
            //       - (parseInt(label.css('paddingRight')) || 0);

            // label.width(labelWidth);
            this.disableSelection(control);
        }
        // Store data for later use and show the control
        select
            .addClass('selectBox')
            .data('selectBox-control', control)
            .data('selectBox-settings', settings)
            .hide();
    };

    /**
     * @param {String} type 'inline'|'dropdown'
     * @returns {jQuery}
     */
    SelectBox.prototype.getOptions = function (type) {
        var options;
        var select = $(this.selectElement);
        var self   = this;
        // Private function to handle recursion in the getOptions function.
        var _getOptions = function (select, options) {
            // Loop through the set in order of element children.
            select.children('OPTION, OPTGROUP').each(function () {
                // If the element is an option, add it to the list.
                if ($(this).is('OPTION')) {
                    // Check for a value in the option found.
                    if ($(this).length > 0) {
                        // Create an option form the found element.
                        self.generateOptions($(this), options);
                    } else {
                        // No option information found, so add an empty.
                        options.append('<li>\u00A0</li>');
                    }
                } else {
                    // If the element is an option group, add the group and call this function on it.
                    var optgroup = $('<li class="selectBox-optgroup" />');
                    optgroup.text($(this).attr('label'));
                    options.append(optgroup);
                    options = _getOptions($(this), options);
                }
            });
            // Return the built strin
            return options;
        };

        switch (type) {
            case 'inline':
                options = $('<ul class="selectBox-options" />');
                options = _getOptions(select, options);
                options
                    .find('A')
                    .bind('mouseover.selectBox', function (event) {
                        self.addHover($(this).parent());
                    })
                    .bind('mouseout.selectBox',function (event) {
                        self.removeHover($(this).parent());
                    })
                    .bind('mousedown.selectBox',function (event) {
                        if (1 !== event.which) {
                            return
                        }
                        event.preventDefault(); // Prevent options from being "dragged"
                        if (!select.selectBox('control').hasClass('selectBox-active')) {
                            select.selectBox('control').focus();
                        }
                    })
                    .bind('mouseup.selectBox', function (event) {
                        if (1 !== event.which) {
                            return;
                        }
                        self.hideMenus();
                        self.selectOption($(this).parent(), event);
                    });

                this.disableSelection(options);
                return options;
            case 'dropdown':
                options = $('<ul class="selectBox-dropdown-menu selectBox-options" />');
                options = _getOptions(select, options);

                options
                    .data('selectBox-select', select)
                    .css('display', 'none')
                    .appendTo('BODY')
                    .find('A')
                    .bind('mousedown.selectBox', function (event) {
                        if (event.which === 1) {
                            event.preventDefault(); // Prevent options from being "dragged"
                            if (event.screenX === options.data('selectBox-down-at-x') &&
                                event.screenY === options.data('selectBox-down-at-y')) {
                                options.removeData('selectBox-down-at-x').removeData('selectBox-down-at-y');
                                if (/android/i.test(navigator.userAgent.toLowerCase()) &&
                                    /chrome/i.test(navigator.userAgent.toLowerCase())) {
                                    self.selectOption($(this).parent());
                                }
                                self.hideMenus();
                            }
                        }
                    })
                    .bind('mouseup.selectBox', function (event) {
                        if (1 !== event.which) {
                            return;
                        }
                        if (event.screenX === options.data('selectBox-down-at-x') &&
                            event.screenY === options.data('selectBox-down-at-y')) {
                            return;
                        } else {
                            options.removeData('selectBox-down-at-x').removeData('selectBox-down-at-y');
                        }
                        self.selectOption($(this).parent());
                        self.hideMenus();
                    })
                    .bind('mouseover.selectBox', function (event) {
                        self.addHover($(this).parent());
                    })
                    .bind('mouseout.selectBox', function (event) {
                        self.removeHover($(this).parent());
                    });

                // Inherit classes for dropdown menu
                var classes = select.attr('class') || '';
                if ('' !== classes) {
                    classes = classes.split(' ');
                    for (var i = 0; i < classes.length; i++) {
                        options.addClass(classes[i] + '-selectBox-dropdown-menu');
                    }

                }
                this.disableSelection(options);
                return options;
        }
    };

    /**
     * Returns the current class of the selected option.
     *
     * @returns {String}
     */
    SelectBox.prototype.getLabelClass = function () {
        var selected = $(this.selectElement).find('OPTION:selected');
        return ('selectBox-label ' + (selected.attr('class') || '')).replace(/\s+$/, '');
    };

    /**
     * Returns the current label of the selected option.
     *
     * @returns {String}
     */
    SelectBox.prototype.getLabelText = function () {
        var selected = $(this.selectElement).find('OPTION:selected');
        return selected.text() || '\u00A0';
    };

    /**
     * Sets the label.
     * This method uses the getLabelClass() and getLabelText() methods.
     */
    SelectBox.prototype.setLabel = function () {
        var select = $(this.selectElement);
        var control = select.data('selectBox-control');
        if (!control) {
            return;
        }

        control
            .find('.selectBox-label')
            .attr('class', this.getLabelClass())
            .text(this.getLabelText());
    };

    /**
     * Destroys the SelectBox instance and shows the origin select element.
     *
     */
    SelectBox.prototype.destroy = function () {
        var select = $(this.selectElement);
        var control = select.data('selectBox-control');
        if (!control) {
            return;
        }

        var options = control.data('selectBox-options');
        options.remove();
        control.remove();
        select
            .removeClass('selectBox')
            .removeData('selectBox-control')
            .data('selectBox-control', null)
            .removeData('selectBox-settings')
            .data('selectBox-settings', null)
            .show();
    };

    /**
     * Refreshes the option elements.
     */
    SelectBox.prototype.refresh = function () {
        var select = $(this.selectElement)
            , control = select.data('selectBox-control')
            , type = control.hasClass('selectBox-dropdown') ? 'dropdown' : 'inline'
            , options;

        // Remove old options
        control.data('selectBox-options').remove();

        // Generate new options
        options  = this.getOptions(type);
        control.data('selectBox-options', options);

        switch (type) {
            case 'inline':
                control.append(options);
                break;
            case 'dropdown':
                // Update label
                this.setLabel();
                $("BODY").append(options);
                break;
        }

        // Restore opened dropdown state (original menu was trashed)
        if ('dropdown' === type && control.hasClass('selectBox-menuShowing')) {
            this.showMenu();
        }
    };

    /**
     * Shows the dropdown menu.
     */
    SelectBox.prototype.showMenu = function () {
        var self = this
            , select   = $(this.selectElement)
            , control  = select.data('selectBox-control')
            , settings = select.data('selectBox-settings')
            , options  = control.data('selectBox-options');

        if (control.hasClass('selectBox-disabled')) {
            return false;
        }

        this.hideMenus();

        // Get top and bottom width of selectBox
        var borderBottomWidth = parseInt(control.css('borderBottomWidth')) || 0;
        var borderTopWidth = parseInt(control.css('borderTopWidth')) || 0;

        // Get proper variables for keeping options in viewport
        var pos = control.offset()
            , topPositionCorrelation = (settings.topPositionCorrelation) ? settings.topPositionCorrelation : 0
            , bottomPositionCorrelation = (settings.bottomPositionCorrelation) ? settings.bottomPositionCorrelation : 0
            , optionsHeight = options.outerHeight()
            , controlHeight = control.outerHeight()
            , maxHeight = parseInt(options.css('max-height'))
            , scrollPos = $(window).scrollTop()
            , heightToTop = pos.top - scrollPos
            , heightToBottom = $(window).height() - ( heightToTop + controlHeight )
            , posTop = (heightToTop > heightToBottom) && (settings.keepInViewport == null ? true : settings.keepInViewport)
            , top = posTop
                  ? pos.top - optionsHeight + borderTopWidth + topPositionCorrelation
                  : pos.top + controlHeight - borderBottomWidth - bottomPositionCorrelation;


        // If the height to top and height to bottom are less than the max-height
        if(heightToTop < maxHeight&& heightToBottom < maxHeight){

            // Set max-height and top
            if(posTop){
                var maxHeightDiff = maxHeight - ( heightToTop - 5 );
                options.css({'max-height': maxHeight - maxHeightDiff + 'px'});
                top = top + maxHeightDiff;
            }else{
                var maxHeightDiff = maxHeight - ( heightToBottom - 5 );
                options.css({'max-height': maxHeight - maxHeightDiff + 'px'});
            }

        }

        // Save if position is top to options data
        options.data('posTop',posTop);


        // Menu position
        options
            .width(control.innerWidth())
            .css({
                top: top,
                left: control.offset().left
            })
            // Add Top and Bottom class based on position
            .addClass('selectBox-options selectBox-options-'+(posTop?'top':'bottom'));


        if (select.triggerHandler('beforeopen')) {
            return false;
        }

        var dispatchOpenEvent = function () {
            select.triggerHandler('open', {
                _selectBox: true
            });
        };

        // Show menu
        switch (settings.menuTransition) {
            case 'fade':
                options.fadeIn(settings.menuSpeed, dispatchOpenEvent);
                break;
            case 'slide':
                options.slideDown(settings.menuSpeed, dispatchOpenEvent);
                break;
            default:
                options.show(settings.menuSpeed, dispatchOpenEvent);
                break;
        }

        if (!settings.menuSpeed) {
            dispatchOpenEvent();
        }

        // Center on selected option
        var li = options.find('.selectBox-selected:first');
        this.keepOptionInView(li, true);
        this.addHover(li);
        control.addClass('selectBox-menuShowing selectBox-menuShowing-'+(posTop?'top':'bottom'));

        $(document).bind('mousedown.selectBox', function (event) {
            if (1 === event.which) {
                if ($(event.target).parents().andSelf().hasClass('selectBox-options')) {
                    return;
                }
                self.hideMenus();
            }
        });
    };

    /**
     * Hides the menu of all instances.
     */
    SelectBox.prototype.hideMenus = function () {
        if ($(".selectBox-dropdown-menu:visible").length === 0) {
            return;
        }

        $(document).unbind('mousedown.selectBox');
        $(".selectBox-dropdown-menu").each(function () {
            var options = $(this)
                , select = options.data('selectBox-select')
                , control = select.data('selectBox-control')
                , settings = select.data('selectBox-settings')
                , posTop = options.data('posTop');

            if (select.triggerHandler('beforeclose')) {
                return false;
            }

            var dispatchCloseEvent = function () {
                select.triggerHandler('close', {
                    _selectBox: true
                });
            };
            if (settings) {
                switch (settings.menuTransition) {
                    case 'fade':
                        options.fadeOut(settings.menuSpeed, dispatchCloseEvent);
                        break;
                    case 'slide':
                        options.slideUp(settings.menuSpeed, dispatchCloseEvent);
                        break;
                    default:
                        options.hide(settings.menuSpeed, dispatchCloseEvent);
                        break;
                }
                if (!settings.menuSpeed) {
                    dispatchCloseEvent();
                }
                control.removeClass('selectBox-menuShowing selectBox-menuShowing-'+(posTop?'top':'bottom'));
            } else {
                $(this).hide();
                $(this).triggerHandler('close', {
                    _selectBox: true
                });
                $(this).removeClass('selectBox-menuShowing selectBox-menuShowing-'+(posTop?'top':'bottom'));
            }

            options.css('max-height','');
            //Remove Top or Bottom class based on position
            options.removeClass('selectBox-options-'+(posTop?'top':'bottom'));
            options.data('posTop' , false);
        });
    };

    /**
     * Selects an option.
     *
     * @param {HTMLElement} li
     * @param {DOMEvent}    event
     * @returns {Boolean}
     */
    SelectBox.prototype.selectOption = function (li, event) {
        var select = $(this.selectElement);
        li         = $(li);

        var control    = select.data('selectBox-control')
            , settings = select.data('selectBox-settings');

        if (control.hasClass('selectBox-disabled')) {
            return false;
        }

        if (0 === li.length || li.hasClass('selectBox-disabled')) {
            return false;
        }

        if (select.attr('multiple')) {
            // If event.shiftKey is true, this will select all options between li and the last li selected
            if (event.shiftKey && control.data('selectBox-last-selected')) {
                li.toggleClass('selectBox-selected');
                var affectedOptions;
                if (li.index() > control.data('selectBox-last-selected').index()) {
                    affectedOptions = li
                        .siblings()
                        .slice(control.data('selectBox-last-selected').index(), li.index());
                } else {
                    affectedOptions = li
                        .siblings()
                        .slice(li.index(), control.data('selectBox-last-selected').index());
                }
                affectedOptions = affectedOptions.not('.selectBox-optgroup, .selectBox-disabled');
                if (li.hasClass('selectBox-selected')) {
                    affectedOptions.addClass('selectBox-selected');
                } else {
                    affectedOptions.removeClass('selectBox-selected');
                }
            } else if ((this.isMac && event.metaKey) || (!this.isMac && event.ctrlKey)) {
                li.toggleClass('selectBox-selected');
            } else {
                li.siblings().removeClass('selectBox-selected');
                li.addClass('selectBox-selected');
            }
        } else {
            li.siblings().removeClass('selectBox-selected');
            li.addClass('selectBox-selected');
        }

        if (control.hasClass('selectBox-dropdown')) {
            control.find('.selectBox-label').text(li.text());
        }

        // Update original control's value
        var i = 0, selection = [];
        if (select.attr('multiple')) {
            control.find('.selectBox-selected A').each(function () {
                selection[i++] = $(this).attr('rel');
            });
        } else {
            selection = li.find('A').attr('rel');
        }

        // Remember most recently selected item
        control.data('selectBox-last-selected', li);

        // Change callback
        if (select.val() !== selection) {
            select.val(selection);
            this.setLabel();
            select.trigger('change');
        }

        return true;
    };

    /**
     * Adds the hover class.
     *
     * @param {HTMLElement} li
     */
    SelectBox.prototype.addHover = function (li) {
        li = $(li);
        var select = $(this.selectElement)
            , control   = select.data('selectBox-control')
            , options = control.data('selectBox-options');

        options.find('.selectBox-hover').removeClass('selectBox-hover');
        li.addClass('selectBox-hover');
    };

    /**
     * Returns the original HTML select element.
     *
     * @returns {HTMLElement}
     */
    SelectBox.prototype.getSelectElement = function () {
        return this.selectElement;
    };

    /**
     * Remove the hover class.
     *
     * @param {HTMLElement} li
     */
    SelectBox.prototype.removeHover = function (li) {
        li = $(li);
        var select = $(this.selectElement)
            , control = select.data('selectBox-control')
            , options = control.data('selectBox-options');

        options.find('.selectBox-hover').removeClass('selectBox-hover');
    };

    /**
     * Checks if the widget is in the view.
     *
     * @param {jQuery}      li
     * @param {Boolean}     center
     */
    SelectBox.prototype.keepOptionInView = function (li, center) {
        if (!li || li.length === 0) {
            return;
        }

        var select = $(this.selectElement)
            , control     = select.data('selectBox-control')
            , options   = control.data('selectBox-options')
            , scrollBox = control.hasClass('selectBox-dropdown') ? options : options.parent()
            , top       = parseInt(li.offset().top -scrollBox.position().top)
            , bottom    = parseInt(top + li.outerHeight());

        if (center) {
            scrollBox.scrollTop(li.offset().top - scrollBox.offset().top + scrollBox.scrollTop() -
                (scrollBox.height() / 2));
        } else {
            if (top < 0) {
                scrollBox.scrollTop(li.offset().top - scrollBox.offset().top + scrollBox.scrollTop());
            }
            if (bottom > scrollBox.height()) {
                scrollBox.scrollTop((li.offset().top + li.outerHeight()) - scrollBox.offset().top +
                    scrollBox.scrollTop() - scrollBox.height());
            }
        }
    };

    /**
     * Handles the keyDown event.
     * Handles open/close and arrow key functionality
     *
     * @param {DOMEvent}    event
     */
    SelectBox.prototype.handleKeyDown = function (event) {
        var select = $(this.selectElement)
            , control        = select.data('selectBox-control')
            , options      = control.data('selectBox-options')
            , settings     = select.data('selectBox-settings')
            , totalOptions = 0, i = 0;

        if (control.hasClass('selectBox-disabled')) {
            return;
        }

        switch (event.keyCode) {
            case 8:
                // backspace
                event.preventDefault();
                this.typeSearch = '';
                break;
            case 9:
            // tab
            case 27:
                // esc
                this.hideMenus();
                this.removeHover();
                break;
            case 13:
                // enter
                if (control.hasClass('selectBox-menuShowing')) {
                    this.selectOption(options.find('LI.selectBox-hover:first'), event);
                    if (control.hasClass('selectBox-dropdown')) {
                        this.hideMenus();
                    }
                } else {
                    this.showMenu();
                }
                break;
            case 38:
            // up
            case 37:
                // left
                event.preventDefault();
                if (control.hasClass('selectBox-menuShowing')) {
                    var prev = options.find('.selectBox-hover').prev('LI');
                    totalOptions = options.find('LI:not(.selectBox-optgroup)').length;
                    i = 0;
                    while (prev.length === 0 || prev.hasClass('selectBox-disabled') ||
                        prev.hasClass('selectBox-optgroup')) {
                        prev = prev.prev('LI');
                        if (prev.length === 0) {
                            if (settings.loopOptions) {
                                prev = options.find('LI:last');
                            } else {
                                prev = options.find('LI:first');
                            }
                        }
                        if (++i >= totalOptions) {
                            break;
                        }
                    }
                    this.addHover(prev);
                    this.selectOption(prev, event);
                    this.keepOptionInView(prev);
                } else {
                    this.showMenu();
                }
                break;
            case 40:
            // down
            case 39:
                // right
                event.preventDefault();
                if (control.hasClass('selectBox-menuShowing')) {
                    var next = options.find('.selectBox-hover').next('LI');
                    totalOptions = options.find('LI:not(.selectBox-optgroup)').length;
                    i = 0;
                    while (0 === next.length || next.hasClass('selectBox-disabled') ||
                        next.hasClass('selectBox-optgroup')) {
                        next = next.next('LI');
                        if (next.length === 0) {
                            if (settings.loopOptions) {
                                next = options.find('LI:first');
                            } else {
                                next = options.find('LI:last');
                            }
                        }
                        if (++i >= totalOptions) {
                            break;
                        }
                    }
                    this.addHover(next);
                    this.selectOption(next, event);
                    this.keepOptionInView(next);
                } else {
                    this.showMenu();
                }
                break;
        }
    };

    /**
     * Handles the keyPress event.
     * Handles type-to-find functionality
     *
     * @param {DOMEvent}    event
     */
    SelectBox.prototype.handleKeyPress = function (event) {
        var select = $(this.selectElement)
            , control = select.data('selectBox-control')
            , options = control.data('selectBox-options')
            , self    = this;

        if (control.hasClass('selectBox-disabled')) {
            return;
        }

        switch (event.keyCode) {
            case 9:
            // tab
            case 27:
            // esc
            case 13:
            // enter
            case 38:
            // up
            case 37:
            // left
            case 40:
            // down
            case 39:
                // right
                // Don't interfere with the keydown event!
                break;
            default:
                // Type to find
                if (!control.hasClass('selectBox-menuShowing')) {
                    this.showMenu();
                }
                event.preventDefault();
                clearTimeout(this.typeTimer);
                this.typeSearch += String.fromCharCode(event.charCode || event.keyCode);
                options.find('A').each(function () {
                    if ($(this).text().substr(0, self.typeSearch.length).toLowerCase() === self.typeSearch.toLowerCase()) {
                        self.addHover($(this).parent());
                        self.selectOption($(this).parent(), event);
                        self.keepOptionInView($(this).parent());
                        return false;
                    }
                });
                // Clear after a brief pause
                this.typeTimer = setTimeout(function () {
                    self.typeSearch = '';
                }, 1000);
                break;
        }
    };

    /**
     * Enables the selectBox.
     */
    SelectBox.prototype.enable = function () {
        var select = $(this.selectElement);
        select.prop('disabled', false);
        var control = select.data('selectBox-control');
        if (!control) {
            return;
        }
        control.removeClass('selectBox-disabled');
    };

    /**
     * Disables the selectBox.
     */
    SelectBox.prototype.disable = function () {
        var select = $(this.selectElement);
        select.prop('disabled', true);
        var control = select.data('selectBox-control');
        if (!control) {
            return;
        }
        control.addClass('selectBox-disabled');
    };

    /**
     * Sets the current value.
     *
     * @param {String}      value
     */
    SelectBox.prototype.setValue = function (value) {
        var select = $(this.selectElement);
        select.val(value);
        value = select.val(); // IE9's select would be null if it was set with a non-exist options value

        if (null === value) { // So check it here and set it with the first option's value if possible
            value = select.children().first().val();
            select.val(value);
        }

        var control = select.data('selectBox-control');
        if (!control) {
            return;
        }

        var settings = select.data('selectBox-settings')
            , options = control.data('selectBox-options');

        // Update label
        this.setLabel();

        // Update control values
        options.find('.selectBox-selected').removeClass('selectBox-selected');
        options.find('A').each(function () {
            if (typeof(value) === 'object') {
                for (var i = 0; i < value.length; i++) {
                    if ($(this).attr('rel') == value[i]) {
                        $(this).parent().addClass('selectBox-selected');
                    }
                }
            } else {
                if ($(this).attr('rel') == value) {
                    $(this).parent().addClass('selectBox-selected');
                }
            }
        });

        if (settings.change) {
            settings.change.call(select);
        }
    };

    /**
     * Sets the option elements.
     *
     * @param {String|Object} options
     */
    SelectBox.prototype.setOptions = function (options) {
        var select = $(this.selectElement)
            , control = select.data('selectBox-control');

        switch (typeof(options)) {
            case 'string':
                select.html(options);
                break;
            case 'object':
                select.html('');
                for (var i in options) {
                    if (options[i] === null) {
                        continue;
                    }
                    if (typeof(options[i]) === 'object') {
                        var optgroup = $('<optgroup label="' + i + '" />');
                        for (var j in options[i]) {
                            optgroup.append('<option value="' + j + '">' + options[i][j] + '</option>');
                        }
                        select.append(optgroup);
                    } else {
                        var option = $('<option value="' + i + '">' + options[i] + '</option>');
                        select.append(option);
                    }
                }
                break;
        }

        if (control) {
            // Refresh the control
            this.refresh();
        }
    };

    /**
     * Disables the selection.
     *
     * @param {*} selector
     */
    SelectBox.prototype.disableSelection = function (selector) {
        $(selector).css('MozUserSelect', 'none').bind('selectstart', function (event) {
            event.preventDefault();
        });
    };

    /**
     * Generates the options.
     *
     * @param {jQuery} self
     * @param {jQuery} options
     */
    SelectBox.prototype.generateOptions = function (self, options) {
        var li = $('<li />'), a = $('<a />');
        li.addClass(self.attr('class'));
        li.data(self.data());
        a.attr('rel', self.val()).text(self.text());
        li.append(a);
        if (self.attr('disabled')) {
            li.addClass('selectBox-disabled');
        }
        if (self.attr('selected')) {
            li.addClass('selectBox-selected');
        }
        options.append(li);
    };

    /**
     * Extends the jQuery.fn object.
     */
    $.extend($.fn, {
        selectBox: function (method, options) {
            var selectBox;

            switch (method) {
                case 'control':
                    return $(this).data('selectBox-control');
                case 'settings':
                    if (!options) {
                        return $(this).data('selectBox-settings');
                    }
                    $(this).each(function () {
                        $(this).data('selectBox-settings', $.extend(true, $(this).data('selectBox-settings'), options));
                    });
                    break;
                case 'options':
                    // Getter
                    if (undefined === options) {
                        return $(this).data('selectBox-control').data('selectBox-options');
                    }
                    // Setter
                    $(this).each(function () {
                        if (selectBox = $(this).data('selectBox')) {
                            selectBox.setOptions(options);
                        }
                    });
                    break;
                case 'value':
                    // Empty string is a valid value
                    if (undefined === options) {
                        return $(this).val();
                    }
                    $(this).each(function () {
                        if (selectBox = $(this).data('selectBox')) {
                            selectBox.setValue(options);
                        }
                    });
                    break;
                case 'refresh':
                    $(this).each(function () {
                        if (selectBox = $(this).data('selectBox')) {
                            selectBox.refresh();
                        }
                    });
                    break;
                case 'enable':
                    $(this).each(function () {
                        if (selectBox = $(this).data('selectBox')) {
                            selectBox.enable(this);
                        }
                    });
                    break;
                case 'disable':
                    $(this).each(function () {
                        if (selectBox = $(this).data('selectBox')) {
                            selectBox.disable();
                        }
                    });
                    break;
                case 'destroy':
                    $(this).each(function () {
                        if (selectBox = $(this).data('selectBox')) {
                            selectBox.destroy();
                            $(this).data('selectBox', null);
                        }
                    });
                    break;
                case 'instance':
                    return $(this).data('selectBox');
                default:
                    $(this).each(function (idx, select) {
                        if (!$(select).data('selectBox')) {
                            $(select).data('selectBox', new SelectBox(select, method));
                        }
                    });
                    break;
            }
            return $(this);
        }
    });
})(jQuery);

/*
 * jQuery selectBox Default - For selecting the default label option
 *
 * v1.0
 *
 */
;(function ($) {
     /**
     * Returns the default class of the selected option.
     *
     * @returns {String}
     */
    SelectBox.prototype.getDefaultLabelClass = function () {
        var selected = $(this.selectElement).find('OPTION:first');
        return ('selectBox-label ' + (selected.attr('class') || '')).replace(/\s+$/, '');
    };

    SelectBox.prototype.getDefaultLabelText = function () {
        var selected = $(this.selectElement).find('OPTION:first');
        return selected.text() || '\u00A0';
    };

    /**
     * Sets the label.
     * This method uses the getDefaultLabelClass() and getDefaultLabelText() methods.
     */
    SelectBox.prototype.setDefaultLabel = function () {
        var select = $(this.selectElement);
        var control = select.data('selectBox-control');
        if (!control) {
            return;
        }
        control
            .find('.selectBox-label')
            .attr('class', this.getDefaultLabelClass())
            .text(this.getDefaultLabelText());
    };

    /**
     * Extends the jQuery.fn object.
     */
    $.extend($.fn, {
        selectBoxDefault: function (method, options) {

            switch (method) {
                case 'selectDefault':
                    $(this).each(function () {
                        if (selectBoxDefault = $(this).data('selectBox')) {
                            selectBoxDefault.setDefaultLabel();
                            selectBoxDefault.setValue(options);
                        }
                    });
                    break;
                default:
                    $(this).each(function (idx, select) {
                        if (!$(select).data('selectBox')) {
                            $(select).data('selectBox', new SelectBox(select, method));
                        }
                    });
                    break;
            }
            return $(this);
        }
    });
})(jQuery);
(function($) {
  // global settings object
  Drupal.ELB = {
    ui: {
      alt_class: "is-alternate", // global/_variables.scss:$alt,
      landing_class: "is-landing", // front/landing class based on home/mobile-home-formatter
      sticky_class: "is-sticky", // header sticky
      active_class: "js-active", // active states (menus), _variables.scss
      search_class: "is-search", // global/_variables.scss:$search,
      dark_nav_class: "is-dark-nav", // global/_variables.scss:$$dark-nav,
      back_top_duration: 800, // default scroll to top value, components/_scroll_to_top.scss
      back_top_distance: -50, // how far from top of page before showing "top" widget
      mq_state: {
        small_only: 'only screen and (max-width: 640px)',
        medium_only: 'only screen and (min-width:641px) and (max-width: 768px)',
        medium_up: 'only screen and (min-width:641px)',
        ipad_only_portrait: 'only screen and (min-width:768px) and (max-width: 1024px) and (orientation: portrait)',
        ipad_only_landscape: 'only screen and (min-width:768px) and (max-width: 1024px) and (orientation: landscape)',
        tablet_only_portrait: 'only screen and (min-width:800px) and (max-width: 1280px) and (orientation: portrait)',
        tablet_only_landscape: 'only screen and (min-width:800px) and (max-width: 1280px) and (orientation: landscape)'
      },
      nav_open: false,
      search_open: false,
      // we often need to get the header height for other calculations
      header_height: function() {
        // set a variable value here instead of constant lookup
        return $('#toolbar').height() + $('.page-header').outerHeight();
      },
      // we often need to get the sticky footer height for other calculations
      sticky_footer_height: function() {
        return $('.page-sticky-footer').height();
      },
      // Resize an element to the usable height of the window,
      // see home_formatter.js for implementation
      fullHeightElement: function($element, includeHeader) {
        // scope stickyFooterHeight
        var stickyFooterHeight = this.sticky_footer_height(),
          headerHeight = this.header_height();
        // return a throttle-able function (with args!) ready to be used in a .resize
        return _.throttle(function() {
          // start with window height, subtract admin toolbar height
          var windowHeight = $(window).height(),
            realWindowHeight = windowHeight - stickyFooterHeight,
            // minHeight = 700;
            minHeight = 650;
          if (includeHeader) {
            realWindowHeight = realWindowHeight - headerHeight;
          }
          // Set element to safe height unless it's below minHeight
          $element.height((realWindowHeight >= minHeight ? realWindowHeight : minHeight));
        }, 250);
      } // fullHeightElement()
    }, // ui
    getJSONCookie : function(cookieName) {
      return jQuery.parseJSON($.cookie(cookieName)) || {};
    },
    // Initiate all selectboxes
    applySelectBoxes: function() {
      $('select.selectbox, select.selectBox').selectBox().removeClass('selectbox');
    },
    // selectbox.js doesn't account for iOS when refreshing even though it does
    // when initing. Use this wrapper function instead of using .selectBox('refresh')
    // directly
    refreshSelectBoxes : function($selectBoxes) {
      $selectBoxes.each(function(){
        var control = $(this).data('selectBox-control');
        if (control && control.length) {
          $(this).selectBox('refresh');
        }
      });
    },
    waypointBottomOffset : function(element) {
      var $element = $(element);
      var contextHeight = $(window).height();
      if( $element.outerHeight() >  contextHeight){
        contextHeight = $element.outerHeight() - 200; //200 for minibag offset
      }
      return contextHeight - $element.outerHeight() - 200;
    },
    //
    // Helper function to return TRUE or FALSE based on whether the personalization engine is enabled.
    // We know this to be true or not based on personal_block being loaded in Drupal.settings.
    //
    hasPersonalization: function() {
      var settings        = Drupal || {};
          settings        = settings.settings || {};
          personalization = settings.personal_block;
      return personalization ? 1 : 0;
    },
    loadPersistenUserCookie: function() {
      var cookieName = 'persistent_user_cookie';
      var cookieVal = Drupal.ELB.getJSONCookie(cookieName);
      // These are the keys we want to copy out of FE_USER_CART:
      var cookieKeys = ['first_name', 'pc_email_optin', 'email', 'is_loyalty_member', 'points', 'loyalty_level', 'loyalty_level_name', 'points_to_next_level', 'next_level', 'next_level_name'];
      // Share accross desktop and mobile sites:
      var domain = '.' + window.location.hostname.replace(
        /^.*(esteelauder\.)/,
        function(m, $1) { return $1; }
      );

      // The jquery.cookie.js included in Drupal is from before this feature
      // existed :(
      // $.cookie.json = true;

      // User only gets one first time:
      if ($.isEmptyObject(cookieVal)) {
        cookieVal.first_time = 1;
      } else {
        cookieVal.first_time = 0;
      }

      // Prevent errors if user_info_cookie.js isn't found:
      if (typeof site != 'undefined' && typeof site.userInfoCookie != 'undefined') {
        // FE_USER_CART is not persistent, it gets emptied when the user signs
        // out. If the values in it update, we want to update our persistent
        // cookie as well, but if they're null we want what's in our cookie to
        // persist.
        var key, val;
        for (var i = 0; i < cookieKeys.length; i++) {
          key = cookieKeys[i];
          val = site.userInfoCookie.getValue(key);
          cookieVal[key] = val;
        }
      }

      $.cookie(cookieName, JSON.stringify(cookieVal), { expires: 365 * 5, path: '/', domain: domain });

      if(cookieVal.is_loyalty_member - 0) {
        // set global loyalty class for when user is enlisted in loyalty
        // used to controll footer state
        $('body').addClass('elc-user-state-loyalty');
      }else{
        // make sure class is not there for non-loyal
        $('body').removeClass('elc-user-state-loyalty');
      }

    }
  }; // Drupal.ELB

  // init page_data
  var page_data = page_data || {};

  Drupal.behaviors.ELB = {
    attach: function(context, settings) {
      //init
      Drupal.ELB.ui.mq = {
        small_only: Modernizr.mq(Drupal.ELB.ui.mq_state.small_only),
        medium_only: Modernizr.mq(Drupal.ELB.ui.mq_state.medium_only),
        medium_up: Modernizr.mq(Drupal.ELB.ui.mq_state.medium_up),
        ipad_only_portrait: Modernizr.mq(Drupal.ELB.ui.mq_state.ipad_only_portrait),
        ipad_only_landscape: Modernizr.mq(Drupal.ELB.ui.mq_state.ipad_only_landscape),
        tablet_only_portrait: Modernizr.mq(Drupal.ELB.ui.mq_state.tablet_only_portrait),
        tablet_only_landscape: Modernizr.mq(Drupal.ELB.ui.mq_state.tablet_only_landscape)
      };
      //resize
      $(window).resize(function(){
        Drupal.ELB.ui.mq = {
          small_only: Modernizr.mq(Drupal.ELB.ui.mq_state.small_only),
          medium_only: Modernizr.mq(Drupal.ELB.ui.mq_state.medium_only),
          medium_up: Modernizr.mq(Drupal.ELB.ui.mq_state.medium_up),
          ipad_only_portrait: Modernizr.mq(Drupal.ELB.ui.mq_state.ipad_only_portrait),
          ipad_only_landscape: Modernizr.mq(Drupal.ELB.ui.mq_state.ipad_only_landscape),
          tablet_only_portrait: Modernizr.mq(Drupal.ELB.ui.mq_state.tablet_only_portrait),
          tablet_only_landscape: Modernizr.mq(Drupal.ELB.ui.mq_state.tablet_only_landscape)
        };
      });
    } // attach
  };


  Drupal.behaviors.ELB_userState = {
    attach: function(context, settings) {
      var signedIn = typeof site != 'undefined';
      signedIn = signedIn && typeof site.userInfoCookie != 'undefined';
      signedIn = signedIn && parseInt(site.userInfoCookie.getValue('signed_in'), 10);
      var signInState = signedIn ? 'logged-in' : 'anonymous';
      $('body').addClass( 'elc-user-state-' + signInState );
    }
  };

  Drupal.behaviors.ELB_persistentUserCookie = {
    attach: function(context, settings) {
      Drupal.ELB.loadPersistenUserCookie();
    }
  };

  Drupal.behaviors.ELBPC_clientToggle = {
    attach: function (context, settings) {
      // wire device toggle links
      if(site && site.client && site.client.controls) {
        site.client.controls();
      }
    }
  };

  /**
   * Modernizr shivs and checks
   */
  Drupal.behaviors.ELB_shivs = {
    attach: function(context, settings) {
      // Modernizr.load({
      //   test: Modernizr.mq('only all'),
      //   nope: 'respond.min.js'
      // });
    }
  };


  /**
   * Mobile-pc navigation behaviors
   */
  Drupal.behaviors.ELBPC_nav = {
    attach: function(context, settings) {
      var $header = $('.page-header'),
      $footer = $('.page-footer'),
      activeclass = Drupal.ELB.ui.active_class;

      var mouseEventType = (Modernizr.touch) ? 'click' : 'mouseenter';

      // close nav on these elements:hover
      // var $navCloseElements = $('#main, .page-branding, .page-utilities, .page-footer, .level-1:not(.menu-trigger)');
      // constrain to page-header
      //var $navCloseElements = $('.page-branding, .page-utilities', $header);
      var $navCloseElements = $('.page-branding', $header);

      // When clicking away from nav header, close the nav header
      $('html').on('click', function() {
        // Trigger generic close event other things can hop onto
        $(document).trigger('navClose');
      });

      // Prevent header clicks from propagating to html tag
      $header.on('click', function(event) {
        event.stopPropagation();
      });

       // Clicking .menu-trigger menu headers (Makeup, Skinecare)
      $header.on(mouseEventType, '.menu-trigger', function(event) {
        event.preventDefault();

        // don't open if mouseenter and search is open
        if(mouseEventType == 'mouseenter' && Drupal.ELB.ui.search_open) {
          return;
        }
        // go all the way up the chain to the parent menu-reference
        var $major_section = $(this).parents('.menu-reference');

        // Major section toggling hide/showing, take into account mobile toggle
        if ($major_section.hasClass(activeclass) && Drupal.ELB.ui.mq.small_only) {
          $('.'+activeclass, $header).removeClass(activeclass);
        }
        // Specific iPad and tablet portrait only Major section toggling hide/showing, take into account mobile nav toggle
        else if ($major_section.hasClass(activeclass) && (Drupal.ELB.ui.mq.ipad_only_portrait || Drupal.ELB.ui.mq.tablet_only_portrait)) {
          $('.'+activeclass, $header).removeClass(activeclass);
        } else {
          $('.'+activeclass, $header).removeClass(activeclass);
          $major_section.addClass(activeclass);
        }

        // Get category class from array of css classes
        var trigger_class_split = $(this).attr('class').split(' ');
        // Ignore the standard drupal classes
        var ignoreThese = ['', 'active-trail', 'level-1', 'menu-trigger', 'leaf', 'last', 'expanded'];
        trigger_class_split = _.difference(trigger_class_split, ignoreThese);
        // Category class is most likely what is left
        var cat_class = trigger_class_split[0];
        // Trigger generic open event other things can hop onto
        $(document).trigger('navOpen', [cat_class]);
      });

      // close search, if open, on nav click
      // nav hover elements
      if(mouseEventType == 'mouseenter') {
        $header.on('click', '.menu-trigger', function(event) {
          event.preventDefault();
          if (Drupal.ELB.ui.search_open) {
            $(document).trigger('searchClose');
            //$(document).trigger('navOpen');
            $(this).trigger('mouseenter');
          }
        });
        // hover state for skincare make up fragrance renutriv sub nav elements
        $header.on('mouseenter', '.level-3', function(event) {
          event.preventDefault();
          if (!Drupal.ELB.ui.search_open && Drupal.ELB.ui.nav_open) {
            $(this).addClass('has-hover');
          }
        });
        $header.on('mouseleave', '.level-3', function(event) {
          event.preventDefault();
            if (!Drupal.ELB.ui.search_open && Drupal.ELB.ui.nav_open) {
              $(this).removeClass('has-hover');
            }
        });
        // hover state for nav elements with no menu-trigger
        $header.on('mouseenter', '.level-1:not(.menu-trigger)', function(event) {
          event.preventDefault();
          if (!Drupal.ELB.ui.search_open && Drupal.ELB.ui.nav_open) {
            $(this).addClass('has-hover');
          }
        });
        $header.on('mouseleave', '.level-1:not(.menu-trigger)', function(event) {
          event.preventDefault();
            if (!Drupal.ELB.ui.search_open && Drupal.ELB.ui.nav_open) {
              $(this).removeClass('has-hover');
            }
        });
        // hover state for Aerin sub nav elements
        $header.on('mouseenter', '.level-2 h3', function(event) {
          event.preventDefault();
          if (!Drupal.ELB.ui.search_open && Drupal.ELB.ui.nav_open) {
            $(this).addClass('has-hover');
          }
        });
        $header.on('mouseleave', '.level-2 h3', function(event) {
          event.preventDefault();
            if (!Drupal.ELB.ui.search_open && Drupal.ELB.ui.nav_open) {
              $(this).removeClass('has-hover');
            }
        });
      }

      // Mobile nav: Clicking submenus (Makeup > Face), toggle active state
      $header.on('click', '.depth-1 h3', function(event) {
        event.stopPropagation();
        var $sub_menu = $(this).parents('.menu-item-container');
        if (!$sub_menu.hasClass(activeclass)) {
          $('.menu-item-container', $header).removeClass(activeclass);
        }
        $sub_menu.toggleClass(activeclass);
      });
       // Menu toggle (X button)
      $header.on('click', '.page-navigation__menu-toggle', function(event) {
        var startingCat = 'makeup';
        // toggle header state
        if (Drupal.ELB.ui.nav_open) {
          $(document).trigger('navClose');
          if (generic.env.isIOS4) {
           $header.css({'top' : $(window).scrollTop()});
          }
        } else {
          $(document).trigger('searchClose');
          // $(document).trigger('navOpen', [startingCat]); // give a default cat
          $(document).trigger('navOpen'); // requested we remove starting cat, 180070
          // Edit, NOPE: 180070. Since we safely have a default cat, set js-active on it.
          // $('.menu-trigger.'+startingCat).parents('.menu-reference').addClass(activeclass);
        }
      });

      // back button
      var $mobileBackButton = $('.js-mobile-checkout-back', context);
      var pathArray = window.location.pathname.split( '/' );
      var mobileCheckout = (pathArray[1] === 'checkout');
      if (mobileCheckout) {
          if (!$('.checkout-confirmation-page').length && history.length > 1) {
              $mobileBackButton.removeClass('hidden');
          } else if($('.checkout-confirmation-page').length){
              $mobileBackButton.remove();
          }
      } else {
          $mobileBackButton.remove();
      }

      // $('.page-navigation__hotswap, page-navigation__supplemental',$header).on('mouseleave', function() {
          // event handling buggy, may be usefull as an additional check.
      // });

      // close nav on mousenter outside of .page-navigation__hotswap
      if(mouseEventType == 'mouseenter') {
        $navCloseElements.on('mouseenter', function() {
            if (!Drupal.ELB.ui.search_open) {
              $(document).trigger('navClose');
            }
            //$(document).trigger('searchClose');
        });
        $header.on('mouseleave', function() {
            if (!Drupal.ELB.ui.search_open) {
              $(document).trigger('navClose');
            }
        });
      }

      // Close nav on esc press
      $(document).keyup(function(e) {
        if (e.which === 27) {
          $(document).trigger('navClose');
          $(document).trigger('searchClose');
        }
      });

      /**
       * React to navOpen event
       */
      $(document).on('navOpen', function(event, category) {
        // add active header state class
        $header.addClass(Drupal.ELB.ui.alt_class);
        //$('html,body').addClass('noscroll');
        // hide footer if it is visible
        //if ($footer.is(':visible')) {
        //  $footer.fadeOut();
        //}
        // finally set global var
        Drupal.ELB.ui.nav_open = true;
        // do one little .resize() to trigger js layout recalcs
        $(window).resize();
         if (generic.env.isIOS4) {
           setTimeout(function(){
             navScroll.refresh();
           }, 500);
         }
      });
       /**
       * React to navClose event
       */
      $(document).on('navClose', function(event, category) {
        // remove active header class
        $header.removeClass(Drupal.ELB.ui.alt_class);
        //$('html,body').removeClass('noscroll');
        // remove menu active states
        $('.'+activeclass, $header).removeClass(activeclass);
        // specific footer handling
        $footer.fadeIn();
        // finally set global var
        Drupal.ELB.ui.nav_open = false;
      });

      $('.page-navigation .nav-tout').parents('.menu-item-container').addClass('menu-item-container--has-nav-tout').parents('.menu-container').addClass('menu-container').addClass('menu-container--has-nav-tout');

      // FE-959: ReNutriv image tout
      // The "nav-tout-3-cols" CSS class must be first added in the "Reference: Contentblock Menu Reference - V1" template item (node/30)
      var $menuRef = $('.page-navigation').find('.menu-reference');
      $menuRef.each(function () {
        var $self = $(this);
        if ($self.hasClass('nav-tout-3-cols')) {
          $('.nav-tout--3-cols.nav-tout').closest('div.menu-container').addClass('nav-tout-3-cols');
        }
      });

    } // attach
  }; // ELBPC_nav

  Drupal.behaviors.ELB_cartConfirm = {
    attach: function(context, settings) {
      if (typeof site.cartConfirm != 'undefined') {
        site.cartConfirm.init();
      }
      if (typeof site.offerConfirm != 'undefined') {
        site.offerConfirm.init();
      }
      $('.page-utilities__cart-button').click(function(event) {
        /* Act on the event */
        event.preventDefault();
        window.location.href = '/checkout/viewcart.tmpl';
      });
      var item_count = site.userInfoCookie.getValue('item_count');
      if(item_count > 0){
        $('.page-utilities__cart-count').html(item_count);
      }else{
        $('.page-utilities__cart-count').html('');
      }
    }
  };

  /**
   * Nav fixed position scroll behavior
   */
  Drupal.behaviors.ELB_headersticky = {
    attach: function(context, settings) {
      var $header = $('.page-header'),
        headerHeight = $header.height();
      // Only apply sticky header above mobile mq, because we sometimes demo
      // mobile behavior on a PC browser. THIS JS ONLY FIRES ON PC
      // if (!Drupal.ELB.ui.mq.small_only){

        var pathArray = window.location.pathname.split( '/' );
        var mobileCheckout = (pathArray[1] === 'checkout');
        var windowHeight = $(window).height();
        var pageHeight = $(document).height();
        if (pageHeight - headerHeight <= windowHeight) {
          // if making the header sticky would result in a smaller
          // document height then the window height it acts / shows weird
          // check /corp_info on CZ ticket GLCRR-52
          return;
        }
        if (mobileCheckout) {
            $header.addClass(Drupal.ELB.ui.sticky_class);
        } else {
            // waypoint module, once we hit the bottom of header, trigger
            $('body').waypoint(function(direction){
                $header.toggleClass(Drupal.ELB.ui.sticky_class);
            }, {
              offset: function(){
                return -headerHeight;
              }
            }); // waypoint
        }

      // } // if mq.small_only
    } // attach
  };

  Drupal.behaviors.ELB_userState = {
    attach: function(context, settings) {
      var signedIn = typeof site != 'undefined';
      signedIn = signedIn && typeof site.userInfoCookie != 'undefined';
      signedIn = signedIn && parseInt(site.userInfoCookie.getValue('signed_in'), 10);
      var signInState = signedIn ? 'logged-in' : 'anonymous';
      $('body').addClass( 'elc-user-state-' + signInState );
    }
  };

  Drupal.behaviors.ELB_persistentUserCookie = {
    attach: function(context, settings) {
      var cookieName = 'persistent_user_cookie';
      var cookieVal = Drupal.ELB.getJSONCookie(cookieName);
      // These are the keys we want to copy out of FE_USER_CART:
      var cookieKeys = ['first_name', 'pc_email_optin', 'email'];
      // Share accross desktop and mobile sites:
      var domain = '.' + window.location.hostname.replace(
        /^.*(esteelauder\.)/,
        function(m, $1) { return $1; }
      );

      // The jquery.cookie.js included in Drupal is from before this feature
      // existed :(
      // $.cookie.json = true;

      // User only gets one first time:
      if ($.isEmptyObject(cookieVal)) {
        cookieVal.first_time = 1;
      } else {
        cookieVal.first_time = 0;
      }

      // Prevent errors if user_info_cookie.js isn't found:
      if (typeof site != 'undefined' && typeof site.userInfoCookie != 'undefined') {
        // FE_USER_CART is not persistent, it gets emptied when the user signs
        // out. If the values in it update, we want to update our persistent
        // cookie as well, but if they're null we want what's in our cookie to
        // persist.
        var key, val;
        for (var i = 0; i < cookieKeys.length; i++) {
          key = cookieKeys[i];
          val = site.userInfoCookie.getValue(key);
          if (!cookieVal[key] || (typeof val != 'undefined' && val !== null && val != 'null')) {
            cookieVal[key] = val;
          }
        }
      }

      $.cookie(cookieName, JSON.stringify(cookieVal), { expires: 365 * 5, path: '/', domain: domain });
    }
  };

  Drupal.behaviors.ELBPC_clientToggle = {
    attach: function (context, settings) {
      // wire device toggle links
      if(site && site.client && site.client.controls) {
        site.client.controls();
      }
    }
  };

  /**
   * Modernizr shivs and checks
   */
  Drupal.behaviors.ELB_shivs = {
    attach: function(context, settings) {
      // Modernizr.load({
      //   test: Modernizr.mq('only all'),
      //   nope: 'respond.min.js'
      // });
    }
  };

  /**
   * Move submenus into .page-navigation__hotswap when the nav is opened
   */
  Drupal.behaviors.ELBPC_nav_hotswap = {
    attach: function(context, settings) {
      var $hotswap = $('.page-navigation__hotswap');

      // hop on navOpen event
      $(document).on('navOpen', function(event, category) {
        // clear out our "landing area"
        $hotswap.empty();
        // only trigger this "hotswap" container behavior ABOVE mobile
        if (!Drupal.ELB.ui.mq.small_only){
          // clone our subnav in prep for positioning, category is emmitted with event
          var $subnav = $('.'+category).next('.depth-1').clone(),
            // holding var for child elements
            $subnav_children = $('.menu-item-container', $subnav),
            // count of subnav elements
            sliceafter = 8;

          // Break apart ULs longer than 7 (according to comps)
          $subnav_children.each(function(){
            // When subnav longer than 7 li's
            if ($('.depth-2 li', $(this)).length > sliceafter) {
              // Make new ul
              $menucol = $('<ul class="menu menu-column"></ul>');
              // Rip out all lis after 7
              $('.depth-2 li', $(this)).slice(sliceafter).appendTo($menucol);
              // UL's are now side by side
              $('.depth-2', $(this)).append($menucol);
            }
          });

          // put a count on the elements to help sizing columns
          $subnav_children.addClass('menu-item-container--childcount-' + $subnav_children.length);
          // place
          $subnav.appendTo($hotswap);
          $('.page-navigation').addClass('is_animated');
        }
      }); //.on('navOpen')

    $(document).on('navClose', function(event, category) {
      // clear hotswap
      $hotswap.empty();
      // pause animation for quick access to other navs
      setTimeout(function(){
        if (!Drupal.ELB.ui.nav_open) {
          $('.page-navigation').removeClass('is_animated');
        }
      }, 300);
    }); //.on('navClose')

    } // attach
  }; // ELBBPC_nav_hotswap

  /**
   * Sticky footer behaviors
   */
  Drupal.behaviors.ELB_stickyFooter = {
    attach: function(context, settings) {
      var $footer = $('.page-footer', context);
      var $stickyFooter = $('.page-sticky-footer', context);
      var $promos = $('.promo-messages', $stickyFooter).children();
      var offset = 0;
      var stickyFooterHeight = $stickyFooter.height();
      var promoIndex = -1;

      // footer tablet
      var $ResponsiveFooter = $('.responsive-footer', context);
      var $ResponsiveFooterInner = $('.page-sticky-footer__right__inner', context);
      var $ResponsiveFooterLeft = $('.page-sticky-footer__left', context);
      var $TabletFooter = $('.tablet-footer', context);
      var $TabletFooterSticky = $('.page-sticky-footer__mobile__inner', context);

      if (!$footer.length) {
        return;
      }

      function _setStickyClass() {
        $stickyFooter.toggleClass( 'is-sticky', $(window).scrollTop() < offset );
      }

      function _setOffset() {
        offset = $footer.offset().top - $(window).height() + stickyFooterHeight;
        _setStickyClass();
      }

      function _fadePromos() {
        ++promoIndex;
        $promos.eq(promoIndex % $promos.length).fadeIn(300).delay(5000).fadeOut(500, _fadePromos);
      }

      $(window).scroll(_setOffset).resize(_setOffset);

      _setOffset();
      // Use a timeout to ensure this is run after other scripts set their dimensions
      setTimeout(_setOffset, 60);

      if ($promos.length > 1) {
        _fadePromos();
      }


      var $TabletFooterCheck = $TabletFooter.contents().length;

      if (($TabletFooterCheck > 1) && (Drupal.ELB.ui.mq.ipad_only_portrait || Drupal.ELB.ui.mq.tablet_only_portrait)) {

        $ResponsiveFooter.addClass('hidden');
        $ResponsiveFooterInner.addClass('hidden');
        $ResponsiveFooterLeft.addClass('hidden');
        $TabletFooterSticky.removeClass('hidden');
        $TabletFooter.removeClass('hidden');


        $(window).on('orientationchange', function(event) {
          $ResponsiveFooter.toggleClass('hidden');
          $ResponsiveFooterInner.toggleClass('hidden');
          $ResponsiveFooterLeft.toggleClass('hidden');
          $TabletFooter.toggleClass('hidden');
          $TabletFooterSticky.toggleClass('hidden');
        });

       } else if (($TabletFooterCheck > 1) && (Drupal.ELB.ui.mq.ipad_only_landscape || Drupal.ELB.ui.mq.tablet_only_landscape)){

       $TabletFooter.addClass('hidden');
       $TabletFooterSticky.addClass('hidden');
       $ResponsiveFooter.removeClass('hidden');
       $ResponsiveFooterInner.removeClass('hidden');
       $ResponsiveFooterLeft.removeClass('hidden');

       $(window).on('orientationchange', function(event) {
         $TabletFooter.toggleClass('hidden');
         $TabletFooterSticky.toggleClass('hidden');
         $ResponsiveFooter.toggleClass('hidden');
         $ResponsiveFooterInner.toggleClass('hidden');
         $ResponsiveFooterLeft.toggleClass('hidden');
       });

       } else {
         $TabletFooter.remove();
         $TabletFooterSticky.remove();
       }
      // footer tablet


    }
  };

  Drupal.behaviors.ELB_mp_translate = {
    attach: function(context, settings) {
      window.MP = {
        Version: '1.0.23',
        // Domains: {'es':'stage3espanol.esteelauder.com', 'fr':'stagefrancais.esteelauder.ca'},
        Domains: {
          'es': 'espanol.esteelauder.com',
          'fr': 'francais.esteelauder.ca'
        },
        SrcLang: 'en',
        UrlLang: 'mp_js_current_lang',
        SrcUrl: decodeURIComponent('mp_js_orgin_url'),
        init: function(){
          if (MP.UrlLang.indexOf('p_js_')==1) {
            MP.SrcUrl=window.top.document.location.href;
            MP.UrlLang=MP.SrcLang;
          }
        },
        getCookie: function(name){
          var start=document.cookie.indexOf(name+'=');
          if(start < 0) return null;
          start=start+name.length+1;
          var end=document.cookie.indexOf(';', start);
          if(end < 0) end=document.cookie.length;
          while (document.cookie.charAt(start)==' '){ start++; }
          return decodeURIComponent(document.cookie.substring(start,end));
        },
        setCookie: function(name,value,path,domain){
          var cookie=name+'='+encodeURIComponent(value);
          if(path)cookie+='; path='+path;
          if(domain)cookie+='; domain='+domain;
          var now=new Date();
          now.setTime(now.getTime()+1000*60*60*24*365);
          cookie+='; expires='+now.toUTCString();
          document.cookie=cookie;
        },
        switchLanguage: function(lang){
          var script;
          if (lang!=MP.SrcLang){
            script=document.createElement('SCRIPT');
            script.src=location.protocol+'//'+MP.Domains[lang]+'/'+MP.SrcLang+lang+'/?1023749632;'+encodeURIComponent(MP.SrcUrl);
            document.body.appendChild(script);
          } else if(lang==MP.SrcLang && MP.UrlLang!=MP.SrcLang){
            script=document.createElement('SCRIPT');
            script.src=location.protocol+'//'+MP.Domains[MP.UrlLang]+'/'+MP.SrcLang+MP.UrlLang+'/?1023749634;'+encodeURIComponent(location.href);
            document.body.appendChild(script);
          }
          return false;
        },
        switchToLang: function(url) {
          window.top.location.href=url;
        }
      };

      function switchLanguage(lang) {
        MP.SrcUrl=decodeURIComponent('mp_js_orgin_url');
        MP.UrlLang = lang !== 'en' ? 'mp_js_current_lang' : MP.getCookie('MP_LANG');
        MP.init();
        MP.switchLanguage(MP.UrlLang==lang?'en':lang);
        return false;
      }

      $('.switch-lang-link').on('click', function(event) {
        event.preventDefault();
        return switchLanguage( $(this).attr('data-mp-lang') );
      });
    }
  };

  /**
   * product CTA quickshop
   */
  Drupal.behaviors.ELB_CTA_quickshop = {
    attach: function(context, settings) {

      if(!_.isUndefined(page_data['cta-mpp'])){
        var quickData = page_data['custom-mpp'].products;
        var $btn_quickshop = $('.action-quickview');
        $btn_quickshop.click(function(e) {
          e.preventDefault();
          var quickshopPID = $(this).attr('data-productid');
          var quickshopData = _.find(quickData, function(p){ return p.PRODUCT_ID == quickshopPID; });
          site.quickshop(quickshopData);
        });
      }

    }
  };

  /**
   * Add a class to checkout pages for a different nav bar
   */
  Drupal.behaviors.checkout_theme = {
    attach: function(context, settings) {
      var pathArray = window.location.pathname.split( '/' );
      // Show a minimal nav throughout checkout, except for the viewcart page and samples pages.
      if (pathArray[1] === 'checkout' && !(pathArray[2] === 'viewcart.tmpl' || pathArray[2] === 'samples.tmpl' || pathArray[2] === 'gwp_samples.tmpl' || pathArray[2] === 'wp_samples.tmpl')) {
        $('body').addClass('is-min-nav');
      } else if (pathArray[1] === 'checkout' && (pathArray[2] === 'viewcart.tmpl' || pathArray[2] === 'samples.tmpl' || pathArray[2] === 'gwp_samples.tmpl' || pathArray[2] === 'wp_samples.tmpl')) {
        $('body').addClass('has-mobile-checkout-nav');
      }
    } // attach
  };

  /**
   * estee edit moodboard slideshow overlay launcher
   */
  Drupal.behaviors.mb_slideshow = {
    attach: function(context, settings) {
      if (!$('.formatter-mb-slideshow').length) return;
      // share link vars
      var url = document.documentURI;
      var title = document.title;

      var twitter_url = 'http://twitter.com/intent/tweet?url=' + encodeURI(url) + '&amp;text=' + encodeURI(title) + '&amp;via=EsteeLauder';
      $('.mb-slide-share__link.twitter').attr('href', twitter_url);

      var facebook_url = 'http://www.facebook.com/sharer.php?u=' + encodeURI(url) + '&amp;t=' + encodeURI(title);
      $('.mb-slide-share__link.facebook').attr('href', facebook_url);

      // @todo debug this is grabbing the first image/first slide only
      var img = $('.mb-slideshow__slide img').attr("src");
      var pinterest_url = 'http://pinterest.com/pin/create/button/?url=' + encodeURI(url) + '&amp;media=' + encodeURI(window.location.protocol) + '//' + encodeURI(window.location.host) + img + '&amp;description=' + encodeURI(title);
      $('.mb-slide-share__link.pinterest').attr('href', pinterest_url);

      // launch colorbox slideshow and oncomplete add what we need
      $('.mb-slides-launcher').colorbox({
        width: '100%',
        height: '100%',
        fixed: true,
        transition: 'none',
        speed: 0,
        className: 'colorbox__mb-slides',
        href: function() { return this.href + ' #main';},
        onOpen: function() {
          $(document).trigger('elc_colorboxOpen');
        },
        onClosed: function() {
          $(document).trigger('elc_colorboxClosed');
        },
        onComplete:function(){
          $('.formatter-mb-slideshow .flexslider').flexslider({
            animation: "fade",
            slideshow: false,
            controlNav: false
          });
          $('.mb-slide-share__link.twitter').attr('href', twitter_url);
          $('.mb-slide-share__link.facebook').attr('href', facebook_url);

          // Each slide inside the colorbox needs to have that image associated with it's pinterest share. All social links (Pinterest included) just need the URL from the main page.
          $('.colorbox__mb-slides .mb-slideshow__slide').each(function(i) {
            var img = $(this).find('.mb-slideshow__slide__image').attr("src");
            var pinterest_url = 'http://pinterest.com/pin/create/button/?url=' + encodeURI(url) + '&amp;media=' + encodeURI(window.location.protocol) + '//' + encodeURI(window.location.host) + img + '&amp;description=' + encodeURI(title);
            $(this).find('.mb-slide-share__link.pinterest').attr('href', pinterest_url);
          });
        }
        });

      // responsive colorbox
      $( window ).resize(function() {
        if($('#cboxOverlay').is(':visible')){
          $.colorbox.resize({width:'100%',height:'100%'});
        }
      });

      // apply flexslider to the main node for previewing purposes
      if( $('.formatter-mb-slideshow .flexslider').length > 0 ){
        $('.formatter-mb-slideshow .flexslider').flexslider({
          animation: "fade",
          slideshow: false,
          controlNav: false
        });
      }
    } // attach
  };
  /**
   * Print this page
   */
  Drupal.behaviors.ELB_printPage = {
    attach: function(context, settings) {
      var $trigger = $('.print-link');
      $trigger.on('click', function(e) {
        e.preventDefault();
        window.print();
      });
    } // attach
  };

  /**
   * Colorbox Common Events
   */
  Drupal.behaviors.colorbox_events = {
    attach: function(context, settings) {

      $(document).on('elc_colorboxOpen', function(event, category) {
        $('body').addClass('colorbox-on');
      });
      $(document).on('elc_colorboxClosed', function(event, category) {
        $('body').removeClass('colorbox-on');
      });
    } // attach
  };

  Drupal.behaviors.ELB_fileUpload = {
    attach: function(context, settings) {
      var $uploadContainers = $('.upload-file', context);
      $uploadContainers.each(function() {
        var $fileInput = $('input[type=file]', this);
        var $fileInputImposterVal = $('.upload-file__value', this);
        if (!$fileInput.length || !$fileInputImposterVal.length) return;
        $fileInput.on('change', function(event) {
          $fileInputImposterVal.text( $(this).val().replace('C:\\fakepath\\', '') );
        });
      });
    }
  };

  Drupal.behaviors.esteelauder_common = {
    attach: function(context, settings) {
      // open multi use hero custom link in a new tab if wrapper class .custom-link-target-blank is found
      $('.custom-link-target-blank').each(function(e) {
        $(this).find('.hero-block__custom-link').attr('target','_blank');
      });
    }
  };
})(jQuery);

// Adds User Agent string as data attribute on <html> needed mainly for IE8 ~ http://css-tricks.com/ie-10-specific-styles/
var doc = document.documentElement;
doc.setAttribute('data-useragent', navigator.userAgent);

/* Modernizr 2.7.0 (Custom Build) | MIT & BSD
 * Build: http://modernizr.com/download/#-fontface-backgroundsize-borderimage-borderradius-boxshadow-flexbox-flexboxlegacy-hsla-multiplebgs-opacity-rgba-textshadow-cssanimations-csscolumns-generatedcontent-cssgradients-cssreflections-csstransforms-csstransforms3d-csstransitions-applicationcache-canvas-canvastext-draganddrop-hashchange-history-audio-video-indexeddb-input-inputtypes-localstorage-postmessage-sessionstorage-websockets-websqldatabase-webworkers-geolocation-inlinesvg-smil-svg-svgclippaths-touch-webgl-shiv-mq-cssclasses-teststyles-testprop-testallprops-hasevent-prefixes-domprefixes-load
 */
;window.Modernizr=function(a,b,c){function D(a){j.cssText=a}function E(a,b){return D(n.join(a+";")+(b||""))}function F(a,b){return typeof a===b}function G(a,b){return!!~(""+a).indexOf(b)}function H(a,b){for(var d in a){var e=a[d];if(!G(e,"-")&&j[e]!==c)return b=="pfx"?e:!0}return!1}function I(a,b,d){for(var e in a){var f=b[a[e]];if(f!==c)return d===!1?a[e]:F(f,"function")?f.bind(d||b):f}return!1}function J(a,b,c){var d=a.charAt(0).toUpperCase()+a.slice(1),e=(a+" "+p.join(d+" ")+d).split(" ");return F(b,"string")||F(b,"undefined")?H(e,b):(e=(a+" "+q.join(d+" ")+d).split(" "),I(e,b,c))}function K(){e.input=function(c){for(var d=0,e=c.length;d<e;d++)u[c[d]]=c[d]in k;return u.list&&(u.list=!!b.createElement("datalist")&&!!a.HTMLDataListElement),u}("autocomplete autofocus list placeholder max min multiple pattern required step".split(" ")),e.inputtypes=function(a){for(var d=0,e,f,h,i=a.length;d<i;d++)k.setAttribute("type",f=a[d]),e=k.type!=="text",e&&(k.value=l,k.style.cssText="position:absolute;visibility:hidden;",/^range$/.test(f)&&k.style.WebkitAppearance!==c?(g.appendChild(k),h=b.defaultView,e=h.getComputedStyle&&h.getComputedStyle(k,null).WebkitAppearance!=="textfield"&&k.offsetHeight!==0,g.removeChild(k)):/^(search|tel)$/.test(f)||(/^(url|email)$/.test(f)?e=k.checkValidity&&k.checkValidity()===!1:e=k.value!=l)),t[a[d]]=!!e;return t}("search tel url email datetime date month week time datetime-local number range color".split(" "))}var d="2.7.0",e={},f=!0,g=b.documentElement,h="modernizr",i=b.createElement(h),j=i.style,k=b.createElement("input"),l=":)",m={}.toString,n=" -webkit- -moz- -o- -ms- ".split(" "),o="Webkit Moz O ms",p=o.split(" "),q=o.toLowerCase().split(" "),r={svg:"http://www.w3.org/2000/svg"},s={},t={},u={},v=[],w=v.slice,x,y=function(a,c,d,e){var f,i,j,k,l=b.createElement("div"),m=b.body,n=m||b.createElement("body");if(parseInt(d,10))while(d--)j=b.createElement("div"),j.id=e?e[d]:h+(d+1),l.appendChild(j);return f=["&#173;",'<style id="s',h,'">',a,"</style>"].join(""),l.id=h,(m?l:n).innerHTML+=f,n.appendChild(l),m||(n.style.background="",n.style.overflow="hidden",k=g.style.overflow,g.style.overflow="hidden",g.appendChild(n)),i=c(l,a),m?l.parentNode.removeChild(l):(n.parentNode.removeChild(n),g.style.overflow=k),!!i},z=function(b){var c=a.matchMedia||a.msMatchMedia;if(c)return c(b).matches;var d;return y("@media "+b+" { #"+h+" { position: absolute; } }",function(b){d=(a.getComputedStyle?getComputedStyle(b,null):b.currentStyle)["position"]=="absolute"}),d},A=function(){function d(d,e){e=e||b.createElement(a[d]||"div"),d="on"+d;var f=d in e;return f||(e.setAttribute||(e=b.createElement("div")),e.setAttribute&&e.removeAttribute&&(e.setAttribute(d,""),f=F(e[d],"function"),F(e[d],"undefined")||(e[d]=c),e.removeAttribute(d))),e=null,f}var a={select:"input",change:"input",submit:"form",reset:"form",error:"img",load:"img",abort:"img"};return d}(),B={}.hasOwnProperty,C;!F(B,"undefined")&&!F(B.call,"undefined")?C=function(a,b){return B.call(a,b)}:C=function(a,b){return b in a&&F(a.constructor.prototype[b],"undefined")},Function.prototype.bind||(Function.prototype.bind=function(b){var c=this;if(typeof c!="function")throw new TypeError;var d=w.call(arguments,1),e=function(){if(this instanceof e){var a=function(){};a.prototype=c.prototype;var f=new a,g=c.apply(f,d.concat(w.call(arguments)));return Object(g)===g?g:f}return c.apply(b,d.concat(w.call(arguments)))};return e}),s.flexbox=function(){return J("flexWrap")},s.flexboxlegacy=function(){return J("boxDirection")},s.canvas=function(){var a=b.createElement("canvas");return!!a.getContext&&!!a.getContext("2d")},s.canvastext=function(){return!!e.canvas&&!!F(b.createElement("canvas").getContext("2d").fillText,"function")},s.webgl=function(){return!!a.WebGLRenderingContext},s.touch=function(){var c;return"ontouchstart"in a||a.DocumentTouch&&b instanceof DocumentTouch?c=!0:y(["@media (",n.join("touch-enabled),("),h,")","{#modernizr{top:9px;position:absolute}}"].join(""),function(a){c=a.offsetTop===9}),c},s.geolocation=function(){return"geolocation"in navigator},s.postmessage=function(){return!!a.postMessage},s.websqldatabase=function(){return!!a.openDatabase},s.indexedDB=function(){return!!J("indexedDB",a)},s.hashchange=function(){return A("hashchange",a)&&(b.documentMode===c||b.documentMode>7)},s.history=function(){return!!a.history&&!!history.pushState},s.draganddrop=function(){var a=b.createElement("div");return"draggable"in a||"ondragstart"in a&&"ondrop"in a},s.websockets=function(){return"WebSocket"in a||"MozWebSocket"in a},s.rgba=function(){return D("background-color:rgba(150,255,150,.5)"),G(j.backgroundColor,"rgba")},s.hsla=function(){return D("background-color:hsla(120,40%,100%,.5)"),G(j.backgroundColor,"rgba")||G(j.backgroundColor,"hsla")},s.multiplebgs=function(){return D("background:url(https://),url(https://),red url(https://)"),/(url\s*\(.*?){3}/.test(j.background)},s.backgroundsize=function(){return J("backgroundSize")},s.borderimage=function(){return J("borderImage")},s.borderradius=function(){return J("borderRadius")},s.boxshadow=function(){return J("boxShadow")},s.textshadow=function(){return b.createElement("div").style.textShadow===""},s.opacity=function(){return E("opacity:.55"),/^0.55$/.test(j.opacity)},s.cssanimations=function(){return J("animationName")},s.csscolumns=function(){return J("columnCount")},s.cssgradients=function(){var a="background-image:",b="gradient(linear,left top,right bottom,from(#9f9),to(white));",c="linear-gradient(left top,#9f9, white);";return D((a+"-webkit- ".split(" ").join(b+a)+n.join(c+a)).slice(0,-a.length)),G(j.backgroundImage,"gradient")},s.cssreflections=function(){return J("boxReflect")},s.csstransforms=function(){return!!J("transform")},s.csstransforms3d=function(){var a=!!J("perspective");return a&&"webkitPerspective"in g.style&&y("@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}",function(b,c){a=b.offsetLeft===9&&b.offsetHeight===3}),a},s.csstransitions=function(){return J("transition")},s.fontface=function(){var a;return y('@font-face {font-family:"font";src:url("https://")}',function(c,d){var e=b.getElementById("smodernizr"),f=e.sheet||e.styleSheet,g=f?f.cssRules&&f.cssRules[0]?f.cssRules[0].cssText:f.cssText||"":"";a=/src/i.test(g)&&g.indexOf(d.split(" ")[0])===0}),a},s.generatedcontent=function(){var a;return y(["#",h,"{font:0/0 a}#",h,':after{content:"',l,'";visibility:hidden;font:3px/1 a}'].join(""),function(b){a=b.offsetHeight>=3}),a},s.video=function(){var a=b.createElement("video"),c=!1;try{if(c=!!a.canPlayType)c=new Boolean(c),c.ogg=a.canPlayType('video/ogg; codecs="theora"').replace(/^no$/,""),c.h264=a.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/,""),c.webm=a.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/,"")}catch(d){}return c},s.audio=function(){var a=b.createElement("audio"),c=!1;try{if(c=!!a.canPlayType)c=new Boolean(c),c.ogg=a.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/,""),c.mp3=a.canPlayType("audio/mpeg;").replace(/^no$/,""),c.wav=a.canPlayType('audio/wav; codecs="1"').replace(/^no$/,""),c.m4a=(a.canPlayType("audio/x-m4a;")||a.canPlayType("audio/aac;")).replace(/^no$/,"")}catch(d){}return c},s.localstorage=function(){try{return localStorage.setItem(h,h),localStorage.removeItem(h),!0}catch(a){return!1}},s.sessionstorage=function(){try{return sessionStorage.setItem(h,h),sessionStorage.removeItem(h),!0}catch(a){return!1}},s.webworkers=function(){return!!a.Worker},s.applicationcache=function(){return!!a.applicationCache},s.svg=function(){return!!b.createElementNS&&!!b.createElementNS(r.svg,"svg").createSVGRect},s.inlinesvg=function(){var a=b.createElement("div");return a.innerHTML="<svg/>",(a.firstChild&&a.firstChild.namespaceURI)==r.svg},s.smil=function(){return!!b.createElementNS&&/SVGAnimate/.test(m.call(b.createElementNS(r.svg,"animate")))},s.svgclippaths=function(){return!!b.createElementNS&&/SVGClipPath/.test(m.call(b.createElementNS(r.svg,"clipPath")))};for(var L in s)C(s,L)&&(x=L.toLowerCase(),e[x]=s[L](),v.push((e[x]?"":"no-")+x));return e.input||K(),e.addTest=function(a,b){if(typeof a=="object")for(var d in a)C(a,d)&&e.addTest(d,a[d]);else{a=a.toLowerCase();if(e[a]!==c)return e;b=typeof b=="function"?b():b,typeof f!="undefined"&&f&&(g.className+=" "+(b?"":"no-")+a),e[a]=b}return e},D(""),i=k=null,function(a,b){function l(a,b){var c=a.createElement("p"),d=a.getElementsByTagName("head")[0]||a.documentElement;return c.innerHTML="x<style>"+b+"</style>",d.insertBefore(c.lastChild,d.firstChild)}function m(){var a=s.elements;return typeof a=="string"?a.split(" "):a}function n(a){var b=j[a[h]];return b||(b={},i++,a[h]=i,j[i]=b),b}function o(a,c,d){c||(c=b);if(k)return c.createElement(a);d||(d=n(c));var g;return d.cache[a]?g=d.cache[a].cloneNode():f.test(a)?g=(d.cache[a]=d.createElem(a)).cloneNode():g=d.createElem(a),g.canHaveChildren&&!e.test(a)&&!g.tagUrn?d.frag.appendChild(g):g}function p(a,c){a||(a=b);if(k)return a.createDocumentFragment();c=c||n(a);var d=c.frag.cloneNode(),e=0,f=m(),g=f.length;for(;e<g;e++)d.createElement(f[e]);return d}function q(a,b){b.cache||(b.cache={},b.createElem=a.createElement,b.createFrag=a.createDocumentFragment,b.frag=b.createFrag()),a.createElement=function(c){return s.shivMethods?o(c,a,b):b.createElem(c)},a.createDocumentFragment=Function("h,f","return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&("+m().join().replace(/[\w\-]+/g,function(a){return b.createElem(a),b.frag.createElement(a),'c("'+a+'")'})+");return n}")(s,b.frag)}function r(a){a||(a=b);var c=n(a);return s.shivCSS&&!g&&!c.hasCSS&&(c.hasCSS=!!l(a,"article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}mark{background:#FF0;color:#000}template{display:none}")),k||q(a,c),a}var c="3.7.0",d=a.html5||{},e=/^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i,f=/^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i,g,h="_html5shiv",i=0,j={},k;(function(){try{var a=b.createElement("a");a.innerHTML="<xyz></xyz>",g="hidden"in a,k=a.childNodes.length==1||function(){b.createElement("a");var a=b.createDocumentFragment();return typeof a.cloneNode=="undefined"||typeof a.createDocumentFragment=="undefined"||typeof a.createElement=="undefined"}()}catch(c){g=!0,k=!0}})();var s={elements:d.elements||"abbr article aside audio bdi canvas data datalist details dialog figcaption figure footer header hgroup main mark meter nav output progress section summary template time video",version:c,shivCSS:d.shivCSS!==!1,supportsUnknownElements:k,shivMethods:d.shivMethods!==!1,type:"default",shivDocument:r,createElement:o,createDocumentFragment:p};a.html5=s,r(b)}(this,b),e._version=d,e._prefixes=n,e._domPrefixes=q,e._cssomPrefixes=p,e.mq=z,e.hasEvent=A,e.testProp=function(a){return H([a])},e.testAllProps=J,e.testStyles=y,g.className=g.className.replace(/(^|\s)no-js(\s|$)/,"$1$2")+(f?" js "+v.join(" "):""),e}(this,this.document),function(a,b,c){function d(a){return"[object Function]"==o.call(a)}function e(a){return"string"==typeof a}function f(){}function g(a){return!a||"loaded"==a||"complete"==a||"uninitialized"==a}function h(){var a=p.shift();q=1,a?a.t?m(function(){("c"==a.t?B.injectCss:B.injectJs)(a.s,0,a.a,a.x,a.e,1)},0):(a(),h()):q=0}function i(a,c,d,e,f,i,j){function k(b){if(!o&&g(l.readyState)&&(u.r=o=1,!q&&h(),l.onload=l.onreadystatechange=null,b)){"img"!=a&&m(function(){t.removeChild(l)},50);for(var d in y[c])y[c].hasOwnProperty(d)&&y[c][d].onload()}}var j=j||B.errorTimeout,l=b.createElement(a),o=0,r=0,u={t:d,s:c,e:f,a:i,x:j};1===y[c]&&(r=1,y[c]=[]),"object"==a?l.data=c:(l.src=c,l.type=a),l.width=l.height="0",l.onerror=l.onload=l.onreadystatechange=function(){k.call(this,r)},p.splice(e,0,u),"img"!=a&&(r||2===y[c]?(t.insertBefore(l,s?null:n),m(k,j)):y[c].push(l))}function j(a,b,c,d,f){return q=0,b=b||"j",e(a)?i("c"==b?v:u,a,b,this.i++,c,d,f):(p.splice(this.i++,0,a),1==p.length&&h()),this}function k(){var a=B;return a.loader={load:j,i:0},a}var l=b.documentElement,m=a.setTimeout,n=b.getElementsByTagName("script")[0],o={}.toString,p=[],q=0,r="MozAppearance"in l.style,s=r&&!!b.createRange().compareNode,t=s?l:n.parentNode,l=a.opera&&"[object Opera]"==o.call(a.opera),l=!!b.attachEvent&&!l,u=r?"object":l?"script":"img",v=l?"script":u,w=Array.isArray||function(a){return"[object Array]"==o.call(a)},x=[],y={},z={timeout:function(a,b){return b.length&&(a.timeout=b[0]),a}},A,B;B=function(a){function b(a){var a=a.split("!"),b=x.length,c=a.pop(),d=a.length,c={url:c,origUrl:c,prefixes:a},e,f,g;for(f=0;f<d;f++)g=a[f].split("="),(e=z[g.shift()])&&(c=e(c,g));for(f=0;f<b;f++)c=x[f](c);return c}function g(a,e,f,g,h){var i=b(a),j=i.autoCallback;i.url.split(".").pop().split("?").shift(),i.bypass||(e&&(e=d(e)?e:e[a]||e[g]||e[a.split("/").pop().split("?")[0]]),i.instead?i.instead(a,e,f,g,h):(y[i.url]?i.noexec=!0:y[i.url]=1,f.load(i.url,i.forceCSS||!i.forceJS&&"css"==i.url.split(".").pop().split("?").shift()?"c":c,i.noexec,i.attrs,i.timeout),(d(e)||d(j))&&f.load(function(){k(),e&&e(i.origUrl,h,g),j&&j(i.origUrl,h,g),y[i.url]=2})))}function h(a,b){function c(a,c){if(a){if(e(a))c||(j=function(){var a=[].slice.call(arguments);k.apply(this,a),l()}),g(a,j,b,0,h);else if(Object(a)===a)for(n in m=function(){var b=0,c;for(c in a)a.hasOwnProperty(c)&&b++;return b}(),a)a.hasOwnProperty(n)&&(!c&&!--m&&(d(j)?j=function(){var a=[].slice.call(arguments);k.apply(this,a),l()}:j[n]=function(a){return function(){var b=[].slice.call(arguments);a&&a.apply(this,b),l()}}(k[n])),g(a[n],j,b,n,h))}else!c&&l()}var h=!!a.test,i=a.load||a.both,j=a.callback||f,k=j,l=a.complete||f,m,n;c(h?a.yep:a.nope,!!i),i&&c(i)}var i,j,l=this.yepnope.loader;if(e(a))g(a,0,l,0);else if(w(a))for(i=0;i<a.length;i++)j=a[i],e(j)?g(j,0,l,0):w(j)?B(j):Object(j)===j&&h(j,l);else Object(a)===a&&h(a,l)},B.addPrefix=function(a,b){z[a]=b},B.addFilter=function(a){x.push(a)},B.errorTimeout=1e4,null==b.readyState&&b.addEventListener&&(b.readyState="loading",b.addEventListener("DOMContentLoaded",A=function(){b.removeEventListener("DOMContentLoaded",A,0),b.readyState="complete"},0)),a.yepnope=k(),a.yepnope.executeStack=h,a.yepnope.injectJs=function(a,c,d,e,i,j){var k=b.createElement("script"),l,o,e=e||B.errorTimeout;k.src=a;for(o in d)k.setAttribute(o,d[o]);c=j?h:c||f,k.onreadystatechange=k.onload=function(){!l&&g(k.readyState)&&(l=1,c(),k.onload=k.onreadystatechange=null)},m(function(){l||(l=1,c(1))},e),i?k.onload():n.parentNode.insertBefore(k,n)},a.yepnope.injectCss=function(a,c,d,e,g,i){var e=b.createElement("link"),j,c=i?h:c||f;e.href=a,e.rel="stylesheet",e.type="text/css";for(j in d)e.setAttribute(j,d[j]);g||(n.parentNode.insertBefore(e,n),m(c,0))}}(this,document),Modernizr.load=function(){yepnope.apply(window,[].slice.call(arguments,0))};
/*!
 * mustache.js - Logic-less {{mustache}} templates with JavaScript
 * http://github.com/janl/mustache.js
 */

/*global define: false*/

(function (root, factory) {
  if (typeof exports === "object" && exports) {
    factory(exports); // CommonJS
  } else {
    var mustache = {};
    factory(mustache);
    if (typeof define === "function" && define.amd) {
      define(mustache); // AMD
    } else {
      root.Mustache = mustache; // <script>
    }
  }
}(this, function (mustache) {

  // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
  // See https://github.com/janl/mustache.js/issues/189
  var RegExp_test = RegExp.prototype.test;
  function testRegExp(re, string) {
    return RegExp_test.call(re, string);
  }

  var nonSpaceRe = /\S/;
  function isWhitespace(string) {
    return !testRegExp(nonSpaceRe, string);
  }

  var Object_toString = Object.prototype.toString;
  var isArray = Array.isArray || function (object) {
    return Object_toString.call(object) === '[object Array]';
  };

  function isFunction(object) {
    return typeof object === 'function';
  }

  function escapeRegExp(string) {
    return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
  }

  var entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': '&quot;',
    "'": '&#39;',
    "/": '&#x2F;'
  };

  function escapeHtml(string) {
    return String(string).replace(/[&<>"'\/]/g, function (s) {
      return entityMap[s];
    });
  }

  function escapeTags(tags) {
    if (!isArray(tags) || tags.length !== 2) {
      throw new Error('Invalid tags: ' + tags);
    }

    return [
      new RegExp(escapeRegExp(tags[0]) + "\\s*"),
      new RegExp("\\s*" + escapeRegExp(tags[1]))
    ];
  }

  var whiteRe = /\s*/;
  var spaceRe = /\s+/;
  var equalsRe = /\s*=/;
  var curlyRe = /\s*\}/;
  var tagRe = /#|\^|\/|>|\{|&|=|!/;

  /**
   * Breaks up the given `template` string into a tree of tokens. If the `tags`
   * argument is given here it must be an array with two string values: the
   * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
   * course, the default is to use mustaches (i.e. mustache.tags).
   *
   * A token is an array with at least 4 elements. The first element is the
   * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
   * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
   * all text that appears outside a symbol this element is "text".
   *
   * The second element of a token is its "value". For mustache tags this is
   * whatever else was inside the tag besides the opening symbol. For text tokens
   * this is the text itself.
   *
   * The third and fourth elements of the token are the start and end indices,
   * respectively, of the token in the original template.
   *
   * Tokens that are the root node of a subtree contain two more elements: 1) an
   * array of tokens in the subtree and 2) the index in the original template at
   * which the closing tag for that section begins.
   */
  function parseTemplate(template, tags) {
    tags = tags || mustache.tags;
    template = template || '';

    if (typeof tags === 'string') {
      tags = tags.split(spaceRe);
    }

    var tagRes = escapeTags(tags);
    var scanner = new Scanner(template);

    var sections = [];     // Stack to hold section tokens
    var tokens = [];       // Buffer to hold the tokens
    var spaces = [];       // Indices of whitespace tokens on the current line
    var hasTag = false;    // Is there a {{tag}} on the current line?
    var nonSpace = false;  // Is there a non-space char on the current line?

    // Strips all whitespace tokens array for the current line
    // if there was a {{#tag}} on it and otherwise only space.
    function stripSpace() {
      if (hasTag && !nonSpace) {
        while (spaces.length) {
          delete tokens[spaces.pop()];
        }
      } else {
        spaces = [];
      }

      hasTag = false;
      nonSpace = false;
    }

    var start, type, value, chr, token, openSection;
    while (!scanner.eos()) {
      start = scanner.pos;

      // Match any text between tags.
      value = scanner.scanUntil(tagRes[0]);
      if (value) {
        for (var i = 0, len = value.length; i < len; ++i) {
          chr = value.charAt(i);

          if (isWhitespace(chr)) {
            spaces.push(tokens.length);
          } else {
            nonSpace = true;
          }

          tokens.push(['text', chr, start, start + 1]);
          start += 1;

          // Check for whitespace on the current line.
          if (chr === '\n') {
            stripSpace();
          }
        }
      }

      // Match the opening tag.
      if (!scanner.scan(tagRes[0])) break;
      hasTag = true;

      // Get the tag type.
      type = scanner.scan(tagRe) || 'name';
      scanner.scan(whiteRe);

      // Get the tag value.
      if (type === '=') {
        value = scanner.scanUntil(equalsRe);
        scanner.scan(equalsRe);
        scanner.scanUntil(tagRes[1]);
      } else if (type === '{') {
        value = scanner.scanUntil(new RegExp('\\s*' + escapeRegExp('}' + tags[1])));
        scanner.scan(curlyRe);
        scanner.scanUntil(tagRes[1]);
        type = '&';
      } else {
        value = scanner.scanUntil(tagRes[1]);
      }

      // Match the closing tag.
      if (!scanner.scan(tagRes[1])) {
        throw new Error('Unclosed tag at ' + scanner.pos);
      }

      token = [ type, value, start, scanner.pos ];
      tokens.push(token);

      if (type === '#' || type === '^') {
        sections.push(token);
      } else if (type === '/') {
        // Check section nesting.
        openSection = sections.pop();

        if (!openSection) {
          throw new Error('Unopened section "' + value + '" at ' + start);
        }
        if (openSection[1] !== value) {
          throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
        }
      } else if (type === 'name' || type === '{' || type === '&') {
        nonSpace = true;
      } else if (type === '=') {
        // Set the tags for the next time around.
        tagRes = escapeTags(tags = value.split(spaceRe));
      }
    }

    // Make sure there are no open sections when we're done.
    openSection = sections.pop();
    if (openSection) {
      throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);
    }

    return nestTokens(squashTokens(tokens));
  }

  /**
   * Combines the values of consecutive text tokens in the given `tokens` array
   * to a single token.
   */
  function squashTokens(tokens) {
    var squashedTokens = [];

    var token, lastToken;
    for (var i = 0, len = tokens.length; i < len; ++i) {
      token = tokens[i];

      if (token) {
        if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
          lastToken[1] += token[1];
          lastToken[3] = token[3];
        } else {
          squashedTokens.push(token);
          lastToken = token;
        }
      }
    }

    return squashedTokens;
  }

  /**
   * Forms the given array of `tokens` into a nested tree structure where
   * tokens that represent a section have two additional items: 1) an array of
   * all tokens that appear in that section and 2) the index in the original
   * template that represents the end of that section.
   */
  function nestTokens(tokens) {
    var nestedTokens = [];
    var collector = nestedTokens;
    var sections = [];

    var token, section;
    for (var i = 0, len = tokens.length; i < len; ++i) {
      token = tokens[i];

      switch (token[0]) {
      case '#':
      case '^':
        collector.push(token);
        sections.push(token);
        collector = token[4] = [];
        break;
      case '/':
        section = sections.pop();
        section[5] = token[2];
        collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
        break;
      default:
        collector.push(token);
      }
    }

    return nestedTokens;
  }

  /**
   * A simple string scanner that is used by the template parser to find
   * tokens in template strings.
   */
  function Scanner(string) {
    this.string = string;
    this.tail = string;
    this.pos = 0;
  }

  /**
   * Returns `true` if the tail is empty (end of string).
   */
  Scanner.prototype.eos = function () {
    return this.tail === "";
  };

  /**
   * Tries to match the given regular expression at the current position.
   * Returns the matched text if it can match, the empty string otherwise.
   */
  Scanner.prototype.scan = function (re) {
    var match = this.tail.match(re);

    if (match && match.index === 0) {
      var string = match[0];
      this.tail = this.tail.substring(string.length);
      this.pos += string.length;
      return string;
    }

    return "";
  };

  /**
   * Skips all text until the given regular expression can be matched. Returns
   * the skipped string, which is the entire tail if no match can be made.
   */
  Scanner.prototype.scanUntil = function (re) {
    var index = this.tail.search(re), match;

    switch (index) {
    case -1:
      match = this.tail;
      this.tail = "";
      break;
    case 0:
      match = "";
      break;
    default:
      match = this.tail.substring(0, index);
      this.tail = this.tail.substring(index);
    }

    this.pos += match.length;

    return match;
  };

  /**
   * Represents a rendering context by wrapping a view object and
   * maintaining a reference to the parent context.
   */
  function Context(view, parentContext) {
    this.view = view == null ? {} : view;
    this.cache = { '.': this.view };
    this.parent = parentContext;
  }

  /**
   * Creates a new context using the given view with this context
   * as the parent.
   */
  Context.prototype.push = function (view) {
    return new Context(view, this);
  };

  /**
   * Returns the value of the given name in this context, traversing
   * up the context hierarchy if the value is absent in this context's view.
   */
  Context.prototype.lookup = function (name) {
    var value;
    if (name in this.cache) {
      value = this.cache[name];
    } else {
      var context = this;

      while (context) {
        if (name.indexOf('.') > 0) {
          value = context.view;

          var names = name.split('.'), i = 0;
          while (value != null && i < names.length) {
            value = value[names[i++]];
          }
        } else {
          value = context.view[name];
        }

        if (value != null) break;

        context = context.parent;
      }

      this.cache[name] = value;
    }

    if (isFunction(value)) {
      value = value.call(this.view);
    }

    return value;
  };

  /**
   * A Writer knows how to take a stream of tokens and render them to a
   * string, given a context. It also maintains a cache of templates to
   * avoid the need to parse the same template twice.
   */
  function Writer() {
    this.cache = {};
  }

  /**
   * Clears all cached templates in this writer.
   */
  Writer.prototype.clearCache = function () {
    this.cache = {};
  };

  /**
   * Parses and caches the given `template` and returns the array of tokens
   * that is generated from the parse.
   */
  Writer.prototype.parse = function (template, tags) {
    var cache = this.cache;
    var tokens = cache[template];

    if (tokens == null) {
      tokens = cache[template] = parseTemplate(template, tags);
    }

    return tokens;
  };

  /**
   * High-level method that is used to render the given `template` with
   * the given `view`.
   *
   * The optional `partials` argument may be an object that contains the
   * names and templates of partials that are used in the template. It may
   * also be a function that is used to load partial templates on the fly
   * that takes a single argument: the name of the partial.
   */
  Writer.prototype.render = function (template, view, partials) {
    var tokens = this.parse(template);
    var context = (view instanceof Context) ? view : new Context(view);
    return this.renderTokens(tokens, context, partials, template);
  };

  /**
   * Low-level method that renders the given array of `tokens` using
   * the given `context` and `partials`.
   *
   * Note: The `originalTemplate` is only ever used to extract the portion
   * of the original template that was contained in a higher-order section.
   * If the template doesn't use higher-order sections, this argument may
   * be omitted.
   */
  Writer.prototype.renderTokens = function (tokens, context, partials, originalTemplate) {
    var buffer = '';

    // This function is used to render an arbitrary template
    // in the current context by higher-order sections.
    var self = this;
    function subRender(template) {
      return self.render(template, context, partials);
    }

    var token, value;
    for (var i = 0, len = tokens.length; i < len; ++i) {
      token = tokens[i];

      switch (token[0]) {
      case '#':
        value = context.lookup(token[1]);
        if (!value) continue;

        if (isArray(value)) {
          for (var j = 0, jlen = value.length; j < jlen; ++j) {
            buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate);
          }
        } else if (typeof value === 'object' || typeof value === 'string') {
          buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate);
        } else if (isFunction(value)) {
          if (typeof originalTemplate !== 'string') {
            throw new Error('Cannot use higher-order sections without the original template');
          }

          // Extract the portion of the original template that the section contains.
          value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);

          if (value != null) buffer += value;
        } else {
          buffer += this.renderTokens(token[4], context, partials, originalTemplate);
        }

        break;
      case '^':
        value = context.lookup(token[1]);

        // Use JavaScript's definition of falsy. Include empty arrays.
        // See https://github.com/janl/mustache.js/issues/186
        if (!value || (isArray(value) && value.length === 0)) {
          buffer += this.renderTokens(token[4], context, partials, originalTemplate);
        }

        break;
      case '>':
        if (!partials) continue;
        value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
        if (value != null) buffer += this.renderTokens(this.parse(value), context, partials, value);
        break;
      case '&':
        value = context.lookup(token[1]);
        if (value != null) buffer += value;
        break;
      case 'name':
        value = context.lookup(token[1]);
        if (value != null) buffer += mustache.escape(value);
        break;
      case 'text':
        buffer += token[1];
        break;
      }
    }

    return buffer;
  };

  mustache.name = "mustache.js";
  mustache.version = "0.8.1";
  mustache.tags = [ "{{", "}}" ];

  // All high-level mustache.* functions use this writer.
  var defaultWriter = new Writer();

  /**
   * Clears all cached templates in the default writer.
   */
  mustache.clearCache = function () {
    return defaultWriter.clearCache();
  };

  /**
   * Parses and caches the given template in the default writer and returns the
   * array of tokens it contains. Doing this ahead of time avoids the need to
   * parse templates on the fly as they are rendered.
   */
  mustache.parse = function (template, tags) {
    return defaultWriter.parse(template, tags);
  };

  /**
   * Renders the `template` with the given `view` and `partials` using the
   * default writer.
   */
  mustache.render = function (template, view, partials) {
    return defaultWriter.render(template, view, partials);
  };

  // This is here for backwards compatibility with 0.4.x.
  mustache.to_html = function (template, view, partials, send) {
    var result = mustache.render(template, view, partials);

    if (isFunction(send)) {
      send(result);
    } else {
      return result;
    }
  };

  // Export the escaping function so that the user may override it.
  // See https://github.com/janl/mustache.js/issues/244
  mustache.escape = escapeHtml;

  // Export these mainly for testing, but also for advanced usage.
  mustache.Scanner = Scanner;
  mustache.Context = Context;
  mustache.Writer = Writer;

}));

var site = site || {};
site.productView = site.productView || {};


$(document).on('prodcat.status', function(e, data) {

  $.each(data.products, function(index, product) {
    if (product) {
      var skus = product.skus;
      $.each(skus, function(index, sku) {
        // save the data somewhere
        $(document).data(sku.SKU_ID, sku);
      });
      //Changing Preorder Button for Single Preorder sku and if all skus are Preorder in MPP
      if (Drupal.settings.globals_variables.enable_preorder) {
        if (($('body').hasClass('brand-aerin') || $('body').hasClass('brand-renutriv') || $('body').hasClass('renutriv-pink-images')) || $('body').hasClass('section-esearch')) {
          var productIdPre = product.PRODUCT_ID;
          var preCount = 0;
          //since product attribute differs for each templates in Aerin & Renutriv
          var preMppButton = $('.js-shopnow-button[data-product-id="' + productIdPre + '"],.js-shopnow-button[data-productid="' + productIdPre + '"],li[data-productid="' + productIdPre + '"] .js-shopnow-button,li[data-product-id="' + productIdPre + '"] .js-shopnow-button, .js-shopnow-button[data-product="' + productIdPre + '"],.js-discover-more-quickshop[data-productid="' + productIdPre + '"], .js-quickshop-show[data-product-id="' + productIdPre + '"]');
          $.each(skus, function(index, sku) {
            if(sku.isPreOrder) {
              preCount += 1;
            }
          });
          if(preCount == skus.length) {
            preMppButton.text(site.translations.product.pre_order);
          }
        }
      }
    }
  });

  $(this).trigger("mpp_product_inventory_status_sort", [data]);
  $(this).trigger('spp_inventory_status_sort', [data]);

  $(".js-inv-status-list").trigger("inventory_status_stored");
  $(".js-add-to-cart").trigger("inventory_status_stored");
  $(".js-quickshop-button").trigger("inventory_status_stored");

  //code will trigger the select box change event on spp page
  if ($('div.spp .selectBox').length) {
    $('.selectBox').trigger('change', [{'pageLoadTrigger': true}]);
  }
  $(document).trigger('mpp-custom--tout:event');
});

$(document).on('mpp_product_inventory_status_sort', function(e, data) {
  if (typeof site.productSort.sort != 'function') return null;

  var prodsNoShop = [];
  var prodsShop = _.filter(data.products, function(prod) {
    if (prod) {
      // check sku inventory status
      // shoppable as inv stat 1 (active) and 3 (coming soon)
      var skuShoppable = _.filter(prod.skus, function (i) {
        if ((i.INVENTORY_STATUS === 1) || (i.INVENTORY_STATUS === 3)) {
          return i;
        }
      });
      if (skuShoppable.length) {
        return prod;
      }
      else {
        prodsNoShop.push(prod);
      }
    }
  });

  var $mppGrid = $('.mpp__product-grid', this);
  var mppGridSort = $($mppGrid).data('inventory-sort') || false;
  var mppGridSortSku = $($mppGrid).data('inventory-sort-sku') || false;
  var mppGridSortProduct = $($mppGrid).data('inventory-sort-product') || false;
  if (!mppGridSort) {
    return;
  }

  // exp shade template
  if (mppGridSort === 'custom_exposed_shade_mpp') {
    $(this).trigger('mpp_sku_grid_inventory_status_sort', [data]);
    return;
  }

  // cms template option to turn off sku only sorting
  if (!!mppGridSortSku) {
    $(this).trigger("mpp_product_inventory_status_sort_sku", [data]);
  }

  // sort non-shoppables by inv status of product's skus
  prodsNoShop = _.sortBy(prodsNoShop, function(p) {
    var invStatuses = _.uniq(_.pluck(p.skus, 'INVENTORY_STATUS'));
    if (invStatuses == 2) {
      return 2;
    }
    else if (invStatuses == 7) {
      return 3;
    }
    else {
      return 4;
    };

  });

  // and refresh mpp
  var prods = prodsShop.concat(prodsNoShop);
  // template option for product sorting only
  if (!!mppGridSortProduct) {
    site.productSort.sort(prods);
  }
});


site.productView.InvStatusList = function($listNode) {
  var that = {
    $listNode : $listNode
  };
  that.productId = that.$listNode.attr("data-product-id");

  that.$listNode.on("inventory_status_stored", function(e) {
    that.updateInvStatus();
    e.stopPropagation();
  });

  that.updateInvStatus = function() {
    var skuId = that.$listNode.attr("data-sku-id");
    var skuData = $(document).data(skuId);
    if (!skuData || !skuData.INVENTORY_STATUS) return null;
    $("li", that.$listNode).hide();
    $(".js-inv-status-" + skuData.INVENTORY_STATUS, that.$listNode).show();
    var $statusToShow = $(".js-inv-status-" + skuData.INVENTORY_STATUS, that.$listNode);

    // handle retail exclusive skus
    var retail_exclusive_node = that.$listNode.find('.retail-exclusive');
    var is_retail_exclusive = retail_exclusive_node.length;

    if(is_retail_exclusive) {
      $statusToShow = retail_exclusive_node;
    }

    if (is_retail_exclusive || $statusToShow.length > 0) {
      $statusToShow.show();
      that.$listNode.trigger("inventory_status_updated");
    }
    // Pre-order page check
    if(Drupal.settings.globals_variables.enable_preorder) {
      var catalogMpp = page_data['catalog-mpp'];
      var customMpp = page_data['custom-mpp'];
      var catalogSpp = page_data['catalog-spp'];
      var customPreorder = $('body').hasClass('section-preorder-custom');
      var exposedPreorder = $('body').hasClass('section-preorder-exposed');
      var aerinPreorder = $('body').hasClass('brand-aerin');
      var renutrivPreorder = $('body').hasClass('brand-renutriv');
      var renutrivPink = $('body').hasClass('renutriv-pink-images');
      var preorderSearch = $('body').hasClass('section-esearch');
      if (catalogMpp && customMpp) {
        site.isPreOrderExposed(skuData);
      } else if (customMpp && customPreorder) {
        site.isPreOrder(skuData, true);
      } else if (catalogSpp) {
        site.isPreOrder(skuData, false);
      } else if (catalogMpp && exposedPreorder) {
        site.isPreOrderExposed(skuData);
      } else if ((customMpp || catalogMpp) && aerinPreorder) {
        if(site.client.isMobile) {
          site.isPreOrder(skuData, true);
        } else if ($('.quickshop').length) { //Calling preorder function only during quickshop since Aerin MPP doesnt have Preorder templates
          site.isPreOrder(skuData, false);
        }
      } else if ((customMpp || catalogMpp) && (renutrivPreorder || renutrivPink)) {
        site.isPreOrder(skuData, true);
      } else if (catalogMpp) {
        site.isPreOrder(skuData, true);
      }
      // Pre-order check for search pages
      if(preorderSearch) {
        site.isPreOrderSearch(skuData)
      }
    }
  };

  that.updateInvStatus();

  that.$listNode.on('sku:select', function(e, skuData) {
    that.$listNode.attr("data-sku-id", skuData.SKU_ID);
    that.updateInvStatus();
    e.stopPropagation();
  });

  return that;
};

site.productView.collectProductIds = function($context) {
  var prodIds = [];
  $('[data-product-id]', $context).each( function() {
      $this = $(this);
      var prodId = $this.attr('data-product-id');
      var insert = true;
      for (var i=prodIds.length-1; i>-1; i--) {
          if (prodIds[i] == prodId) {
              insert = false;
              break;
          }
      }
      if (insert) {
          prodIds.push(prodId);
      }
      insert = true;
  });
  return prodIds;
};

site.productView.loadL2Data = function(productIds) {
  if (!_.isArray(productIds) || productIds.length<1) return null;

  generic.jsonrpc.fetch({
    "method":   "prodcat.querykey",
    "params":   [{
        products: productIds,
        query_key: 'catalog-mpp-volatile'
    }],
    "onSuccess" : function (response) {
        var v = response.getValue();
        $(document).trigger('prodcat.status', v);
    }
   });
};
site.isPreOrder = function(skuData, page_check) { // page_check == true for MPP pages, false for SPP pages
  var $addToBagBtn;
  if(page_check) {
    var $prodId = skuData.PRODUCT_ID;
    var $skuBaseId = skuData.SKU_BASE_ID;
    $addToBagBtn = site.client.isMobile ? $('button[data-product-id="' + $prodId + '"].js-add-to-cart') : $('li[data-productid="' + $prodId + '"] .js-add-to-cart, li[data-product-id="' + $prodId + '"] .js-add-to-cart');
    var $activePreOrderStatus = $('li[data-productid="'+$prodId+'"] .pre-order_active_msg, li[data-product-id="'+$prodId+'"] .pre-order_active_msg');
    var $tosPreOrderStatus = $('li[data-productid="'+$prodId+'"] .pre-order_tos_msg, li[data-product-id="'+$prodId+'"] .pre-order_tos_msg');
    var $soldOutPreOrderStatus = $('li[data-productid="'+$prodId+'"] .pre-order_sold_msg, li[data-product-id="'+$prodId+'"] .pre-order_sold_msg');
    var $inventortStatusList = $('li[data-productid="'+$prodId+'"] .js-inv-status-list, li[data-product-id="'+$prodId+'"] .js-inv-status-list');
    var $prodContainer = $('li[data-productid="'+$prodId+'"], li[data-product-id="'+$prodId+'"]');
  }
  else {
    var $quickShopContainer = $('.quickshop').length;
    $addToBagBtn = $quickShopContainer ? $('.quickshop .js-add-to-cart') : $('.js-add-to-cart');
    var $activePreOrderStatus = $quickShopContainer ? $('.quickshop .pre-order_active_msg') : $('.pre-order_active_msg');
    var $tosPreOrderStatus = $quickShopContainer ? $('.quickshop .pre-order_tos_msg') : $('.pre-order_tos_msg');
    var $soldOutPreOrderStatus = $quickShopContainer ? $('.quickshop .pre-order_sold_msg') : $('.pre-order_sold_msg');
    var $inventortStatusList = $quickShopContainer ? $('.quickshop .js-inv-status-list') : $('.js-inv-status-list');
    var $prodContainer = $quickShopContainer ? $('.quickshop__description') : $('.product-full__description');
  }
  var skuInfo = $(document).data(skuData.SKU_ID);
  var $preorderSppContainer = $(".js-pr-product[data-product-id='" + skuData.PRODUCT_ID + "']").closest('.page-product');
  if(skuInfo.isPreOrder) {
    $addToBagBtn.addClass('pre-order-button').text(site.translations.product.pre_order);
    $prodContainer.addClass('pre-order-container');
    $preorderSppContainer.addClass('preorder-spp-container');
    if(skuInfo.INVENTORY_STATUS  == 7 ) {
      $inventortStatusList.hide();
      $soldOutPreOrderStatus.html(site.translations.product.pre_order_sold_old_msg);
      $soldOutPreOrderStatus.removeClass('hidden');
      $tosPreOrderStatus.addClass('hidden');
      $activePreOrderStatus.addClass('hidden');
      $addToBagBtn.addClass('pre-order-button-disabled');
    }
    else if(skuInfo.INVENTORY_STATUS  == 2 ) {
      $inventortStatusList.hide();
      site.setPreorderMessage($tosPreOrderStatus, site.translations.product.pre_order_tos_msg, skuInfo, false);
      $soldOutPreOrderStatus.addClass('hidden');
      $activePreOrderStatus.addClass('hidden');
      $addToBagBtn.addClass('pre-order-button-disabled');
    }
    else if(skuInfo.INVENTORY_STATUS  == 1 ) {
      site.setPreorderMessage($activePreOrderStatus, site.translations.product.pre_order_available_msg, skuInfo, true);
      $tosPreOrderStatus.addClass('hidden');
      $soldOutPreOrderStatus.addClass('hidden');
      $addToBagBtn.removeClass('pre-order-button-disabled');
    }
  }
  else {
    if ($('.js-spp-with-form-overlay').length === 0) {
      $addToBagBtn.text(site.translations.product.add_to_bag);
    }
    $activePreOrderStatus.addClass('hidden');
    $tosPreOrderStatus.addClass('hidden');
    $soldOutPreOrderStatus.addClass('hidden');
    $inventortStatusList.show();
    $addToBagBtn.removeClass('pre-order-button pre-order-button-disabled');
    $prodContainer.removeClass('pre-order-container');
    $preorderSppContainer.removeClass('preorder-spp-container');
  }
};

site.isPreOrderExposed = function(skuData) {
  var skuId = skuData.SKU_ID;
  skuId = skuId.replace(/\D/g,'');
  var $addToBagBtn = site.client.isMobile ? $('li[data-sku-id="'+skuId+'"] .js-quickshop-show') : $('li[data-productid="'+skuData.PRODUCT_ID+'"] div[data-sku-id="'+skuId+'"] .js-add-to-cart');
  var $activePreOrderStatus = site.client.isMobile ? $('li[data-sku-id="'+skuId+'"] .pre-order_active_msg') : $('li[data-productid="'+skuData.PRODUCT_ID+'"] div[data-sku-id="'+skuId+'"] .pre-order_active_msg');
  var $tosPreOrderStatus = site.client.isMobile ? $('li[data-sku-id="'+skuId+'"] .pre-order_tos_msg') : $('li[data-productid="'+skuData.PRODUCT_ID+'"] div[data-sku-id="'+skuId+'"] .pre-order_tos_msg');
  var $soldOutPreOrderStatus = site.client.isMobile ? $('li[data-sku-id="'+skuId+'"] .pre-order_sold_msg') : $('li[data-productid="'+skuData.PRODUCT_ID+'"] div[data-sku-id="'+skuId+'"] .pre-order_sold_msg');
  var $prodContainer = site.client.isMobile ? $addToBagBtn.parents('li.js-product-brief[data-sku-id="'+skuId+'"]') : $addToBagBtn.parents('li.mpp__product');
  var $selectSku = site.client.isMobile ? $prodContainer.find('.js-quickshop-show').attr('data-sku-base-id') : $prodContainer.find('.js-add-to-cart').attr('data-sku-base-id');
  if((skuId == $selectSku) && skuData.isPreOrder) {
    $prodContainer.addClass('pre-order-container pre-order-exposed-container');
    $addToBagBtn.addClass('pre-order-button').text(site.translations.product.pre_order);
    if((skuData.INVENTORY_STATUS == 1)) {
      site.setPreorderMessage($activePreOrderStatus, site.translations.product.pre_order_available_msg, skuData, true);
      if(!site.client.isMobile) {
        $addToBagBtn.removeClass('hidden');
      }
    } else if((skuData.INVENTORY_STATUS == 2)){
      site.setPreorderMessage($tosPreOrderStatus, site.translations.product.pre_order_tos_msg, skuData, false);
      $activePreOrderStatus.addClass('hidden');
      $addToBagBtn.addClass('hidden');
    } else if((skuData.INVENTORY_STATUS == 7)){
      $activePreOrderStatus.addClass('hidden');
      $soldOutPreOrderStatus.text(site.translations.product.pre_order_sold_old_msg);
      $soldOutPreOrderStatus.removeClass('hidden');
    }
  }
};

site.isPreOrderSearch = function(skuData) {
  var prodDetail = skuData.PRODUCT_ID;
  var $addToBagBtn = site.client.isMobile ? $('.js-add-to-cart[data-product-id='+prodDetail+']') : $('#product-'+ prodDetail +' .js-add-to-cart');
  var $activePreOrderStatus = site.client.isMobile ? $('div.result[data-product-id='+prodDetail+'] .pre-order_active_msg, .js-quickshop-container .pre-order_active_msg') : $('#product-'+ prodDetail +' .pre-order_active_msg');
  var $tosPreOrderStatus = site.client.isMobile ? $('div.result[data-product-id='+prodDetail+'] .pre-order_tos_msg, .js-quickshop-container .pre-order_tos_msg') : $('#product-'+ prodDetail +' .pre-order_tos_msg');
  var $soldOutPreOrderStatus = site.client.isMobile ? $('div.result[data-product-id='+prodDetail+'] .pre-order_sold_msg, .js-quickshop-container .pre-order_sold_msg') : $('#product-'+ prodDetail +' .pre-order_sold_msg');
  var $inventortStatusList = site.client.isMobile ? $('div.result[data-product-id='+prodDetail+'] .js-inv-status-list, .js-quickshop-container .js-inv-status-list') : $('#product-'+ prodDetail +' .js-inv-status-list');
  var $prodContainer = site.client.isMobile ? $('div.result[data-product-id='+prodDetail+'], .js-quickshop-container') : $('#product-'+ prodDetail +'');
  if(skuData.isPreOrder) {
    $addToBagBtn.addClass('pre-order-button').text(site.translations.product.pre_order);
    $prodContainer.find('.search-product__misc-flag').show();
    $prodContainer.addClass('pre-order-container');
    $prodContainer.addClass('active');
    if(skuData.INVENTORY_STATUS  == 7 ) {
      $soldOutPreOrderStatus.text(site.translations.product.pre_order_sold_old_msg);
      $soldOutPreOrderStatus.removeClass('hidden');
      $tosPreOrderStatus.addClass('hidden');
      $activePreOrderStatus.addClass('hidden');
      $addToBagBtn.addClass('pre-order-button-disabled');
      $inventortStatusList.hide();
    }
    else if(skuData.INVENTORY_STATUS  == 2 ) {
      site.setPreorderMessage($tosPreOrderStatus, site.translations.product.pre_order_tos_msg, skuData, false);
      $soldOutPreOrderStatus.addClass('hidden');
      $activePreOrderStatus.addClass('hidden');
      $addToBagBtn.addClass('pre-order-button-disabled');
      $inventortStatusList.hide();
    }
    else if(skuData.INVENTORY_STATUS  == 1 ) {
      site.setPreorderMessage($activePreOrderStatus, site.translations.product.pre_order_available_msg, skuData, true);
      $tosPreOrderStatus.addClass('hidden');
      $soldOutPreOrderStatus.addClass('hidden');
      $addToBagBtn.removeClass('pre-order-button-disabled');
    }
  } else {
    $addToBagBtn.text(site.translations.product.add_to_bag);
    $addToBagBtn.removeClass('pre-order-button');
    $activePreOrderStatus.addClass('hidden');
    $tosPreOrderStatus.addClass('hidden');
    $soldOutPreOrderStatus.addClass('hidden');
    $inventortStatusList.show();
    $prodContainer.removeClass('pre-order-container active');
  }
}
site.quickShopExposed = function(skuData) {
  var skuDetail = skuData.SKU_ID ? skuData.SKU_ID : "SKU" + skuData.skuId;
  var skuInfo = $(document).data(skuDetail);
  var $addToBagBtn = site.client.isMobile ? $('.product-brief__quickshop-container .js-add-to-cart') : $('.quickshop.extended-mpp-qs .js-add-to-cart');
  var $activePreOrderStatus = site.client.isMobile ? $('.product-brief__quickshop-container .pre-order_active_msg') : $('.quickshop.extended-mpp-qs .pre-order_active_msg');
  var $tosPreOrderStatus = site.client.isMobile ? $('.product-brief__quickshop-container .pre-order_tos_msg') : $('.quickshop.extended-mpp-qs .pre-order_tos_msg');
  var $soldOutPreOrderStatus = site.client.isMobile ? $('.product-brief__quickshop-container .pre-order_sold_msg') : $('.quickshop.extended-mpp-qs .pre-order_sold_msg');
  var $inventortStatusList = site.client.isMobile ? $('.product-brief__quickshop-container .js-inv-status-list') : $('.quickshop.extended-mpp-qs .js-inv-status-list');
  if(skuInfo.isPreOrder) {
  $addToBagBtn.addClass('pre-order-button pre-order-exposed-button').text(site.translations.product.pre_order);
    if(skuInfo.INVENTORY_STATUS  == 7 ) {
      $soldOutPreOrderStatus.text(site.translations.product.pre_order_sold_old_msg);
      $soldOutPreOrderStatus.removeClass('hidden');
      $tosPreOrderStatus.addClass('hidden');
      $activePreOrderStatus.addClass('hidden');
      $addToBagBtn.addClass('pre-order-button-disabled');
      $inventortStatusList.hide();
    }
    else if(skuInfo.INVENTORY_STATUS  == 2 ) {
      site.setPreorderMessage($tosPreOrderStatus, site.translations.product.pre_order_tos_msg, skuInfo, false);
      $soldOutPreOrderStatus.addClass('hidden');
      $activePreOrderStatus.addClass('hidden');
      $addToBagBtn.addClass('pre-order-button-disabled');
      $inventortStatusList.hide();
    }
    else if(skuInfo.INVENTORY_STATUS  == 1 ) {
      site.setPreorderMessage($activePreOrderStatus, site.translations.product.pre_order_available_msg, skuInfo, true);
      $tosPreOrderStatus.addClass('hidden');
      $soldOutPreOrderStatus.addClass('hidden');
      $addToBagBtn.removeClass('pre-order-button-disabled');
    }
  }
  else {
    $addToBagBtn.text(site.translations.product.add_to_bag);
    $addToBagBtn.removeClass('pre-order-button');
    $activePreOrderStatus.addClass('hidden');
    $tosPreOrderStatus.addClass('hidden');
    $soldOutPreOrderStatus.addClass('hidden');
    $inventortStatusList.show();
  }
};

site.setPreorderMessage = function($ele, trKey, dateStr, calculateShipDays) {
  if (dateStr) {
    var releaseSkuDateStr = '' + dateStr.RELEASE_DATE;
    var releaseSkuDate = new Date();
    releaseSkuDate.setFullYear(parseInt('20' + releaseSkuDateStr.substr(0, 2), 10), parseInt(releaseSkuDateStr.substr(2, 2), 10) - 1, parseInt(releaseSkuDateStr.substr(4, 2), 10));
    var preorderDateFormat = typeof Drupal.settings.globals_variables.preorder_date_format !== 'undefined' ? Drupal.settings.globals_variables.preorder_date_format : '';
    if (calculateShipDays) {
      var shipDays = parseInt(site.translations.product.preorder_ships_by_days);
      var days = releaseSkuDate.getDate();
      if (!isNaN(shipDays)) {
        releaseSkuDate.setDate(days += shipDays);
      }
    }
    var formattedDate = '';
    var releaseYear = releaseSkuDate.getFullYear();
    var releaseMonth = ('0' + (releaseSkuDate.getMonth() + 1)).slice(-2);
    var releaseDay = ('0' + releaseSkuDate.getDate()).slice(-2);
    switch (preorderDateFormat) {
      case 'dd/mm/yyyy':
        formattedDate = releaseDay + '/' + releaseMonth + '/' + releaseYear;
        break;
      case 'dd/mm':
        formattedDate = releaseDay + '/' + releaseMonth;
        break;
      default :
        formattedDate = releaseMonth + '/' + releaseDay;
        break;
    }
    var releaseDateReplace = formattedDate;
    if (trKey) {
      trKey = trKey.replace(/::release_date::|::rs_dt::/, releaseDateReplace);
    }
    $ele.html(trKey);
    $ele.removeClass('hidden');
  }
};

(function($) {
  Drupal.behaviors.ELB_invStatusList = {
    attach: function(context, settings) {
      $('.js-inv-status-list').each( function() {
        var invStatusList = site.productView.InvStatusList($(this));
      });

      $(".js-quickshop-button").each(function(){
        $(this).on('inventory_status_stored', function(e) {
          var currentSkuId = "SKU" + $(this).attr("data-sku-base-id");
          var skuDataL2 = $(document).data(currentSkuId);
          if (skuDataL2 && !skuDataL2.isShoppable) {
            $(this).hide();
          } else {
            $(this).show();
          }
        });
      });

    }
  };
})(jQuery);

var site = site || {};
var profileRequests = profileRequests || '';
site.profile = site.profile || {};

/**
  * Function that stores any common functionality between PC and Mobile.
  * Any common helper functionality, variables, etc should be added here using the private this object.
  *
*/
site.profile.common = function() {

  // Method to get the profile events class from /personal_block/js/events.js if available.
  var _getEventClass = function() {
    return (site.profile && site.profile.events) ? site.profile.events() : {};
  };

  // Class to handle setting the individual pageview events.
  this.setPageView = {
    mpp : function(id) {
      if (!id) {
        return null;
      };
      this.set({ 'VIEWED_MPP' : id });
    },
    spp : function(id) {
      if (!id) {
        return null;
      };
      this.set({ 'VIEWED_SPP' : id });
    },
    set : function(event) {
      if (!event) {
        return null;
      };

      var eventClass = _getEventClass();
      if (jQuery.isEmptyObject(eventClass)) {
        return null;
      };

      eventClass.store(event);
    }
  };

  // Method to handle the gathering and storing of the page_data for mpp and spp pages.
  this.data = {
    mpp : function(data) {
      if (!data) {
        return null;
      };
      var that      = this;
      var catInfo   = data['categories'] || '';

      return catInfo ? catInfo[0] : {};
    },
    spp : function(data) {
      if (!data) {
        return null;
      };
      var products  = data.products;

      return products ? products[0] : {};
    }
  };

};
/*
 * Purl (A JavaScript URL parser) v2.3.1
 * Developed and maintanined by Mark Perkins, mark@allmarkedup.com
 * Source repository: https://github.com/allmarkedup/jQuery-URL-Parser
 * Licensed under an MIT-style license. See https://github.com/allmarkedup/jQuery-URL-Parser/blob/master/LICENSE for details.
 */

;(function(factory) {
    if (typeof define === 'function' && define.amd) {
        define(factory);
    } else {
        window.purl = factory();
    }
})(function() {

    var tag2attr = {
            a       : 'href',
            img     : 'src',
            form    : 'action',
            base    : 'href',
            script  : 'src',
            iframe  : 'src',
            link    : 'href',
            embed   : 'src',
            object  : 'data'
        },

        key = ['source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'fragment'], // keys available to query

        aliases = { 'anchor' : 'fragment' }, // aliases for backwards compatability

        parser = {
            strict : /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*):?([^:@]*))?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,  //less intuitive, more accurate to the specs
            loose :  /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*):?([^:@]*))?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/ // more intuitive, fails on relative paths and deviates from specs
        },

        isint = /^[0-9]+$/;

    function parseUri( url, strictMode ) {
        var str = decodeURIComponent(encodeURIComponent(url)),
        res   = parser[ strictMode || false ? 'strict' : 'loose' ].exec( str ),
        uri = { attr : {}, param : {}, seg : {} },
        i   = 14;

        while ( i-- ) {
            uri.attr[ key[i] ] = res[i] || '';
        }

        // build query and fragment parameters
        uri.param['query'] = parseString(uri.attr['query']);
        uri.param['fragment'] = parseString(uri.attr['fragment']);

        // split path and fragement into segments
        uri.seg['path'] = uri.attr.path.replace(/^\/+|\/+$/g,'').split('/');
        uri.seg['fragment'] = uri.attr.fragment.replace(/^\/+|\/+$/g,'').split('/');

        // compile a 'base' domain attribute
        uri.attr['base'] = uri.attr.host ? (uri.attr.protocol ?  uri.attr.protocol+'://'+uri.attr.host : uri.attr.host) + (uri.attr.port ? ':'+uri.attr.port : '') : '';

        return uri;
    }

    function getAttrName( elm ) {
        var tn = elm.tagName;
        if ( typeof tn !== 'undefined' ) return tag2attr[tn.toLowerCase()];
        return tn;
    }

    function promote(parent, key) {
        if (parent[key].length === 0) return parent[key] = {};
        var t = {};
        for (var i in parent[key]) t[i] = parent[key][i];
        parent[key] = t;
        return t;
    }

    function parse(parts, parent, key, val) {
        var part = parts.shift();
        if (!part) {
            if (isArray(parent[key])) {
                parent[key].push(val);
            } else if ('object' == typeof parent[key]) {
                parent[key] = val;
            } else if ('undefined' == typeof parent[key]) {
                parent[key] = val;
            } else {
                parent[key] = [parent[key], val];
            }
        } else {
            var obj = parent[key] = parent[key] || [];
            if (']' == part) {
                if (isArray(obj)) {
                    if ('' !== val) obj.push(val);
                } else if ('object' == typeof obj) {
                    obj[keys(obj).length] = val;
                } else {
                    obj = parent[key] = [parent[key], val];
                }
            } else if (~part.indexOf(']')) {
                part = part.substr(0, part.length - 1);
                if (!isint.test(part) && isArray(obj)) obj = promote(parent, key);
                parse(parts, obj, part, val);
                // key
            } else {
                if (!isint.test(part) && isArray(obj)) obj = promote(parent, key);
                parse(parts, obj, part, val);
            }
        }
    }

    function merge(parent, key, val) {
        if (~key.indexOf(']')) {
            var parts = key.split('[');
            parse(parts, parent, 'base', val);
        } else {
            if (!isint.test(key) && isArray(parent.base)) {
                var t = {};
                for (var k in parent.base) t[k] = parent.base[k];
                parent.base = t;
            }
            if (key !== '') {
                set(parent.base, key, val);
            }
        }
        return parent;
    }

    function parseString(str) {
        return reduce(String(str).split(/&|;/), function(ret, pair) {
            try {
                pair = decodeURIComponent(pair.replace(/\+/g, ' '));
            } catch(e) {
                // ignore
            }
            var eql = pair.indexOf('='),
                brace = lastBraceInKey(pair),
                key = pair.substr(0, brace || eql),
                val = pair.substr(brace || eql, pair.length);

            val = val.substr(val.indexOf('=') + 1, val.length);

            if (key === '') {
                key = pair;
                val = '';
            }

            return merge(ret, key, val);
        }, { base: {} }).base;
    }

    function set(obj, key, val) {
        var v = obj[key];
        if (typeof v === 'undefined') {
            obj[key] = val;
        } else if (isArray(v)) {
            v.push(val);
        } else {
            obj[key] = [v, val];
        }
    }

    function lastBraceInKey(str) {
        var len = str.length,
            brace,
            c;
        for (var i = 0; i < len; ++i) {
            c = str[i];
            if (']' == c) brace = false;
            if ('[' == c) brace = true;
            if ('=' == c && !brace) return i;
        }
    }

    function reduce(obj, accumulator){
        var i = 0,
            l = obj.length >> 0,
            curr = arguments[2];
        while (i < l) {
            if (i in obj) curr = accumulator.call(undefined, curr, obj[i], i, obj);
            ++i;
        }
        return curr;
    }

    function isArray(vArg) {
        return Object.prototype.toString.call(vArg) === "[object Array]";
    }

    function keys(obj) {
        var key_array = [];
        for ( var prop in obj ) {
            if ( obj.hasOwnProperty(prop) ) key_array.push(prop);
        }
        return key_array;
    }

    function purl( url, strictMode ) {
        if ( arguments.length === 1 && url === true ) {
            strictMode = true;
            url = undefined;
        }
        strictMode = strictMode || false;
        url = url || window.location.toString();

        return {

            data : parseUri(url, strictMode),

            // get various attributes from the URI
            attr : function( attr ) {
                attr = aliases[attr] || attr;
                return typeof attr !== 'undefined' ? this.data.attr[attr] : this.data.attr;
            },

            // return query string parameters
            param : function( param ) {
                return typeof param !== 'undefined' ? this.data.param.query[param] : this.data.param.query;
            },

            // return fragment parameters
            fparam : function( param ) {
                return typeof param !== 'undefined' ? this.data.param.fragment[param] : this.data.param.fragment;
            },

            // return path segments
            segment : function( seg ) {
                if ( typeof seg === 'undefined' ) {
                    return this.data.seg.path;
                } else {
                    seg = seg < 0 ? this.data.seg.path.length + seg : seg - 1; // negative segments count from the end
                    return this.data.seg.path[seg];
                }
            },

            // return fragment segments
            fsegment : function( seg ) {
                if ( typeof seg === 'undefined' ) {
                    return this.data.seg.fragment;
                } else {
                    seg = seg < 0 ? this.data.seg.fragment.length + seg : seg - 1; // negative segments count from the end
                    return this.data.seg.fragment[seg];
                }
            }

        };

    }

    purl.jQuery = function($){
        if ($ != null) {
            $.fn.purl_url = function( strictMode ) {
                var url_val = '';
                if ( this.length ) {
                    url_val = $(this).attr( getAttrName(this[0]) ) || '';
                }
                return purl( url_val, strictMode );
            };

            $.purl_url = purl;
        }
    };

    purl.jQuery(window.jQuery);

    return purl;

});

var site = site || {};

site.ShadePicker = function (productData) {
    //console.log('init productData: ' + productData.PRODUCT_ID);
    this.init(productData);
};

site.ShadePicker.prototype = {
  productData : null,
  skus: [],
  skuShades : [],
  swatches : '',
  shadeSelects : '',
  originalUrl : window.location.href.split('#/shade/')[0],
  initialShadeRoute : window.location.href.split('#/shade/')[1],
  wireSwatches : function(){
    var self = this;
    self.swatches.bind( "click", function(e) {
      e.preventDefault();
      var selectedSkuBaseId = $(this).attr("data-sku-base-id");
      self.updateSwatches(selectedSkuBaseId);
      site.skuSelect(self.skus[selectedSkuBaseId]);
      self.selectShade(selectedSkuBaseId);
    });
    self.swatches.on( "sku:select", function(e, skuData) {
      var selectedSkuBaseId = skuData.SKU_BASE_ID;
      self.updateSwatches(selectedSkuBaseId);
      e.stopPropagation();
    });
    //init first swatch
    self.swatches.eq(0).addClass("selected");
  },
  wireShadeSelects : function() {
    var self = this;
    self.customSelects(true);
    self.shadeSelects.bind('change', function(e) {
      var selectedSkuBaseId = $(this).val();
      self.updateSelects(selectedSkuBaseId);
      site.skuSelect(self.skus[selectedSkuBaseId]);
      self.selectShade(selectedSkuBaseId);
    });
    self.shadeSelects.on( "sku:select", function(e, skuData) {
      var selectedSkuBaseId = skuData.SKU_BASE_ID;
      self.updateSelects(selectedSkuBaseId);
      e.stopPropagation();
    });
  },
  customSelects : function(init) {
    var self = this;
    self.shadeSelects.each(function(index, val) {
      if(init){
        $(this).selectBox({ mobile: true });
      }else{
        $(this).selectBox('refresh');
        //self.shadeSelects.selectBox('destroy');
        //self.shadeSelects.selectBox({ mobile: true });
      }
      var $shadeSelect = $(this).selectBox('control');
      var $shadeSelectOption = $($shadeSelect).data('selectBox-options');  // extra $() for iPad
      if(init){
        $(this).selectBoxDefault('selectDefault');
        $('.product-full__quantity').selectBoxDefault('selectDefault');
        $('.spp-product__mini-bag-quantity').selectBoxDefault('selectDefault');
      }

      if(!_.isUndefined($shadeSelectOption) && !_.isNull($shadeSelectOption)){
        var $shadeMenuOptions = $shadeSelectOption.find('li a');
        // add shade divs to custom select
        $shadeMenuOptions.each(function() {
          var shadeSku = $(this).attr('rel');
          //var shadeProductData = _.find(self.skus, function(p){ return p.SKU_BASE_ID == shadeSku; });
          var shadeProductData = _.find(self.productData.skus, function(sku){ return sku.SKU_BASE_ID == shadeSku; });
          var shadeHex = shadeProductData.HEX_VALUE_STRING;

          // explode
          var shadeHex = shadeHex.split(',');

          //sort swathes
          var swatchType, hexValue1, hexValue2, hexValue3, hexValue4, hexValue5;
          if(shadeHex.length == 1) {
            swatchType = 'swatches--single';
            hexValue1 = shadeHex[0];
          }else if(shadeHex.length == 2){
            swatchType = 'swatches--duo';
            hexValue1 = shadeHex[0];
            hexValue2 = shadeHex[1];
          }else if(shadeHex.length == 3){
            swatchType = 'swatches--trio';
            hexValue1 = shadeHex[0];
            hexValue2 = shadeHex[1];
            hexValue3 = shadeHex[2];
          }else if(shadeHex.length == 4){
            swatchType = 'swatches--quad';
            hexValue1 = shadeHex[0];
            hexValue2 = shadeHex[1];
            hexValue3 = shadeHex[2];
            hexValue4 = shadeHex[3];
          }else if(shadeHex.length == 5){
            swatchType = 'swatches--quint';
            hexValue1 = shadeHex[0];
            hexValue2 = shadeHex[1];
            hexValue3 = shadeHex[2];
            hexValue4 = shadeHex[3];
            hexValue5 = shadeHex[4];
          }

          var $swatchContainer = $('<div/>', {
            'class': 'swatch__container ' + swatchType
          });
          for(var i=0; i<shadeHex.length; i++){
            var $swatchDiv = $('<div/>', {
              'class': 'swatch--'+(i+1),
              'style': 'background-color:'+shadeHex[i]
            });
            $swatchContainer.append($swatchDiv);
          }

          // add to li
          $(this).prepend($swatchContainer).clone(true);
          // add to label
          if($(this).parent().hasClass('selectBox-selected')){
            var $shadeSelectLabel = $shadeSelect.parent().find('.selectBox-dropdown');
            if($('.swatch__container',$shadeSelectLabel).length){
              var $clone = $swatchContainer.clone(true);
              $('.swatch__container',$shadeSelectLabel).replaceWith($clone);
            }else{
              var $clone = $swatchContainer.clone(true);
              $shadeSelectLabel.prepend($clone);
            }
          }
           
           //ie8 pie attach behavior
           if ( generic.env.isIE8 ) {
             if (window.PIE) {
               $('.swatches--single div').each(function(i, el) {
                 PIE.attach(this);
               });
             }
           }
        });
      }
    });
  },
  updateSwatches : function(skuId){
    var self = this;
    self.swatches.removeClass("selected");
    self.swatches.filter("[data-sku-base-id=" + skuId +  "]").addClass("selected");
  },
  updateSelects : function(skuId){
    var self = this;
    self.shadeSelects.val(skuId);
    self.customSelects(false);
  },
  fixedEncodeURIComponent : function (str){ //CX-3730 Deep Link Implementation
    try {
      return str.replace(/([~!@#$%^&*()_+=`{}\[\]\|\\:;'<>,.\/? ])+/g, '-').replace(/^(-)+|(-)+$/g,'');
    }
    catch(err) {
      // console.log('shadename is undefined');
    }
  },
  hasQueryString : function () { //CX-3730 Deep Link Implementation
    var self = this;
    if (_.isEmpty(self.initialShadeRoute.split('?')[1])) {
      return false;
    } else {
      return true;
    }
  },
  shadeInit : function () { //CX-3730 Deep Link Implementation
    var self = this;
    if (!_.isUndefined(self.initialShadeRoute)) {
      var shadeRoutefromURL = self.initialShadeRoute;
      if (self.hasQueryString()) {
        shadeRoutefromURL = self.initialShadeRoute.split('?')[0];
      }
      var shadeNameNoSpaces = self.fixedEncodeURIComponent(decodeURIComponent(shadeRoutefromURL));
      if (_.contains(self.skuShades, shadeNameNoSpaces)) {
        var foundShadeSkuId = self.skuShades.indexOf(shadeNameNoSpaces);
        $("a.swatch[data-sku-base-id=" + foundShadeSkuId + "]").trigger('click');
      } else {
        self.defaultshadeSelect();
      }
    } else {
      self.defaultshadeSelect();
    }
  },
  selectShade : function (selectedSkuBaseId) { //CX-3730 Deep Link Implementation
    var self = this;
    if (!_.isEmpty(self.skuShades) && Drupal.settings.globals_variables.enable_deep_link) {
      var selectedShade = self.skuShades[selectedSkuBaseId];
      if ( (page_data['custom-spp'] || page_data['catalog-spp']) && $(document).find('.quickshop').length < 1) {
        if (!_.isUndefined(self.initialShadeRoute) && self.hasQueryString()) {
          selectedShade = selectedShade + '?' + self.initialShadeRoute.split('?')[1];
        }
        history.replaceState({}, selectedShade, '#/shade/' + selectedShade);
      }
    }
  },
  defaultshadeSelect : function () {
    var defaultSku = $('a.swatch--selected.selected').data('sku-base-id');
    $("a.swatch[data-sku-base-id=" + defaultSku + "]").trigger('click');
  },
  init: function (productData) {
    var self = this;
    self.productData = productData;
    var pid = self.productData.PRODUCT_ID;
    for (var i=0; i<self.productData.skus.length; i++) {
      var s = self.productData.skus[i];
      self.skus[s.SKU_BASE_ID] = s;
      //CX-3730 Deep Link Implementation
      if (!_.isUndefined(s.SHADENAME) && !_.isNull(s.SHADENAME) && Drupal.settings.globals_variables.enable_deep_link) {
        var shadeNameNoSpaces = self.fixedEncodeURIComponent(s.SHADENAME);
        self.skuShades[s.SKU_BASE_ID] = shadeNameNoSpaces;
      }
      //self.skus.push(s);
    }

    //check for swatches
    self.swatches = $("a.swatch[data-product-id=" + pid + "]");
    if(self.swatches.length > 0){
      self.wireSwatches(self.swatches);
    }
    //check for selects
    self.shadeSelects = $("select.js-sku-menu[data-product-id=" + pid + "]");
    if(self.shadeSelects.length > 0){
      self.wireShadeSelects(self.shadeSelects);
    }
  }
};


site.SmooshSlider = function(args) {
  var that = {
    $list : $(args.containerNode)
  };
  var productData = args.productData;
  //smoosh list
  setTimeout(function(){
    that.$list.slick({
      lazyLoad: 'progressive',
      centerPadding: '50%',
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      onAfterChange: function(slider){
        var $currentSlide = $(slider.$slides).eq(slider.currentSlide);
        var skuBaseId = $currentSlide.attr('data-sku-base-id');
        var skuData = _.find(productData.skus, function(p){ return p.SKU_BASE_ID == skuBaseId; });
        site.skuSelect(skuData);
        //CX-3730 Deep Link Implementation
        site.ShadePicker.prototype.selectShade(skuBaseId);
      }
    });
    $(document).trigger('smoosh_slick_init_ready');
  },200); //give the first image some time to load

  that.$list.on('afterChange', function(event, slick, currentSlide, nextSlide) {
    var skuBaseId = $(slick.$slides).eq(currentSlide).attr('data-sku-base-id');
    $('a.js-swatch[data-sku-base-id=' + skuBaseId + ']', '.js-shade-picker').trigger('click');
  });

  //hook into shade picker
  that.$list.on('sku:select', function(e, skuData) {
    var skuId = skuData.SKU_BASE_ID;
    var $smooshes= $('.smoosh-list-item', that.$list);
    var smooshIndex = $smooshes.filter("[data-sku-base-id=" + skuId + "]").index();
    var currentSlide = that.$list.slick('slickCurrentSlide');
    if(smooshIndex != currentSlide) {
      that.$list.slick('slickGoTo', smooshIndex);
    }
    e.stopPropagation();
  });

  return that;

};


window.site = window.site || {};

site.template = (function($) {
  site.templates = site.templates || {};
  site.translations = site.translations || {};

  var defaults = {
    globals: {
      t: site.translations,
      variables: {
        // IE doesn't support location.origin, so...
        site_url: window.location.protocol + '//' + window.location.hostname
      }
    }
  };

  // include config settings from brand common module
  if (typeof Drupal !== 'undefined' && typeof Drupal.settings !== 'undefined' && typeof Drupal.settings.common !== 'undefined') {
    $.extend(defaults.globals.variables, Drupal.settings.common);
  }

  var public = {
    get: function(args) {
      var template = site.templates[args.name];

      // If that didn't work, search for a versioned match of the same template
      // (eg. template_v2)
      if (!template && args.name) {
        for (var key in site.templates) {
          if (site.templates.hasOwnProperty(key)) {
            var matcher = new RegExp(args.name + "_v(\\d+)$");
            if (matcher.test(key)) {
              template = site.templates[key];
              break;
            }
          }
        }
      }

      if (typeof template === 'undefined') {
        throw new Error('The template ' + args.name + ' cannot be found');
      }

      var rendered = this.render(template, args.data);

      if ($.isFunction(args.callback)) {
        var so = args.callback(rendered);
        if (typeof so !== 'undefined') {
          return so;
        }
      }

      return rendered;
    },

    render: function(template, data) {
      defaults.globals.t = site.translations;
      data = data || {};

      // You can pass just the template as a string if you want:
      if ($.type(template) === 'string') {
        template = {
          content: template,
          data: {}
        };
      }

      var view = $.extend({}, defaults, template.data, data);
      var partials = {};

      if (typeof template.partials !== 'undefined') {
        $.each(template.partials, function(key, name) {
          if (typeof site.templates[key] === 'undefined' && typeof site.templates[name] === 'undefined') {
            throw new Error('The partial ' + key + ' or ' + name + ' cannot be found');
          }

          var pkey = (typeof site.templates[key] !== 'undefined') ? key : name;
          partials[pkey] = site.templates[pkey].content;
        });
      }

      return Mustache.render(template.content, view, partials);
    }
  };

  return public;
})(
  window.jQuery = window.jQuery || function(){}
);

//     Underscore.js 1.5.2
//     http://underscorejs.org
//     (c) 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.
(function(){var n=this,t=n._,r={},e=Array.prototype,u=Object.prototype,i=Function.prototype,a=e.push,o=e.slice,c=e.concat,l=u.toString,f=u.hasOwnProperty,s=e.forEach,p=e.map,h=e.reduce,v=e.reduceRight,g=e.filter,d=e.every,m=e.some,y=e.indexOf,b=e.lastIndexOf,x=Array.isArray,w=Object.keys,_=i.bind,j=function(n){return n instanceof j?n:this instanceof j?(this._wrapped=n,void 0):new j(n)};"undefined"!=typeof exports?("undefined"!=typeof module&&module.exports&&(exports=module.exports=j),exports._=j):n._=j,j.VERSION="1.5.2";var A=j.each=j.forEach=function(n,t,e){if(null!=n)if(s&&n.forEach===s)n.forEach(t,e);else if(n.length===+n.length){for(var u=0,i=n.length;i>u;u++)if(t.call(e,n[u],u,n)===r)return}else for(var a=j.keys(n),u=0,i=a.length;i>u;u++)if(t.call(e,n[a[u]],a[u],n)===r)return};j.map=j.collect=function(n,t,r){var e=[];return null==n?e:p&&n.map===p?n.map(t,r):(A(n,function(n,u,i){e.push(t.call(r,n,u,i))}),e)};var E="Reduce of empty array with no initial value";j.reduce=j.foldl=j.inject=function(n,t,r,e){var u=arguments.length>2;if(null==n&&(n=[]),h&&n.reduce===h)return e&&(t=j.bind(t,e)),u?n.reduce(t,r):n.reduce(t);if(A(n,function(n,i,a){u?r=t.call(e,r,n,i,a):(r=n,u=!0)}),!u)throw new TypeError(E);return r},j.reduceRight=j.foldr=function(n,t,r,e){var u=arguments.length>2;if(null==n&&(n=[]),v&&n.reduceRight===v)return e&&(t=j.bind(t,e)),u?n.reduceRight(t,r):n.reduceRight(t);var i=n.length;if(i!==+i){var a=j.keys(n);i=a.length}if(A(n,function(o,c,l){c=a?a[--i]:--i,u?r=t.call(e,r,n[c],c,l):(r=n[c],u=!0)}),!u)throw new TypeError(E);return r},j.find=j.detect=function(n,t,r){var e;return O(n,function(n,u,i){return t.call(r,n,u,i)?(e=n,!0):void 0}),e},j.filter=j.select=function(n,t,r){var e=[];return null==n?e:g&&n.filter===g?n.filter(t,r):(A(n,function(n,u,i){t.call(r,n,u,i)&&e.push(n)}),e)},j.reject=function(n,t,r){return j.filter(n,function(n,e,u){return!t.call(r,n,e,u)},r)},j.every=j.all=function(n,t,e){t||(t=j.identity);var u=!0;return null==n?u:d&&n.every===d?n.every(t,e):(A(n,function(n,i,a){return(u=u&&t.call(e,n,i,a))?void 0:r}),!!u)};var O=j.some=j.any=function(n,t,e){t||(t=j.identity);var u=!1;return null==n?u:m&&n.some===m?n.some(t,e):(A(n,function(n,i,a){return u||(u=t.call(e,n,i,a))?r:void 0}),!!u)};j.contains=j.include=function(n,t){return null==n?!1:y&&n.indexOf===y?n.indexOf(t)!=-1:O(n,function(n){return n===t})},j.invoke=function(n,t){var r=o.call(arguments,2),e=j.isFunction(t);return j.map(n,function(n){return(e?t:n[t]).apply(n,r)})},j.pluck=function(n,t){return j.map(n,function(n){return n[t]})},j.where=function(n,t,r){return j.isEmpty(t)?r?void 0:[]:j[r?"find":"filter"](n,function(n){for(var r in t)if(t[r]!==n[r])return!1;return!0})},j.findWhere=function(n,t){return j.where(n,t,!0)},j.max=function(n,t,r){if(!t&&j.isArray(n)&&n[0]===+n[0]&&n.length<65535)return Math.max.apply(Math,n);if(!t&&j.isEmpty(n))return-1/0;var e={computed:-1/0,value:-1/0};return A(n,function(n,u,i){var a=t?t.call(r,n,u,i):n;a>e.computed&&(e={value:n,computed:a})}),e.value},j.min=function(n,t,r){if(!t&&j.isArray(n)&&n[0]===+n[0]&&n.length<65535)return Math.min.apply(Math,n);if(!t&&j.isEmpty(n))return 1/0;var e={computed:1/0,value:1/0};return A(n,function(n,u,i){var a=t?t.call(r,n,u,i):n;a<e.computed&&(e={value:n,computed:a})}),e.value},j.shuffle=function(n){var t,r=0,e=[];return A(n,function(n){t=j.random(r++),e[r-1]=e[t],e[t]=n}),e},j.sample=function(n,t,r){return arguments.length<2||r?n[j.random(n.length-1)]:j.shuffle(n).slice(0,Math.max(0,t))};var k=function(n){return j.isFunction(n)?n:function(t){return t[n]}};j.sortBy=function(n,t,r){var e=k(t);return j.pluck(j.map(n,function(n,t,u){return{value:n,index:t,criteria:e.call(r,n,t,u)}}).sort(function(n,t){var r=n.criteria,e=t.criteria;if(r!==e){if(r>e||r===void 0)return 1;if(e>r||e===void 0)return-1}return n.index-t.index}),"value")};var F=function(n){return function(t,r,e){var u={},i=null==r?j.identity:k(r);return A(t,function(r,a){var o=i.call(e,r,a,t);n(u,o,r)}),u}};j.groupBy=F(function(n,t,r){(j.has(n,t)?n[t]:n[t]=[]).push(r)}),j.indexBy=F(function(n,t,r){n[t]=r}),j.countBy=F(function(n,t){j.has(n,t)?n[t]++:n[t]=1}),j.sortedIndex=function(n,t,r,e){r=null==r?j.identity:k(r);for(var u=r.call(e,t),i=0,a=n.length;a>i;){var o=i+a>>>1;r.call(e,n[o])<u?i=o+1:a=o}return i},j.toArray=function(n){return n?j.isArray(n)?o.call(n):n.length===+n.length?j.map(n,j.identity):j.values(n):[]},j.size=function(n){return null==n?0:n.length===+n.length?n.length:j.keys(n).length},j.first=j.head=j.take=function(n,t,r){return null==n?void 0:null==t||r?n[0]:o.call(n,0,t)},j.initial=function(n,t,r){return o.call(n,0,n.length-(null==t||r?1:t))},j.last=function(n,t,r){return null==n?void 0:null==t||r?n[n.length-1]:o.call(n,Math.max(n.length-t,0))},j.rest=j.tail=j.drop=function(n,t,r){return o.call(n,null==t||r?1:t)},j.compact=function(n){return j.filter(n,j.identity)};var M=function(n,t,r){return t&&j.every(n,j.isArray)?c.apply(r,n):(A(n,function(n){j.isArray(n)||j.isArguments(n)?t?a.apply(r,n):M(n,t,r):r.push(n)}),r)};j.flatten=function(n,t){return M(n,t,[])},j.without=function(n){return j.difference(n,o.call(arguments,1))},j.uniq=j.unique=function(n,t,r,e){j.isFunction(t)&&(e=r,r=t,t=!1);var u=r?j.map(n,r,e):n,i=[],a=[];return A(u,function(r,e){(t?e&&a[a.length-1]===r:j.contains(a,r))||(a.push(r),i.push(n[e]))}),i},j.union=function(){return j.uniq(j.flatten(arguments,!0))},j.intersection=function(n){var t=o.call(arguments,1);return j.filter(j.uniq(n),function(n){return j.every(t,function(t){return j.indexOf(t,n)>=0})})},j.difference=function(n){var t=c.apply(e,o.call(arguments,1));return j.filter(n,function(n){return!j.contains(t,n)})},j.zip=function(){for(var n=j.max(j.pluck(arguments,"length").concat(0)),t=new Array(n),r=0;n>r;r++)t[r]=j.pluck(arguments,""+r);return t},j.object=function(n,t){if(null==n)return{};for(var r={},e=0,u=n.length;u>e;e++)t?r[n[e]]=t[e]:r[n[e][0]]=n[e][1];return r},j.indexOf=function(n,t,r){if(null==n)return-1;var e=0,u=n.length;if(r){if("number"!=typeof r)return e=j.sortedIndex(n,t),n[e]===t?e:-1;e=0>r?Math.max(0,u+r):r}if(y&&n.indexOf===y)return n.indexOf(t,r);for(;u>e;e++)if(n[e]===t)return e;return-1},j.lastIndexOf=function(n,t,r){if(null==n)return-1;var e=null!=r;if(b&&n.lastIndexOf===b)return e?n.lastIndexOf(t,r):n.lastIndexOf(t);for(var u=e?r:n.length;u--;)if(n[u]===t)return u;return-1},j.range=function(n,t,r){arguments.length<=1&&(t=n||0,n=0),r=arguments[2]||1;for(var e=Math.max(Math.ceil((t-n)/r),0),u=0,i=new Array(e);e>u;)i[u++]=n,n+=r;return i};var R=function(){};j.bind=function(n,t){var r,e;if(_&&n.bind===_)return _.apply(n,o.call(arguments,1));if(!j.isFunction(n))throw new TypeError;return r=o.call(arguments,2),e=function(){if(!(this instanceof e))return n.apply(t,r.concat(o.call(arguments)));R.prototype=n.prototype;var u=new R;R.prototype=null;var i=n.apply(u,r.concat(o.call(arguments)));return Object(i)===i?i:u}},j.partial=function(n){var t=o.call(arguments,1);return function(){return n.apply(this,t.concat(o.call(arguments)))}},j.bindAll=function(n){var t=o.call(arguments,1);if(0===t.length)throw new Error("bindAll must be passed function names");return A(t,function(t){n[t]=j.bind(n[t],n)}),n},j.memoize=function(n,t){var r={};return t||(t=j.identity),function(){var e=t.apply(this,arguments);return j.has(r,e)?r[e]:r[e]=n.apply(this,arguments)}},j.delay=function(n,t){var r=o.call(arguments,2);return setTimeout(function(){return n.apply(null,r)},t)},j.defer=function(n){return j.delay.apply(j,[n,1].concat(o.call(arguments,1)))},j.throttle=function(n,t,r){var e,u,i,a=null,o=0;r||(r={});var c=function(){o=r.leading===!1?0:new Date,a=null,i=n.apply(e,u)};return function(){var l=new Date;o||r.leading!==!1||(o=l);var f=t-(l-o);return e=this,u=arguments,0>=f?(clearTimeout(a),a=null,o=l,i=n.apply(e,u)):a||r.trailing===!1||(a=setTimeout(c,f)),i}},j.debounce=function(n,t,r){var e,u,i,a,o;return function(){i=this,u=arguments,a=new Date;var c=function(){var l=new Date-a;t>l?e=setTimeout(c,t-l):(e=null,r||(o=n.apply(i,u)))},l=r&&!e;return e||(e=setTimeout(c,t)),l&&(o=n.apply(i,u)),o}},j.once=function(n){var t,r=!1;return function(){return r?t:(r=!0,t=n.apply(this,arguments),n=null,t)}},j.wrap=function(n,t){return function(){var r=[n];return a.apply(r,arguments),t.apply(this,r)}},j.compose=function(){var n=arguments;return function(){for(var t=arguments,r=n.length-1;r>=0;r--)t=[n[r].apply(this,t)];return t[0]}},j.after=function(n,t){return function(){return--n<1?t.apply(this,arguments):void 0}},j.keys=w||function(n){if(n!==Object(n))throw new TypeError("Invalid object");var t=[];for(var r in n)j.has(n,r)&&t.push(r);return t},j.values=function(n){for(var t=j.keys(n),r=t.length,e=new Array(r),u=0;r>u;u++)e[u]=n[t[u]];return e},j.pairs=function(n){for(var t=j.keys(n),r=t.length,e=new Array(r),u=0;r>u;u++)e[u]=[t[u],n[t[u]]];return e},j.invert=function(n){for(var t={},r=j.keys(n),e=0,u=r.length;u>e;e++)t[n[r[e]]]=r[e];return t},j.functions=j.methods=function(n){var t=[];for(var r in n)j.isFunction(n[r])&&t.push(r);return t.sort()},j.extend=function(n){return A(o.call(arguments,1),function(t){if(t)for(var r in t)n[r]=t[r]}),n},j.pick=function(n){var t={},r=c.apply(e,o.call(arguments,1));return A(r,function(r){r in n&&(t[r]=n[r])}),t},j.omit=function(n){var t={},r=c.apply(e,o.call(arguments,1));for(var u in n)j.contains(r,u)||(t[u]=n[u]);return t},j.defaults=function(n){return A(o.call(arguments,1),function(t){if(t)for(var r in t)n[r]===void 0&&(n[r]=t[r])}),n},j.clone=function(n){return j.isObject(n)?j.isArray(n)?n.slice():j.extend({},n):n},j.tap=function(n,t){return t(n),n};var S=function(n,t,r,e){if(n===t)return 0!==n||1/n==1/t;if(null==n||null==t)return n===t;n instanceof j&&(n=n._wrapped),t instanceof j&&(t=t._wrapped);var u=l.call(n);if(u!=l.call(t))return!1;switch(u){case"[object String]":return n==String(t);case"[object Number]":return n!=+n?t!=+t:0==n?1/n==1/t:n==+t;case"[object Date]":case"[object Boolean]":return+n==+t;case"[object RegExp]":return n.source==t.source&&n.global==t.global&&n.multiline==t.multiline&&n.ignoreCase==t.ignoreCase}if("object"!=typeof n||"object"!=typeof t)return!1;for(var i=r.length;i--;)if(r[i]==n)return e[i]==t;var a=n.constructor,o=t.constructor;if(a!==o&&!(j.isFunction(a)&&a instanceof a&&j.isFunction(o)&&o instanceof o))return!1;r.push(n),e.push(t);var c=0,f=!0;if("[object Array]"==u){if(c=n.length,f=c==t.length)for(;c--&&(f=S(n[c],t[c],r,e)););}else{for(var s in n)if(j.has(n,s)&&(c++,!(f=j.has(t,s)&&S(n[s],t[s],r,e))))break;if(f){for(s in t)if(j.has(t,s)&&!c--)break;f=!c}}return r.pop(),e.pop(),f};j.isEqual=function(n,t){return S(n,t,[],[])},j.isEmpty=function(n){if(null==n)return!0;if(j.isArray(n)||j.isString(n))return 0===n.length;for(var t in n)if(j.has(n,t))return!1;return!0},j.isElement=function(n){return!(!n||1!==n.nodeType)},j.isArray=x||function(n){return"[object Array]"==l.call(n)},j.isObject=function(n){return n===Object(n)},A(["Arguments","Function","String","Number","Date","RegExp"],function(n){j["is"+n]=function(t){return l.call(t)=="[object "+n+"]"}}),j.isArguments(arguments)||(j.isArguments=function(n){return!(!n||!j.has(n,"callee"))}),"function"!=typeof/./&&(j.isFunction=function(n){return"function"==typeof n}),j.isFinite=function(n){return isFinite(n)&&!isNaN(parseFloat(n))},j.isNaN=function(n){return j.isNumber(n)&&n!=+n},j.isBoolean=function(n){return n===!0||n===!1||"[object Boolean]"==l.call(n)},j.isNull=function(n){return null===n},j.isUndefined=function(n){return n===void 0},j.has=function(n,t){return f.call(n,t)},j.noConflict=function(){return n._=t,this},j.identity=function(n){return n},j.times=function(n,t,r){for(var e=Array(Math.max(0,n)),u=0;n>u;u++)e[u]=t.call(r,u);return e},j.random=function(n,t){return null==t&&(t=n,n=0),n+Math.floor(Math.random()*(t-n+1))};var I={escape:{"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;"}};I.unescape=j.invert(I.escape);var T={escape:new RegExp("["+j.keys(I.escape).join("")+"]","g"),unescape:new RegExp("("+j.keys(I.unescape).join("|")+")","g")};j.each(["escape","unescape"],function(n){j[n]=function(t){return null==t?"":(""+t).replace(T[n],function(t){return I[n][t]})}}),j.result=function(n,t){if(null==n)return void 0;var r=n[t];return j.isFunction(r)?r.call(n):r},j.mixin=function(n){A(j.functions(n),function(t){var r=j[t]=n[t];j.prototype[t]=function(){var n=[this._wrapped];return a.apply(n,arguments),z.call(this,r.apply(j,n))}})};var N=0;j.uniqueId=function(n){var t=++N+"";return n?n+t:t},j.templateSettings={evaluate:/<%([\s\S]+?)%>/g,interpolate:/<%=([\s\S]+?)%>/g,escape:/<%-([\s\S]+?)%>/g};var q=/(.)^/,B={"'":"'","\\":"\\","\r":"r","\n":"n","	":"t","\u2028":"u2028","\u2029":"u2029"},D=/\\|'|\r|\n|\t|\u2028|\u2029/g;j.template=function(n,t,r){var e;r=j.defaults({},r,j.templateSettings);var u=new RegExp([(r.escape||q).source,(r.interpolate||q).source,(r.evaluate||q).source].join("|")+"|$","g"),i=0,a="__p+='";n.replace(u,function(t,r,e,u,o){return a+=n.slice(i,o).replace(D,function(n){return"\\"+B[n]}),r&&(a+="'+\n((__t=("+r+"))==null?'':_.escape(__t))+\n'"),e&&(a+="'+\n((__t=("+e+"))==null?'':__t)+\n'"),u&&(a+="';\n"+u+"\n__p+='"),i=o+t.length,t}),a+="';\n",r.variable||(a="with(obj||{}){\n"+a+"}\n"),a="var __t,__p='',__j=Array.prototype.join,"+"print=function(){__p+=__j.call(arguments,'');};\n"+a+"return __p;\n";try{e=new Function(r.variable||"obj","_",a)}catch(o){throw o.source=a,o}if(t)return e(t,j);var c=function(n){return e.call(this,n,j)};return c.source="function("+(r.variable||"obj")+"){\n"+a+"}",c},j.chain=function(n){return j(n).chain()};var z=function(n){return this._chain?j(n).chain():n};j.mixin(j),A(["pop","push","reverse","shift","sort","splice","unshift"],function(n){var t=e[n];j.prototype[n]=function(){var r=this._wrapped;return t.apply(r,arguments),"shift"!=n&&"splice"!=n||0!==r.length||delete r[0],z.call(this,r)}}),A(["concat","join","slice"],function(n){var t=e[n];j.prototype[n]=function(){return z.call(this,t.apply(this._wrapped,arguments))}}),j.extend(j.prototype,{chain:function(){return this._chain=!0,this},value:function(){return this._wrapped}})}).call(this);
//# sourceMappingURL=underscore-min.map
// Generated by CoffeeScript 1.6.2
/*
jQuery Waypoints - v2.0.4
Copyright (c) 2011-2014 Caleb Troughton
Dual licensed under the MIT license and GPL license.
https://github.com/imakewebthings/jquery-waypoints/blob/master/licenses.txt
*/
(function(){var t=[].indexOf||function(t){for(var e=0,n=this.length;e<n;e++){if(e in this&&this[e]===t)return e}return-1},e=[].slice;(function(t,e){if(typeof define==="function"&&define.amd){return define("waypoints",["jquery"],function(n){return e(n,t)})}else{return e(t.jQuery,t)}})(this,function(n,r){var i,o,l,s,f,u,c,a,h,d,p,y,v,w,g,m;i=n(r);a=t.call(r,"ontouchstart")>=0;s={horizontal:{},vertical:{}};f=1;c={};u="waypoints-context-id";p="resize.waypoints";y="scroll.waypoints";v=1;w="waypoints-waypoint-ids";g="waypoint";m="waypoints";o=function(){function t(t){var e=this;this.$element=t;this.element=t[0];this.didResize=false;this.didScroll=false;this.id="context"+f++;this.oldScroll={x:t.scrollLeft(),y:t.scrollTop()};this.waypoints={horizontal:{},vertical:{}};this.element[u]=this.id;c[this.id]=this;t.bind(y,function(){var t;if(!(e.didScroll||a)){e.didScroll=true;t=function(){e.doScroll();return e.didScroll=false};return r.setTimeout(t,n[m].settings.scrollThrottle)}});t.bind(p,function(){var t;if(!e.didResize){e.didResize=true;t=function(){n[m]("refresh");return e.didResize=false};return r.setTimeout(t,n[m].settings.resizeThrottle)}})}t.prototype.doScroll=function(){var t,e=this;t={horizontal:{newScroll:this.$element.scrollLeft(),oldScroll:this.oldScroll.x,forward:"right",backward:"left"},vertical:{newScroll:this.$element.scrollTop(),oldScroll:this.oldScroll.y,forward:"down",backward:"up"}};if(a&&(!t.vertical.oldScroll||!t.vertical.newScroll)){n[m]("refresh")}n.each(t,function(t,r){var i,o,l;l=[];o=r.newScroll>r.oldScroll;i=o?r.forward:r.backward;n.each(e.waypoints[t],function(t,e){var n,i;if(r.oldScroll<(n=e.offset)&&n<=r.newScroll){return l.push(e)}else if(r.newScroll<(i=e.offset)&&i<=r.oldScroll){return l.push(e)}});l.sort(function(t,e){return t.offset-e.offset});if(!o){l.reverse()}return n.each(l,function(t,e){if(e.options.continuous||t===l.length-1){return e.trigger([i])}})});return this.oldScroll={x:t.horizontal.newScroll,y:t.vertical.newScroll}};t.prototype.refresh=function(){var t,e,r,i=this;r=n.isWindow(this.element);e=this.$element.offset();this.doScroll();t={horizontal:{contextOffset:r?0:e.left,contextScroll:r?0:this.oldScroll.x,contextDimension:this.$element.width(),oldScroll:this.oldScroll.x,forward:"right",backward:"left",offsetProp:"left"},vertical:{contextOffset:r?0:e.top,contextScroll:r?0:this.oldScroll.y,contextDimension:r?n[m]("viewportHeight"):this.$element.height(),oldScroll:this.oldScroll.y,forward:"down",backward:"up",offsetProp:"top"}};return n.each(t,function(t,e){return n.each(i.waypoints[t],function(t,r){var i,o,l,s,f;i=r.options.offset;l=r.offset;o=n.isWindow(r.element)?0:r.$element.offset()[e.offsetProp];if(n.isFunction(i)){i=i.apply(r.element)}else if(typeof i==="string"){i=parseFloat(i);if(r.options.offset.indexOf("%")>-1){i=Math.ceil(e.contextDimension*i/100)}}r.offset=o-e.contextOffset+e.contextScroll-i;if(r.options.onlyOnScroll&&l!=null||!r.enabled){return}if(l!==null&&l<(s=e.oldScroll)&&s<=r.offset){return r.trigger([e.backward])}else if(l!==null&&l>(f=e.oldScroll)&&f>=r.offset){return r.trigger([e.forward])}else if(l===null&&e.oldScroll>=r.offset){return r.trigger([e.forward])}})})};t.prototype.checkEmpty=function(){if(n.isEmptyObject(this.waypoints.horizontal)&&n.isEmptyObject(this.waypoints.vertical)){this.$element.unbind([p,y].join(" "));return delete c[this.id]}};return t}();l=function(){function t(t,e,r){var i,o;r=n.extend({},n.fn[g].defaults,r);if(r.offset==="bottom-in-view"){r.offset=function(){var t;t=n[m]("viewportHeight");if(!n.isWindow(e.element)){t=e.$element.height()}return t-n(this).outerHeight()}}this.$element=t;this.element=t[0];this.axis=r.horizontal?"horizontal":"vertical";this.callback=r.handler;this.context=e;this.enabled=r.enabled;this.id="waypoints"+v++;this.offset=null;this.options=r;e.waypoints[this.axis][this.id]=this;s[this.axis][this.id]=this;i=(o=this.element[w])!=null?o:[];i.push(this.id);this.element[w]=i}t.prototype.trigger=function(t){if(!this.enabled){return}if(this.callback!=null){this.callback.apply(this.element,t)}if(this.options.triggerOnce){return this.destroy()}};t.prototype.disable=function(){return this.enabled=false};t.prototype.enable=function(){this.context.refresh();return this.enabled=true};t.prototype.destroy=function(){delete s[this.axis][this.id];delete this.context.waypoints[this.axis][this.id];return this.context.checkEmpty()};t.getWaypointsByElement=function(t){var e,r;r=t[w];if(!r){return[]}e=n.extend({},s.horizontal,s.vertical);return n.map(r,function(t){return e[t]})};return t}();d={init:function(t,e){var r;if(e==null){e={}}if((r=e.handler)==null){e.handler=t}this.each(function(){var t,r,i,s;t=n(this);i=(s=e.context)!=null?s:n.fn[g].defaults.context;if(!n.isWindow(i)){i=t.closest(i)}i=n(i);r=c[i[0][u]];if(!r){r=new o(i)}return new l(t,r,e)});n[m]("refresh");return this},disable:function(){return d._invoke.call(this,"disable")},enable:function(){return d._invoke.call(this,"enable")},destroy:function(){return d._invoke.call(this,"destroy")},prev:function(t,e){return d._traverse.call(this,t,e,function(t,e,n){if(e>0){return t.push(n[e-1])}})},next:function(t,e){return d._traverse.call(this,t,e,function(t,e,n){if(e<n.length-1){return t.push(n[e+1])}})},_traverse:function(t,e,i){var o,l;if(t==null){t="vertical"}if(e==null){e=r}l=h.aggregate(e);o=[];this.each(function(){var e;e=n.inArray(this,l[t]);return i(o,e,l[t])});return this.pushStack(o)},_invoke:function(t){this.each(function(){var e;e=l.getWaypointsByElement(this);return n.each(e,function(e,n){n[t]();return true})});return this}};n.fn[g]=function(){var t,r;r=arguments[0],t=2<=arguments.length?e.call(arguments,1):[];if(d[r]){return d[r].apply(this,t)}else if(n.isFunction(r)){return d.init.apply(this,arguments)}else if(n.isPlainObject(r)){return d.init.apply(this,[null,r])}else if(!r){return n.error("jQuery Waypoints needs a callback function or handler option.")}else{return n.error("The "+r+" method does not exist in jQuery Waypoints.")}};n.fn[g].defaults={context:r,continuous:true,enabled:true,horizontal:false,offset:0,triggerOnce:false};h={refresh:function(){return n.each(c,function(t,e){return e.refresh()})},viewportHeight:function(){var t;return(t=r.innerHeight)!=null?t:i.height()},aggregate:function(t){var e,r,i;e=s;if(t){e=(i=c[n(t)[0][u]])!=null?i.waypoints:void 0}if(!e){return[]}r={horizontal:[],vertical:[]};n.each(r,function(t,i){n.each(e[t],function(t,e){return i.push(e)});i.sort(function(t,e){return t.offset-e.offset});r[t]=n.map(i,function(t){return t.element});return r[t]=n.unique(r[t])});return r},above:function(t){if(t==null){t=r}return h._filter(t,"vertical",function(t,e){return e.offset<=t.oldScroll.y})},below:function(t){if(t==null){t=r}return h._filter(t,"vertical",function(t,e){return e.offset>t.oldScroll.y})},left:function(t){if(t==null){t=r}return h._filter(t,"horizontal",function(t,e){return e.offset<=t.oldScroll.x})},right:function(t){if(t==null){t=r}return h._filter(t,"horizontal",function(t,e){return e.offset>t.oldScroll.x})},enable:function(){return h._invoke("enable")},disable:function(){return h._invoke("disable")},destroy:function(){return h._invoke("destroy")},extendFn:function(t,e){return d[t]=e},_invoke:function(t){var e;e=n.extend({},s.vertical,s.horizontal);return n.each(e,function(e,n){n[t]();return true})},_filter:function(t,e,r){var i,o;i=c[n(t)[0][u]];if(!i){return[]}o=[];n.each(i.waypoints[e],function(t,e){if(r(i,e)){return o.push(e)}});o.sort(function(t,e){return t.offset-e.offset});return n.map(o,function(t){return t.element})}};n[m]=function(){var t,n;n=arguments[0],t=2<=arguments.length?e.call(arguments,1):[];if(h[n]){return h[n].apply(null,t)}else{return h.aggregate.call(null,n)}};n[m].settings={resizeThrottle:100,scrollThrottle:30};return i.load(function(){return n[m]("refresh")})})}).call(this);